(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._root_vjca1_2{box-sizing:border-box;background:var(--dixa-color-neutral-000);flex-direction:column;flex-grow:1;height:100%;display:flex}._slotLeft_vjca1_11,._slotCenter_vjca1_12,._slotRight_vjca1_13{align-items:center;gap:8px;display:flex}._slotLeft_vjca1_11{grid-area:slotLeft;justify-content:flex-start}._slotCenter_vjca1_12{text-align:center;grid-area:slotCenter;justify-content:center}._slotRight_vjca1_13{grid-area:slotRight;justify-content:flex-end}._head_vjca1_35{background-color:var(--dixa-color-neutral-000);gap:var(--dixa-size-spacer-300);min-height:64px;padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400);box-sizing:border-box;border-bottom:1px solid var(--dixa-color-neutral-200);grid-template:"slotLeft slotRight"/auto 1fr;display:grid}#pageHead{z-index:1;position:relative;container-type:inline-size}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft slotCenter slotRight"/1fr auto 1fr}@container (width<=500px){._head_vjca1_35{padding:var(--dixa-size-spacer-300)}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft slotRight""slotCenter slotCenter"/1fr 1fr}}@container (width<=300px){._head_vjca1_35{grid-template:"slotRight""slotLeft"/1fr}._head_vjca1_35:has(._slotCenter_vjca1_12){grid-template:"slotLeft""slotRight""slotCenter"/1fr}}._controls_vjca1_83{gap:var(--dixa-size-spacer-200);flex-wrap:wrap;justify-content:flex-end;display:inline-flex}._link_vjca1_90{justify-content:start;align-items:center;column-gap:var(--dixa-size-spacer-100);height:100%;color:var(--dixa-typography-color-link);font-size:var(--dixa-typography-size-300);text-decoration:none;display:flex}._link_vjca1_90:hover,._link_vjca1_90:focus{color:var(--dixa-color-blue-700)}._link_vjca1_90:active{color:var(--dixa-color-blue-900)}._linkArrow_vjca1_106{height:var(--dixa-typography-size-300);width:var(--dixa-typography-size-300);display:block}._body_vjca1_112{flex:1;position:relative;overflow-y:auto}._hablaPageBody_vjca1_122._hablaPageBody_vjca1_122{flex-direction:row}._modalBody_1eukg_1{width:600px}._message_8a2au_1{margin-bottom:var(--dixa-size-spacer-400)}._editor_friuv_1,._editor_friuv_1 .monaco-editor,._editor_friuv_1 .overflow-guard,._wrapper_11awi_1{border-radius:var(--dixa-size-border-radius-100)}._wrapperDark_11awi_5{background-color:var(--dixa-color-neutral-100);padding-left:calc(var(--dixa-size-spacer-300) * 1.25);padding-right:calc(var(--dixa-size-spacer-300) * 1.25)}._marginBottom_11awi_11{margin-bottom:var(--dixa-size-spacer-100)}._noFieldLabel_m67db_1>[data-testid=fieldLabel]{display:none}._tableWrapper_1vb1f_1{height:100%;overflow-y:auto}._table_1vb1f_1{border-collapse:collapse}._tableRow_1vb1f_10._isSyncedWithElevio_1vb1f_10 td{background-color:var(--dixa-color-neutral-000)}._tableRow_1vb1f_10 th:first-of-type,._tableRow_1vb1f_10 td:first-of-type{padding-left:var(--dixa-size-spacer-400);padding-top:var(--dixa-size-spacer-250);padding-bottom:var(--dixa-size-spacer-250)}._th_1vb1f_21,._td_1vb1f_22{padding:var(--dixa-size-spacer-300)}._th_1vb1f_21{background-color:var(--dixa-color-neutral-100);text-align:start}._th_1vb1f_21 .checkbox--checkbox__input{width:var(--dixa-size-spacer-300);height:var(--dixa-size-spacer-300);top:0;left:0}._td_1vb1f_22 a{text-decoration:none}._actionColumn_1vb1f_42{width:1%}._externalLink_1vb1f_46{align-items:center;gap:var(--dixa-size-spacer-200);display:flex}._internalLink_1vb1f_52{font-weight:var(--dixa-typography-weight-semibold);color:var(--dixa-typography-color-link);text-decoration:none}._wrapper_1j5v5_1{padding:var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100)}._header_1j5v5_7{cursor:pointer;padding:var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);justify-content:space-between;align-items:center}._body_1j5v5_15{border-radius:var(--dixa-size-border-radius-100);background:var(--dixa-color-neutral-000);padding:var(--dixa-size-spacer-300)}._bodyOpen_1j5v5_21{margin-top:var(--dixa-size-spacer-200)}code,pre{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100)}code{padding:0 var(--dixa-size-spacer-100)}pre{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-100) var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300)}._code_1w4at_18 li{padding-bottom:var(--dixa-size-spacer-200)}._fieldSet_2u3fk_1{border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-400);padding-top:var(--dixa-size-spacer-400);padding-bottom:var(--dixa-size-spacer-200);margin-bottom:var(--dixa-size-spacer-300);box-sizing:border-box}._fieldSetLegend_2u3fk_11{padding:0 var(--dixa-size-spacer-200);margin-left:-var(--dixa-size-spacer-200)}._formField_1bcx8_1{margin-bottom:0}._fieldSet_1bcx8_5{padding:var(--dixa-size-spacer-400);margin-bottom:0}._pre_1bcx8_10{margin:0;margin-top:var(--dixa-size-spacer-100);text-overflow:ellipsis;flex-grow:1;flex-shrink:1}._copyIcon_1bcx8_18{display:block}._copied_1bcx8_22{color:var(--dixa-typography-color-success)}._alert_smz2d_1{margin-top:var(--dixa-size-spacer-100)}._uploadDropzoneWrapper_smz2d_5,._uploadImageWrapper_smz2d_6,._uploadDropzoneLoadingWrapper_smz2d_7{width:160px;height:80px}._uploadImageWrapper_smz2d_6{padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);box-sizing:border-box;min-width:160px}._uploadImage_smz2d_6{object-fit:contain;width:100%;height:100%;font-size:10px}._uploadDropzoneLoadingWrapper_smz2d_7{background-color:var(--dixa-color-neutral-100);border:1px dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);box-sizing:border-box;cursor:wait}._dropzone_1wf8u_1{background-color:var(--dixa-color-neutral-100);border:1px dashed var(--dixa-color-neutral-300);cursor:pointer;border-radius:3px}._dropzone_1wf8u_1._isFocused_1wf8u_7{background-color:var(--dixa-color-purple-100);border-color:var(--dixa-color-purple-500)}._dropzone_1wf8u_1._isDragAccept_1wf8u_11{background-color:var(--dixa-color-green-100);border-color:var(--dixa-color-green-500)}._dropzone_1wf8u_1._isDragReject_1wf8u_15{background-color:var(--dixa-color-red-100);border-color:var(--dixa-color-red-500)}._heading_1wf8u_20{margin-top:var(--dixa-size-spacer-100)}._uploadErrorText_1wf8u_24{margin-top:var(--dixa-size-spacer-300)}._table_tz287_1{border-collapse:collapse}._tabContentWrapper_1315b_1{container-type:inline-size}._tabContentContainer_1315b_5{overflow-y:auto}._tabContent_1315b_1{padding:var(--dixa-size-spacer-400);overflow-y:auto}._tabContent_1315b_1._inactive_1315b_14{display:none}._tabContent_1315b_1 form,._tabContent_1315b_1 ._preview_1315b_19{width:100%}._tabContent_1315b_1 form{box-sizing:border-box}._tabContent_1315b_1._customHostname_1315b_27 form{min-width:600px}@container (width>=800px){._tabContent_1315b_1{display:flex}._tabContent_1315b_1 form{width:50%;max-width:600px}._tabContent_1315b_1 ._preview_1315b_19{flex-grow:1;width:50%}}._tab_1315b_1{line-height:var(--dixa-typography-line-height-200);border-top:none}._tabsWrapper_1315b_49{padding:0 var(--dixa-size-spacer-400);border-bottom:1px solid var(--dixa-color-neutral-200)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import * as e from "@apollo/client";
import { ApolloClient as t, ApolloProvider as n, InMemoryCache as r, createHttpLink as i, from as a, gql as o } from "@apollo/client";
import { createPersistedQueryLink as s } from "@apollo/client/link/persisted-queries";
import { setContext as c } from "@apollo/client/link/context";
import { authManager as l } from "lib-shared-auth";
import { config as u } from "lib-shared-backend-config";
import { Badge as d, Banner as f, Box as p, Button as m, ButtonList as h, Collapsible as g, ColorPicker as _, DropdownButton as v, EmptyState as ee, FieldAlert as y, FieldColorPicker as b, FieldSelect as x, FieldWrapper as S, FlexBox as C, FormField as w, FormGrid as T, Icon as E, IconButton as te, InputSelectionList as ne, InputText as D, Modal as re, ModalBody as ie, ModalFoot as ae, ModalHead as O, Page as oe, SelectionList as se, Skeleton as k, Spinner as ce, Switch as le, Table as A, Tabs as ue, Tag as de, Text as j, Tooltip as fe } from "@dixa/lib-shared-habla";
import pe from "classnames";
import * as me from "react";
import he, { Fragment as ge, Suspense as _e, createContext as ve, forwardRef as ye, isValidElement as be, lazy as xe, memo as Se, useCallback as M, useContext as Ce, useEffect as N, useImperativeHandle as we, useMemo as Te, useReducer as Ee, useRef as P, useState as De } from "react";
import { Link as Oe, UNSAFE_DataRouterContext as ke, UNSAFE_NavigationContext as Ae, useLocation as je, useNavigate as Me, useParams as Ne, useRoutes as Pe } from "react-router-dom";
import { Fragment as F, jsx as I, jsxs as L } from "react/jsx-runtime";
import { Sentry as Fe, SentryTeam as Ie } from "lib-shared-sentry";
import { Controller as Le, appendErrors as Re, get as ze, set as Be, useForm as Ve } from "react-hook-form";
import { ampli as He } from "lib-shared-tracking";
//#region \0rolldown/runtime.js
var Ue = Object.create, We = Object.defineProperty, Ge = Object.getOwnPropertyDescriptor, Ke = Object.getOwnPropertyNames, qe = Object.getPrototypeOf, Je = Object.prototype.hasOwnProperty, R = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, z = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Ye = (e, t) => {
	let n = {};
	for (var r in e) We(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || We(n, Symbol.toStringTag, { value: "Module" }), n;
}, Xe = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ke(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Je.call(e, s) && s !== n && We(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Ge(t, s)) || r.enumerable
	});
	return e;
}, Ze = (e, t, n) => (n = e == null ? {} : Ue(qe(e)), Xe(t || !e || !e.__esModule ? We(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Qe = (e) => {
	let t = new DataView(e), n = "";
	for (let e = 0; e < t.byteLength; e += 4) n += t.getUint32(e).toString(16).padStart(8, "0");
	return n;
}, $e = ((e) => async (t, { outputFormat: n = "hex" } = {}) => {
	typeof t == "string" && (t = new globalThis.TextEncoder().encode(t));
	let r = await globalThis.crypto.subtle.digest(e, t);
	return n === "hex" ? Qe(r) : r;
})("SHA-256"), et = "authData";
async function tt() {
	await l.getAuthData();
	let e = localStorage.getItem(et);
	return e ? JSON.parse(e) : null;
}
async function nt() {
	return `Bearer ${(await tt())?.access_token}`;
}
//#endregion
//#region ../utils/src/apollo.ts
function rt() {
	return c(async (e, { headers: t }) => {
		let n = await nt();
		return { headers: {
			...t,
			authorization: n
		} };
	});
}
//#endregion
//#region ../management-common/src/apolloClient.ts
var it = "beta";
function at() {
	return i({ uri: `${u.url.knowledgeApi}/management/api/${it}/graphql` });
}
var ot = new r({ typePolicies: {
	Article: { fields: { tags: { merge(e, t) {
		return t;
	} } } },
	Collection: { merge: !0 },
	ArticleTranslation: { keyFields: [
		"articleId",
		"languageId",
		"version",
		["__typename"]
	] },
	ArticleList: { keyFields: ["query", ["results"]] },
	ArticleListItem: { fields: { titles: { merge(e, t) {
		return t;
	} } } },
	Query: { fields: {
		category: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Category",
				id: t.id
			});
		} },
		article: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "Article",
				id: t.id
			});
		} },
		aiDraft: { read(e, { args: t, toReference: n }) {
			if (t?.id) return n({
				__typename: "AiDraft",
				id: t.id
			});
		} },
		articles: { keyArgs: ["$filters", "$query"] },
		collections: {
			keyArgs: !1,
			merge(e, t, { args: n }) {
				return !e || !n?.offset ? t : {
					...t,
					results: [...e.results.slice(0, n.offset), ...t.results]
				};
			}
		}
	} }
} }), st;
function ct() {
	return st ||= new t({
		link: a([
			s({
				sha256: $e,
				useGETForHashedQueries: !1
			}),
			rt(),
			at()
		].filter(Boolean)),
		cache: ot,
		assumeImmutableResults: !0,
		defaultOptions: { query: { canonizeResults: !0 } },
		connectToDevTools: !0
	}), st;
}
//#endregion
//#region ../utils/src/components/page/page.module.scss
var lt, ut, dt, ft, pt, mt, ht, gt, _t, vt, yt, bt = R((() => {
	lt = "_root_vjca1_2", ut = "_slotLeft_vjca1_11", dt = "_slotCenter_vjca1_12", ft = "_slotRight_vjca1_13", pt = "_head_vjca1_35", mt = "_controls_vjca1_83", ht = "_link_vjca1_90", gt = "_linkArrow_vjca1_106", _t = "_body_vjca1_112", vt = "_hablaPageBody_vjca1_122", yt = {
		root: lt,
		slotLeft: ut,
		slotCenter: dt,
		slotRight: ft,
		head: pt,
		controls: mt,
		link: ht,
		linkArrow: gt,
		body: _t,
		hablaPageBody: vt
	};
}));
//#endregion
//#region ../utils/src/components/page/head.tsx
function xt({ title: e }) {
	return /* @__PURE__ */ I(j.Heading, {
		variant: "heading-2",
		as: "h1",
		"data-testid": "main-heading",
		children: e
	});
}
function St({ subtitle: e }) {
	return /* @__PURE__ */ I(j.Paragraph, {
		variant: "4",
		subdued: !0,
		children: e
	});
}
var Ct, wt, Tt, Et = R((() => {
	bt(), Ct = ({ backProps: e, backText: t }) => /* @__PURE__ */ L(Oe, {
		className: yt.link,
		...e,
		children: [/* @__PURE__ */ I(E, {
			name: "angle-left",
			className: yt.linkArrow
		}), t]
	}), wt = ({ title: e, subtitle: t, className: n }) => t ? /* @__PURE__ */ L(C, {
		className: n,
		flexDirection: "column",
		children: [/* @__PURE__ */ I(C, {
			alignItems: "center",
			children: /* @__PURE__ */ I(xt, { title: e })
		}), /* @__PURE__ */ I(p, { children: /* @__PURE__ */ I(St, { subtitle: t }) })]
	}) : /* @__PURE__ */ I(C, {
		className: n,
		alignItems: "center",
		children: /* @__PURE__ */ I(xt, { title: e })
	}), Tt = ({ className: e, slotCenter: t, slotLeft: n, slotRight: r, children: i }) => /* @__PURE__ */ L("div", {
		className: e,
		id: "pageHead",
		children: [/* @__PURE__ */ L("div", {
			className: pe("pageHead", yt.head),
			children: [
				!!n && /* @__PURE__ */ I(p, {
					className: yt.slotLeft,
					children: n
				}),
				!!t && /* @__PURE__ */ I(p, {
					className: yt.slotCenter,
					children: t
				}),
				!!r && /* @__PURE__ */ I(p, {
					className: yt.slotRight,
					children: r
				})
			]
		}), i && /* @__PURE__ */ I("div", { children: i })]
	});
})), Dt, Ot, kt = R((() => {
	Et(), bt(), Dt = ({ className: e, children: t, flexDirection: n, ...r }) => /* @__PURE__ */ I("div", {
		className: pe(yt.root, e),
		...r,
		children: t
	}), Ot = ({ children: e, padding: t, flexDirection: n, ...r }) => /* @__PURE__ */ I(oe.Body, {
		className: yt.hablaPageBody,
		...r,
		children: e
	}), Dt.Body = Ot, Dt.Head = Tt, Dt.HeadTitle = wt, Dt.HeadBackLink = Ct, Dt.Section = oe.Section, Dt.Tabs = oe.Tabs;
})), At, jt = R((() => {
	kt(), At = Dt;
}));
//#endregion
//#region ../management-common/src/graphql.ts
function Mt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(hn, n);
}
function Nt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(gn, n);
}
function Pt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(_n, n);
}
function Ft(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(vn, n);
}
function It(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(yn, n);
}
function Lt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(bn, n);
}
function Rt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(xn, n);
}
function zt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(Sn, n);
}
function Bt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(Cn, n);
}
function Vt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(wn, n);
}
function Ht(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(Tn, n);
}
function Ut(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(En, n);
}
function Wt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(Dn, n);
}
function Gt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(On, n);
}
function Kt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(kn, n);
}
function qt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(An, n);
}
function Jt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(jn, n);
}
function Yt(t) {
	let n = {
		...B,
		...t
	};
	return e.useMutation(Mn, n);
}
function Xt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(Nn, n);
}
function Zt(t) {
	let n = {
		...B,
		...t
	};
	return e.useQuery(Pn, n);
}
var B, Qt, $t, en, tn, nn, rn, an, on, sn, cn, ln, un, dn, fn, pn, mn, hn, gn, _n, vn, yn, bn, xn, Sn, Cn, wn, Tn, En, Dn, On, kn, An, jn, Mn, Nn, Pn, V = R((() => {
	B = {}, Qt = /* @__PURE__ */ function(e) {
		return e.NotAllowed = "NOT_ALLOWED", e.Taken = "TAKEN", e;
	}({}), $t = /* @__PURE__ */ function(e) {
		return e.Ar = "ar", e.Bg = "bg", e.Ca = "ca", e.CaValencia = "ca_valencia", e.Cs = "cs", e.Da = "da", e.De = "de", e.DeAt = "de_at", e.DeBe = "de_be", e.DeCh = "de_ch", e.Ee = "ee", e.El = "el", e.En = "en", e.EnAu = "en_au", e.EnCa = "en_ca", e.EnGb = "en_gb", e.EnIe = "en_ie", e.EnNz = "en_nz", e.EnUs = "en_us", e.Es = "es", e.Es_419 = "es_419", e.Et = "et", e.Eu = "eu", e.Fa = "fa", e.Fi = "fi", e.Fr = "fr", e.FrBe = "fr_be", e.FrCa = "fr_ca", e.FrCh = "fr_ch", e.Gl = "gl", e.Hi = "hi", e.Hr = "hr", e.Hu = "hu", e.Id = "id", e.Is = "is", e.It = "it", e.ItCh = "it_ch", e.Iw = "iw", e.Ja = "ja", e.Ko = "ko", e.Lt = "lt", e.Lv = "lv", e.Nb = "nb", e.Nl = "nl", e.NlBe = "nl_be", e.Nn = "nn", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_br", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.Sl = "sl", e.Sq = "sq", e.Sr = "sr", e.Sv = "sv", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhHant = "zh_hant", e;
	}({}), en = o`
  fragment AiDraftListItem on AiDraft {
    __typename
    id
    title
    type
    languageId
    createdAt
    modifiedAt
    initiatedFromConversation
    referencedConversationIds
    collectionId
    categoryId
    possibleCollectionIds
    forArticleId
    initiatedBy {
      id
      name
      email
      avatarUrl
    }
    summary
    htmlContent
  }
`, o`
  fragment ArticleNode on Article {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
  }
`, o`
  fragment ArticleListItemNode on ArticleListItem {
    id
    parentCategories {
      id
    }
    titles {
      title
      languageId
    }
  }
`, tn = o`
  fragment ArticleListItemResult on ArticleListItem {
    __typename
    id
    isSyncedWithElevio: isLocked
    title(languageId: $languageId)
    titles {
      languageId
      title
    }
    publicationStatus(languageId: $languageId)
    parentCollections {
      id
      internalKbEnabled
      title
      linkedResources {
        id
        name
        ... on Queue {
          id
          name
        }
      }
    }
    createdAt
    updatedAt
    createdBy {
      name
      deactivated
    }
    updatedBy {
      name
      deactivated
    }
    parentCategories {
      id
      title(languageId: $languageId)
      parentCollections {
        id
        title
      }
    }
  }
`, nn = o`
  fragment CategoryFields on Category {
    id
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
    isSyncedWithElevio: isLocked
  }
`, rn = o`
  fragment ArticleFields on Article {
    id
    isSyncedWithElevio: isLocked
    updatedAt
    indexedAt
    parent {
      id
    }
    titles {
      title
      languageId
    }
    restrictions {
      direct
      inherited {
        restriction
        from {
          id
        }
      }
    }
  }
`, an = o`
  fragment CategoryChild on Category {
    ...CategoryFields
    articles {
      ...ArticleFields
    }
    categories {
      ...CategoryFields
    }
  }
  ${nn}
  ${rn}
`, o`
  fragment CategoryNode on Category {
    id
    parent {
      id
    }
    restrictions {
      direct
    }
  }
`, on = o`
  fragment CollectionFields on Collection {
    id
    title
    internalKbEnabled
    isSyncedWithElevio: isLocked
    description
    themeColors {
      icon
    }
    linkedResources {
      id
      name
      ... on Queue {
        id
        name
      }
    }
  }
`, sn = o`
  fragment LanguageFields on Language {
    languageId
    description
    nativeDescription
  }
`, cn = o`
  fragment ManagementOrganizationSettings on OrganisationSettingsPayload {
    availableLanguages {
      ...LanguageFields
    }
    defaultLanguage {
      ...LanguageFields
    }
    enabledLanguages {
      ...LanguageFields
    }
  }
  ${sn}
`, ln = o`
  fragment SettingsFields on SettingsPayload {
    isOrganisationSetup
    canCreateCollections
  }
`, un = o`
  fragment AiSettingsVersion on AiSettingsVersionPayload {
    id
    version
    name
    isDraft
    isActive
    createdAt
    settings {
      judgeInstructions
      writerInstructions
      similarity
      minSimilarConversations
    }
  }
`, dn = o`
  fragment ArticleFullFields on Article {
    id
    aiAssisted
    createdAt
    createdBy {
      name
      email
    }
    updatedAt
    updatedBy {
      name
      email
    }
    indexedAt
    indexedBy {
      name
      email
    }
    parent {
      id
      ... on Category {
        titles {
          title
          languageId
        }
      }
    }
    tags {
      id
      name
      color
      type
      isDeactivated
    }
    isSyncedWithElevio: isLocked
    titles {
      title
      languageId
    }
    translations {
      draft {
        languageId
        articleId
        title
        publicationStatus
        version {
          __typename
        }
      }
    }
    parentCollections {
      id
      title
    }
  }
`, fn = o`
  fragment ArticleTranslationFields on ArticleTranslation {
    articleId
    languageId
    version {
      __typename
    }
    title
    aiAssisted
    titleTranslatedAt
    titleUpdatedAt
    content
    updatedAt
    updatedBy {
      name
      email
    }
    publicationStatus
  }
`, pn = o`
  fragment HelpCenterCustomHostname on HelpCenter {
    id
    customHostname {
      hostname
      records {
        cname {
          record {
            aliasOf
            hostname
          }
          status
          verificationErrors
        }
        ssl {
          records {
            name
            value
          }
          status
        }
      }
    }
  }
`, mn = o`
  fragment HelpCenter on HelpCenter {
    id
    name
    subdomain
    hostname
    isHelpCenterIndexable
    collection {
      id
    }
    isActive
    favicon {
      availableAt
    }
    logo {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    companyUrl
    favicon {
      filename
      fileType
      availableAt
      size
      uploadedAt
      originalFileName
    }
    translations {
      languageId
      title
      tagline
    }
    theme {
      id
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
    themeCustomization {
      headerHtml {
        value
        enabled
      }
      footerHtml {
        value
        enabled
      }
      css {
        value
        enabled
      }
      js {
        value
        enabled
      }
    }
    enabledLanguages {
      languageId
    }
    defaultLanguage {
      languageId
      description
    }
  }
`, o`
  fragment CategoryTitles on Category {
    id
    titles {
      title
      languageId
    }
  }
`, o`
  mutation AiDraftApprove($id: ID!, $alsoPublish: Boolean!) {
    aiDraftApprove(id: $id, alsoPublish: $alsoPublish) {
      id
    }
  }
`, o`
  query AiDraft($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
    }
  }
  ${en}
`, o`
  mutation AiDraftReject($id: ID!) {
    aiDraftReject(id: $id) {
      id
    }
  }
`, o`
  mutation AiDraftUpdate(
    $id: ID!
    $feedback: NonEmptyString
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftUpdate(
      id: $id
      feedback: $feedback
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${en}
`, o`
  query AiDrafts(
    $searchQuery: NonEmptyString
    $filters: AiDraftFiltersInput
    $limit: Limit
    $offset: Offset
  ) {
    aiDrafts(
      searchQuery: $searchQuery
      filters: $filters
      limit: $limit
      offset: $offset
    ) {
      results {
        ...AiDraftListItem
      }
      pagination {
        hasMore
        end
        total
      }
    }
  }
  ${en}
`, o`
  mutation ArticleCreate(
    $translations: [ArticleTranslationInput!]!
    $parentId: ID!
  ) {
    articleCreate(translations: $translations, parentId: $parentId) {
      ...ArticleFields
    }
  }
  ${rn}
`, o`
  mutation ArticleDelete($id: ID!) {
    articleDelete(id: $id)
  }
`, o`
  mutation ArticleMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
    }
  }
`, o`
  mutation ArticleTranslationUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString
    $content: ContentJson
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, o`
  mutation ArticleDetachFromElevio($id: ID!) {
    articleUnlock(id: $id) {
      id
      isSyncedWithElevio: isLocked
    }
  }
`, o`
  query Articles(
    $languageId: LanguageId!
    $limit: Limit
    $offset: Offset
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: $limit, offset: $offset) {
      query(query: $query, filters: $filters) {
        results {
          ...ArticleListItemResult
        }
        pagination {
          hasMore
          end
        }
      }
    }
  }
  ${tn}
`, o`
  mutation CategoryCreate(
    $parentId: ID!
    $translations: [CategoryTranslationInputInput!]!
  ) {
    categoryCreate(parentId: $parentId, translations: $translations) {
      ...CategoryFields
    }
  }
  ${nn}
`, o`
  mutation CategoryDelete($categoryId: ID!) {
    categoryDelete(id: $categoryId)
  }
`, o`
  query CategoryDropdown($collectionId: ID!) {
    collection(id: $collectionId) {
      categories {
        id
        isSyncedWithElevio: isLocked
        titles {
          title
          languageId
        }
        categories {
          id
          isSyncedWithElevio: isLocked
          titles {
            title
            languageId
          }
          categories {
            id
            isSyncedWithElevio: isLocked
            titles {
              title
              languageId
            }
            categories {
              id
              isSyncedWithElevio: isLocked
              titles {
                title
                languageId
              }
              categories {
                id
                isSyncedWithElevio: isLocked
                titles {
                  title
                  languageId
                }
              }
            }
          }
        }
      }
    }
  }
`, o`
  mutation CategoryMove(
    $entityId: ID!
    $currentParentId: ID!
    $newParentId: ID
    $newPosition: PositiveInt
  ) {
    contentMove(
      entityId: $entityId
      currentParentId: $currentParentId
      newParentId: $newParentId
      newPosition: $newPosition
    ) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, o`
  query CategoryMoveQ($id: ID!) {
    category(id: $id) {
      id
      parent {
        id
      }
    }
  }
`, o`
  query CategoryNode($id: ID!) {
    category(id: $id) {
      ...CategoryChild
    }
  }
  ${an}
`, o`
  query Category($id: ID!) {
    category(id: $id) {
      id
      titles {
        languageId
        title
      }
      parent {
        id
      }
      restrictions {
        direct
      }
      isSyncedWithElevio: isLocked
    }
  }
`, o`
  mutation CategoryTranslationDelete($id: ID!, $languageId: LanguageId!) {
    categoryTranslationDelete(id: $id, languageId: $languageId) {
      ...CategoryFields
    }
  }
  ${nn}
`, o`
  mutation CategoryTranslationUpsert(
    $id: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
  ) {
    categoryTranslationUpsert(id: $id, languageId: $languageId, title: $title) {
      ...CategoryFields
    }
  }
  ${nn}
`, o`
  mutation CategoryUpdate($id: ID!) {
    categoryUpdate(id: $id) {
      ...CategoryFields
    }
  }
  ${nn}
`, o`
  mutation CollectionCreate(
    $title: NonEmptyString!
    $internalKbEnabled: Boolean!
  ) {
    collectionCreate(title: $title, internalKbEnabled: $internalKbEnabled) {
      ...CollectionFields
    }
  }
  ${on}
`, o`
  mutation CollectionDelete($id: ID!) {
    collectionDelete(id: $id)
  }
`, o`
  mutation CollectionDetach($id: ID!) {
    collectionUnlock(id: $id) {
      ...CollectionFields
    }
  }
  ${on}
`, hn = o`
  query Collection($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
    }
  }
  ${on}
`, o`
  query CollectionStats($id: ID!) {
    collection(id: $id) {
      id
      statistics {
        categoryCount
        articleCount
        queueCount
      }
    }
  }
`, o`
  query CollectionTree($id: ID!) {
    collection(id: $id) {
      ...CollectionFields
      categories {
        ...CategoryFields
        articles {
          ...ArticleFields
        }
        categories {
          ...CategoryFields
          articles {
            ...ArticleFields
          }
          categories {
            ...CategoryFields
            articles {
              ...ArticleFields
            }
            categories {
              ...CategoryFields
              articles {
                ...ArticleFields
              }
              categories {
                ...CategoryFields
                articles {
                  ...ArticleFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${on}
  ${nn}
  ${rn}
`, o`
  mutation CollectionUpdate(
    $id: ID!
    $title: NonEmptyString
    $externalResources: ResourcesUpdateInput
    $internalKbEnabled: Boolean!
    $icon: Color!
    $description: String
  ) {
    collectionUpdate(
      id: $id
      title: $title
      externalResources: $externalResources
      internalKbEnabled: $internalKbEnabled
      themeColors: { icon: $icon }
      description: $description
    ) {
      ...CollectionFields
    }
  }
  ${on}
`, gn = o`
  query CollectionsFetch($offset: Offset, $limit: Limit) {
    collections(offset: $offset, limit: $limit) {
      results {
        id
        title
        internalKbEnabled
        isSyncedWithElevio: isLocked
      }
    }
    settings {
      ...SettingsFields
    }
  }
  ${ln}
`, _n = o`
  mutation FileUpload($fileName: NonEmptyString!) {
    fileUploadRequest(filename: $fileName) {
      uploadUrl
      method
      contentType
      customHeaders
      expiresAt
      filename
      availableAt
    }
  }
`, o`
  query OptimisticArticleParent($id: ID!) {
    category(id: $id) {
      id
      articles {
        id
      }
    }
  }
`, o`
  query OptimisticCategory($id: ID!) {
    category(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, o`
  query OptimisticCollection($id: ID!) {
    collection(id: $id) {
      id
      categories {
        id
        parent {
          id
        }
      }
    }
  }
`, o`
  mutation OrganizationEnableLanguages($languageIds: [LanguageId!]!) {
    organisationEnableLanguages(languageIds: $languageIds) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, o`
  mutation OrganizationRemoveLanguage($languageId: LanguageId!) {
    organisationDisableLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, o`
  mutation OrganizationSetDefaultLanguage($languageId: LanguageId!) {
    organisationSetDefaultLanguage(languageId: $languageId) {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, vn = o`
  query OrganizationSettings {
    organisationSettings {
      ...ManagementOrganizationSettings
    }
  }
  ${cn}
`, o`
  query Owners {
    articles {
      owners {
        id
        name
        fullName {
          givenName
          middleNames
          familyName
        }
        avatarUrl
      }
    }
  }
`, o`
  mutation ParentAddChild($childId: ID!, $parentId: ID!) {
    parentAddChild(childId: $childId, parentId: $parentId) {
      id
    }
  }
`, o`
  query Settings {
    settings {
      ...SettingsFields
    }
  }
  ${ln}
`, o`
  mutation SetupOrganisation {
    setupOrganisation {
      id
      title
    }
  }
`, o`
  query AiDraftByCsid($csid: Long!) {
    aiDraftByCsid(csid: $csid) {
      ...AiDraftListItem
    }
  }
  ${en}
`, o`
  mutation AiDraftDelete($id: ID!) {
    aiDraftDelete(id: $id)
  }
`, o`
  mutation AiDraftGenerate(
    $csid: Long!
    $languageId: LanguageId!
    $collectionId: ID
    $categoryId: ID
  ) {
    aiDraftGenerate(
      csid: $csid
      languageId: $languageId
      collectionId: $collectionId
      categoryId: $categoryId
    ) {
      ...AiDraftListItem
    }
  }
  ${en}
`, o`
  query AiDraftLiveUpdate($id: ID!) {
    aiDraft(id: $id) {
      ...AiDraftListItem
      approvedAt
      rejectedAt
    }
  }
  ${en}
`, o`
  query AiSettingsAccess {
    settings {
      userPermissions {
        languageSettings
      }
    }
  }
`, o`
  mutation AiSettingsDraftUpdate(
    $judgeInstructions: String
    $writerInstructions: String
    $minSimilarConversations: Int!
    $similarity: SimilarityLevel!
  ) {
    organisationUpdateAiSettingsDraft(
      judgeInstructions: $judgeInstructions
      writerInstructions: $writerInstructions
      minSimilarConversations: $minSimilarConversations
      similarity: $similarity
    ) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, o`
  mutation AiSettingsVersionActivate($id: ID!) {
    organisationActivateAiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, o`
  mutation AiSettingsVersionCreate($name: String!, $activate: Boolean!) {
    organisationCreateAiSettingsVersion(name: $name, activate: $activate) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, o`
  query AiSettingsVersion($id: ID) {
    aiSettingsVersion(id: $id) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, o`
  mutation AiSettingsVersionRename($id: ID!, $name: String!) {
    organisationRenameAiSettingsVersion(id: $id, name: $name) {
      ...AiSettingsVersion
    }
  }
  ${un}
`, o`
  query AiSettingsVersions {
    aiSettingsVersions {
      id
      version
      name
      isActive
      createdAt
    }
  }
`, o`
  query ArticleEditor($id: ID!) {
    article(id: $id) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, o`
  query ArticleHasChanges($articleId: ID!) {
    article(id: $articleId) {
      id
      translations {
        draft {
          articleId
          languageId
          publicationStatus
        }
      }
    }
  }
`, o`
  query ArticleLinkLookup(
    $languageId: LanguageId!
    $filters: ArticleFiltersInput
    $query: ArticleSearchInput
  ) {
    articles(limit: 15, offset: 0) {
      query(query: $query, filters: $filters) {
        results {
          id
          title(languageId: $languageId)
          parentCategories {
            id
            title(languageId: $languageId)
          }
        }
      }
    }
  }
`, o`
  mutation ArticlePublish($articleId: ID!) {
    articlePublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, o`
  mutation ArticleTranslationDelete($articleId: ID!, $languageId: LanguageId!) {
    articleTranslationDelete(articleId: $articleId, languageId: $languageId)
  }
`, o`
  mutation ArticleTranslationDraftCreate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
  ) {
    articleTranslationCreate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, o`
  mutation ArticleTranslationDraftUpdate(
    $articleId: ID!
    $languageId: LanguageId!
    $title: NonEmptyString!
    $content: ContentJson!
    $titleUpdatedAt: String
    $titleTranslatedAt: String
  ) {
    articleTranslationUpdate(
      articleId: $articleId
      languageId: $languageId
      title: $title
      content: $content
      titleUpdatedAt: $titleUpdatedAt
      titleTranslatedAt: $titleTranslatedAt
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, o`
  query ArticleTranslation($id: ID!, $languageId: LanguageId!) {
    articleTranslation(id: $id, languageId: $languageId) {
      articleId
      publicationStatus
      draft {
        ...ArticleTranslationFields
      }
    }
  }
  ${fn}
`, o`
  mutation ArticleTranslationPublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationPublish(articleId: $articleId, languageId: $languageId)
  }
`, o`
  mutation ArticleTranslationRevertDraft(
    $articleId: ID!
    $languageId: LanguageId!
    $version: PositiveInt
    $publish: Boolean
  ) {
    articleTranslationRevertDraft(
      articleId: $articleId
      languageId: $languageId
      version: $version
      publish: $publish
    ) {
      ...ArticleTranslationFields
    }
  }
  ${fn}
`, o`
  mutation ArticleTranslationUnpublish(
    $articleId: ID!
    $languageId: LanguageId!
  ) {
    articleTranslationUnpublish(articleId: $articleId, languageId: $languageId)
  }
`, o`
  query ArticleTranslationVersion(
    $articleId: ID!
    $languageId: LanguageId!
    $versionNumber: PositiveInt!
  ) {
    article(id: $articleId) {
      translation(languageId: $languageId) {
        version(versionNumber: $versionNumber) {
          articleId
          languageId
          version {
            __typename
          }
          title
          content
        }
      }
    }
  }
`, o`
  query ArticleTranslationVersions($articleId: ID!, $languageId: LanguageId!) {
    article(id: $articleId) {
      translations {
        versions(languageId: $languageId) {
          publishedAt
          publishedBy {
            name
          }
          title
          version {
            __typename
            ... on Indexed {
              versionNumber
            }
          }
          isCurrentlyIndexed
          aiAssisted
          referencedConversationIds
        }
      }
    }
  }
`, o`
  mutation ArticleUnpublish($articleId: ID!) {
    articleUnpublish(articleId: $articleId) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, o`
  mutation ArticleUpdate($articleId: ID!, $tags: TagsInput) {
    articleUpdate(id: $articleId, tags: $tags) {
      ...ArticleFullFields
    }
  }
  ${dn}
`, yn = o`
  mutation HelpCenterAddCompanyLogo($id: ID!, $logo: String!) {
    helpCenterUpdate(id: $id, logo: $logo) {
      id
      logo {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, bn = o`
  mutation HelpCenterAddFavicon($id: ID!, $favicon: String!) {
    helpCenterUpdate(id: $id, favicon: $favicon) {
      id
      favicon {
        filename
        fileType
        availableAt
        size
        uploadedAt
        originalFileName
      }
    }
  }
`, xn = o`
  mutation HelpCenterCreate(
    $subdomain: String!
    $translations: [HelpCenterTranslationInput!]!
    $name: NonEmptyString!
    $collectionId: ID!
    $defaultLanguageId: LanguageId!
    $isHelpCenterIndexable: Boolean!
  ) {
    helpCenterCreate(
      subdomain: $subdomain
      translations: $translations
      name: $name
      collectionId: $collectionId
      defaultLanguage: $defaultLanguageId
      isHelpCenterIndexable: $isHelpCenterIndexable
    ) {
      id
      name
      translation(languageId: $defaultLanguageId) {
        languageId
        title
        tagline
      }
      subdomain
      hostname
      customHostname {
        hostname
      }
      isHelpCenterIndexable
      collection {
        id
        title
      }
      isActive
      favicon {
        filename
        fileType
        availableAt
      }
      logo {
        filename
        fileType
        availableAt
      }
    }
  }
`, Sn = o`
  query HelpCenterCustomHostnameFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, Cn = o`
  mutation HelpCenterCustomizationDeleteFavicon($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, favicon: "") {
      favicon {
        availableAt
        filename
      }
    }
  }
`, wn = o`
  mutation HelpCenterCustomizationDeleteLogo($helpCenterId: ID!) {
    helpCenterUpdate(id: $helpCenterId, logo: "") {
      logo {
        availableAt
        filename
      }
    }
  }
`, Tn = o`
  mutation HelpCenterDelete($id: ID!, $deregisterCustomHostname: Boolean) {
    helpCenterDelete(
      id: $id
      deregisterCustomHostname: $deregisterCustomHostname
    )
  }
`, En = o`
  mutation HelpCenterDeregisterHostname($id: ID!) {
    helpCenterDeregisterHostname(id: $id) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, Dn = o`
  query HelpCenterFetch($id: ID!) {
    helpCenter(id: $id) {
      ...HelpCenter
    }
  }
  ${mn}
`, On = o`
  mutation HelpCenterRegisterHostname($id: ID!, $customHostname: String!) {
    helpCenterRegisterHostname(id: $id, customHostname: $customHostname) {
      ...HelpCenterCustomHostname
    }
  }
  ${pn}
`, kn = o`
  mutation HelpCenterUpdateAdvancedCustomization(
    $helpCenterId: ID!
    $themeCustomization: HelpCenterThemeCustomizationInput!
  ) {
    helpCenterUpdate(
      id: $helpCenterId
      themeCustomization: $themeCustomization
    ) {
      id
      themeCustomization {
        headerHtml {
          value
          enabled
        }
        footerHtml {
          value
          enabled
        }
        css {
          value
          enabled
        }
        js {
          value
          enabled
        }
      }
    }
  }
`, An = o`
  mutation HelpCenterUpdateCustomization(
    $helpCenterId: ID!
    $themeId: ID!
    $colors: HelpCenterThemeColorsUpdateInput!
    $companyUrl: URL!
  ) {
    helpCenterUpdate(id: $helpCenterId, companyUrl: $companyUrl) {
      ...HelpCenter
    }
    helpCenterThemeUpdate(id: $themeId, colors: $colors) {
      id
      name
      colors {
        websiteBackground
        pageBackground
        text
        link
        accent
        accentText
      }
    }
  }
  ${mn}
`, jn = o`
  mutation HelpCenterUpdateCustomizationTranslations(
    $helpCenterId: ID!
    $translation: HelpCenterTranslationInput!
  ) {
    helpCenterUpdate(id: $helpCenterId, translation: $translation) {
      ...HelpCenter
    }
  }
  ${mn}
`, Mn = o`
  mutation HelpCenterUpdateSettings(
    $id: ID!
    $subdomain: String
    $collectionId: ID
    $active: Boolean!
    $name: NonEmptyString!
    $isHelpCenterIndexable: Boolean!
    $enableLanguages: [LanguageId!]
    $disableLanguages: [LanguageId!]
    $defaultLanguage: LanguageId
  ) {
    helpCenterUpdate(
      id: $id
      subdomain: $subdomain
      collectionId: $collectionId
      active: $active
      name: $name
      isHelpCenterIndexable: $isHelpCenterIndexable
      enableLanguages: $enableLanguages
      disableLanguages: $disableLanguages
      defaultLanguage: $defaultLanguage
    ) {
      ...HelpCenter
    }
  }
  ${mn}
`, Nn = o`
  query HelpCenters {
    helpCenters(offset: 0, limit: 50) {
      results {
        id
        name
        hostname
        customHostname {
          hostname
        }
        isActive
        collection {
          id
          title
        }
      }
    }
  }
`, Pn = o`
  query SubdomainAvailability($subdomain: String!) {
    subdomainAvailability(subdomain: $subdomain) {
      isAvailable
      reason
    }
  }
`;
}));
jt(), V();
function Fn({ selectedLanguageId: e, onCompleted: t, fetchPolicy: n = "cache-first" } = {}) {
	let { data: r, ...i } = Ft({
		fetchPolicy: n,
		onCompleted: t
	});
	return {
		...i,
		data: In(r, e)
	};
}
function In(e, t) {
	if (!e?.organisationSettings) return;
	let n = e.organisationSettings.enabledLanguages.find((e) => e.languageId === t) || e.organisationSettings.defaultLanguage;
	return {
		...e.organisationSettings,
		selectedLanguage: n
	};
}
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/serialize.js
function Ln(e, t) {
	if (e == null) return e;
	if (e.length === 0 && (!t || t && e !== "")) return null;
	let n = e instanceof Array ? e[0] : e;
	return n == null ? n : !t && n === "" ? null : n;
}
function Rn(e) {
	return e == null ? e : String(e);
}
function zn(e) {
	let t = Ln(e, !0);
	return t == null ? t : String(t);
}
var Bn = R((() => {})), Vn, Hn = R((() => {
	Bn(), Vn = {
		encode: Rn,
		decode: zn
	};
}));
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/objectToSearchString.js
function Un(e) {
	let t = new URLSearchParams(), n = Object.entries(e);
	for (let [e, r] of n) if (r != null) if (Array.isArray(r)) for (let n of r) t.append(e, n ?? "");
	else t.append(e, r);
	return t.toString();
}
var Wn = R((() => {})), Gn = R((() => {
	Xn(), "{}[],\":".split("").map((e) => [e, encodeURIComponent(e)]);
}));
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/encodeQueryParams.js
function Kn(e, t) {
	let n = {}, r = Object.keys(t);
	for (let i of r) {
		let r = t[i];
		e[i] ? n[i] = e[i].encode(t[i]) : n[i] = r == null ? r : String(r);
	}
	return n;
}
var qn = R((() => {}));
//#endregion
//#region ../../../node_modules/serialize-query-params/dist/searchStringToObject.js
function Jn(e) {
	let t = new URLSearchParams(e), n = {};
	for (let [e, r] of t) Object.prototype.hasOwnProperty.call(n, e) ? Array.isArray(n[e]) ? n[e].push(r) : n[e] = [n[e], r] : n[e] = r;
	return n;
}
var Yn = R((() => {})), Xn = R((() => {
	Hn(), Gn(), qn(), Yn(), Wn();
})), Zn = R((() => {})), Qn, $n, er = R((() => {
	Qn = class {
		constructor() {
			this.paramsMap = /* @__PURE__ */ new Map(), this.registeredParams = /* @__PURE__ */ new Map();
		}
		set(e, t, n, r) {
			this.paramsMap.set(e, {
				stringified: t,
				decoded: n,
				decode: r
			});
		}
		has(e, t, n) {
			if (!this.paramsMap.has(e)) return !1;
			let r = this.paramsMap.get(e);
			return r ? r.stringified === t && (n == null || r.decode === n) : !1;
		}
		get(e) {
			if (this.paramsMap.has(e)) return this.paramsMap.get(e)?.decoded;
		}
		registerParams(e) {
			for (let t of e) {
				let e = this.registeredParams.get(t) || 0;
				this.registeredParams.set(t, e + 1);
			}
		}
		unregisterParams(e) {
			for (let t of e) {
				let e = (this.registeredParams.get(t) || 0) - 1;
				e <= 0 ? (this.registeredParams.delete(t), this.paramsMap.has(t) && this.paramsMap.delete(t)) : this.registeredParams.set(t, e);
			}
		}
		clear() {
			this.paramsMap.clear(), this.registeredParams.clear();
		}
	}, $n = new Qn();
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/inheritedParams.js
function tr(e, t) {
	let n = {}, r = !1, i = Object.keys(e), a = i;
	if (t.includeKnownParams || t.includeKnownParams !== !1 && i.length === 0) {
		let e = Object.keys(t.params ?? {});
		a.push(...e);
	}
	for (let i of a) {
		let a = e[i];
		if (typeof a == "object" && a) {
			n[i] = a;
			continue;
		}
		r = !0, n[i] = t.params?.[i] ?? Vn;
	}
	return r ? n : e;
}
function nr(e, t, n, r) {
	if (!n || !t.length) return e;
	let i = { ...e }, a = !1;
	for (let e of t) Object.prototype.hasOwnProperty.call(i, e) || (i[e] = n[e] ?? r, a = !0);
	return a ? i : e;
}
var rr = R((() => {
	Xn();
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/shallowEqual.js
function ir(e, t) {
	return e === t ? e !== 0 || t !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function ar(e, t, n) {
	if (ir(e, t)) return !0;
	if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
	let r = Object.keys(e), i = Object.keys(t);
	if (r.length !== i.length) return !1;
	for (let i = 0; i < r.length; i++) {
		let a = n?.[r[i]]?.equals ?? ir;
		if (!or.call(t, r[i]) || !a(e[r[i]], t[r[i]])) return !1;
	}
	return !0;
}
var or, sr = R((() => {
	or = Object.prototype.hasOwnProperty;
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/latestValues.js
function cr(e, t, n) {
	let r = {}, i = Object.keys(t);
	for (let a of i) {
		let i = t[a], o = e[a], s;
		if (n.has(a, o, i.decode)) s = n.get(a);
		else {
			if (s = i.decode(o), i.equals && n.has(a, o)) {
				let e = n.get(a);
				i.equals(s, e) && (s = e);
			}
			s !== void 0 && n.set(a, o, s, i.decode);
		}
		s === void 0 && i.default !== void 0 && (s = i.default), r[a] = s;
	}
	return r;
}
function lr() {
	let e;
	function t(t, n, r) {
		let i = cr(t, n, r);
		return e != null && ar(e, i) ? e : (e = i, i);
	}
	return t;
}
var ur = R((() => {
	sr();
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/urlName.js
function dr(e) {
	let t;
	for (let n in e) if (e[n].urlName) {
		let r = `${e[n].urlName}\0${n}`;
		t ? t.push(r) : t = [r];
	}
	return t ? t.join("\n") : void 0;
}
function fr(e) {
	if (e) return Object.fromEntries(e.split("\n").map((e) => e.split("\0")));
}
function pr(e, t) {
	let n = {};
	for (let r in e) t[r]?.urlName == null ? n[r] = e[r] : n[t[r].urlName] = e[r];
	return n;
}
var mr = R((() => {})), hr, gr, _r, vr, yr, br = R((() => {
	sr(), mr(), vr = {}, yr = (e, t, n) => {
		if (hr === t && _r === e && gr === n) return vr;
		hr = t, _r = e;
		let r = e(t ?? "");
		gr = n;
		let i = fr(n);
		for (let [e, t] of Object.entries(r)) {
			i?.[e] && (delete r[e], e = i[e], r[e] = t);
			let n = vr[e];
			ar(t, n) && (r[e] = n);
		}
		return vr = r, r;
	};
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/options.js
function xr(e, t) {
	t ??= {};
	let n = {
		...e,
		...t
	};
	return t.params && e.params && (n.params = {
		...e.params,
		...t.params
	}), n;
}
var Sr, Cr = R((() => {
	Xn(), Sr = {
		searchStringToObject: Jn,
		objectToSearchString: Un,
		updateType: "pushIn",
		includeKnownParams: void 0,
		includeAllParams: !1,
		removeDefaultsFromUrl: !1,
		enableBatching: !1,
		skipUpdateWhenNoChange: !0
	};
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/QueryParamProvider.js
function wr() {
	let e = me.useContext(Or);
	if (e === void 0 || e === Dr) throw Error("useQueryParams must be used within a QueryParamProvider");
	return e;
}
function Tr({ children: e, adapter: t, options: n }) {
	let { adapter: r, options: i } = me.useContext(Or), a = me.useMemo(() => ({
		adapter: t ?? r,
		options: xr(i, n)
	}), [
		t,
		n,
		r,
		i
	]);
	return /* @__PURE__ */ me.createElement(Or.Provider, { value: a }, e);
}
function Er({ children: e, adapter: t, options: n }) {
	let r = t;
	return r ? /* @__PURE__ */ me.createElement(r, null, (t) => /* @__PURE__ */ me.createElement(Tr, {
		adapter: t,
		options: n
	}, e)) : /* @__PURE__ */ me.createElement(Tr, { options: n }, e);
}
var Dr, Or, kr = R((() => {
	Cr(), Dr = {
		adapter: {},
		options: Sr
	}, Or = me.createContext(Dr);
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/removeDefaults.js
function Ar(e, t) {
	for (let n in e) t[n]?.default !== void 0 && e[n] !== void 0 && t[n].encode(t[n].default) === e[n] && (e[n] = void 0);
}
var jr = R((() => {}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/updateSearchString.js
function Mr({ changes: e, updateType: t, currentSearchString: n, paramConfigMap: r, options: i }) {
	let { searchStringToObject: a, objectToSearchString: o } = i;
	t ??= i.updateType;
	let s, c = yr(a, n), l = nr(r, Object.keys(e), i.params), u;
	u = typeof e == "function" ? e(cr(c, l, $n)) : e, s = Kn(l, u), i.removeDefaultsFromUrl && Ar(s, l), s = pr(s, l);
	let d;
	return d = o(t === "push" || t === "replace" ? s : {
		...c,
		...s
	}), d?.length && d[0] !== "?" && (d = `?${d}`), d ?? "";
}
function Nr({ searchString: e, adapter: t, navigate: n, updateType: r }) {
	let i = {
		...t.location,
		search: e
	};
	n && (typeof r == "string" && r.startsWith("replace") ? t.replace(i) : t.push(i));
}
function Pr(e, { immediate: t } = {}) {
	Lr.push(e);
	let n = t ? Fr : Ir;
	Lr.length === 1 && n(() => {
		let t = Lr.slice();
		Lr.length = 0;
		let n = t[0].currentSearchString, r;
		for (let e = 0; e < t.length; ++e) r = Mr(e === 0 ? t[e] : {
			...t[e],
			currentSearchString: r
		});
		e.options.skipUpdateWhenNoChange && r === n || Nr({
			searchString: r ?? "",
			adapter: t[t.length - 1].adapter,
			navigate: !0,
			updateType: t[t.length - 1].updateType
		});
	});
}
var Fr, Ir, Lr, Rr = R((() => {
	Xn(), er(), rr(), ur(), br(), jr(), mr(), Fr = (e) => e(), Ir = (e) => setTimeout(() => e(), 0), Lr = [];
}));
//#endregion
//#region ../../../node_modules/use-query-params/dist/useQueryParams.js
function zr(e, t) {
	let { adapter: n, options: r } = wr(), [i] = De(lr), { paramConfigMap: a, options: o } = Br(e, t), s = Te(() => xr(r, o), [r, o]), c = tr(a, s), l = yr(s.searchStringToObject, n.location.search, dr(c));
	s.includeAllParams && (c = nr(c, Object.keys(l), s.params, Vn));
	let u = i(l, c, $n), d = Object.keys(c).join("\0");
	N(() => {
		let e = d.split("\0");
		return $n.registerParams(e), () => {
			$n.unregisterParams(e);
		};
	}, [d]);
	let f = {
		adapter: n,
		paramConfigMap: c,
		options: s
	}, p = P(f);
	p.current ??= f, N(() => {
		p.current.adapter = n, p.current.paramConfigMap = c, p.current.options = s;
	}, [
		n,
		c,
		s
	]);
	let [m] = De(() => (e, t) => {
		let { adapter: n, paramConfigMap: r, options: i } = p.current;
		t ??= i.updateType, Pr({
			changes: e,
			updateType: t,
			currentSearchString: n.location.search,
			paramConfigMap: r,
			options: i,
			adapter: n
		}, { immediate: !i.enableBatching });
	});
	return [u, m];
}
function Br(e, t) {
	let n, r;
	return e === void 0 ? (n = {}, r = t) : Array.isArray(e) ? (n = Object.fromEntries(e.map((e) => [e, "inherit"])), r = t) : (n = e, r = t), {
		paramConfigMap: n,
		options: r
	};
}
var Vr, Hr = R((() => {
	Xn(), er(), rr(), ur(), br(), Cr(), kr(), Rr(), mr(), Vr = zr;
})), Ur, Wr = R((() => {
	Hr(), Ur = (e, t, n) => {
		let [r, i] = Vr(Te(() => ({ [e]: t ?? "inherit" }), [e, t]), n);
		return [r[e], M((t, n) => i(typeof t == "function" ? (n) => {
			let r = t(n[e]);
			return { [e]: r };
		} : { [e]: t }, n), [e, i])];
	};
})), Gr = R((() => {
	Hr();
})), Kr = R((() => {
	Hr();
})), qr = R((() => {
	Xn(), Zn(), Wr(), Hr(), Gr(), Kr(), kr();
}));
//#endregion
//#region ../management-common/src/contexts/language.ts
function Jr() {
	let [e, t] = Ur("langId", Vn);
	return [e || null, t];
}
var Yr, Xr = R((() => {
	qr(), Yr = ve({}), Yr.displayName = "LanguageContext";
}));
//#endregion
//#region ../management-common/src/contexts/languageProvider.tsx
Xr();
var Zr = ({ children: e }) => {
	let [t, n] = Jr(), { data: r, loading: i, error: a } = Fn({
		selectedLanguageId: t,
		fetchPolicy: "cache-and-network"
	});
	if (a) throw a;
	return i || !r ? /* @__PURE__ */ I(At, { children: /* @__PURE__ */ I(C, {
		width: "100%",
		height: "100%",
		justifyContent: "center",
		alignItems: "center",
		children: /* @__PURE__ */ I(ce, { size: 64 })
	}) }) : /* @__PURE__ */ I(Yr.Provider, {
		value: {
			...r,
			currentLanguage: t,
			setCurrentLanguage: n
		},
		children: e
	});
};
//#endregion
//#region ../modal/src/Context.tsx
function Qr({ children: e }) {
	let [t, n] = De(null), r = M((e, t) => {
		n({
			modal: e,
			props: t
		});
	}, []), i = M(() => n(null), []), [a, o] = t ? [t.modal, t.props] : [];
	return /* @__PURE__ */ L(ei.Provider, {
		value: {
			showModal: r,
			hideModal: i
		},
		children: [e, /* @__PURE__ */ I(_e, {
			fallback: null,
			children: a && /* @__PURE__ */ I(a, { ...o })
		})]
	});
}
function $r() {
	let { showModal: e, hideModal: t } = Ce(ei);
	return {
		showModal: e,
		hideModal: t
	};
}
var ei, ti = R((() => {
	ei = ve({
		hideModal: () => {},
		showModal: () => {}
	});
})), ni, ri, ii = R((() => {
	ni = "_modalBody_1eukg_1", ri = { modalBody: ni };
}));
//#endregion
//#region ../modal/src/ModalWrapper/index.tsx
function ai({ children: e, className: t, allowEscClose: n = !0 }) {
	let { hideModal: r } = $r();
	return /* @__PURE__ */ I(re, {
		allowEscClose: n,
		className: pe(ri.modalBody, t),
		isOpen: !0,
		onClose: r,
		children: e
	});
}
var oi = R((() => {
	ti(), ii();
})), si = R((() => {
	ti(), oi();
}));
//#endregion
//#region ../utils/src/components/bugTracking.tsx
si();
function ci({ children: e, fallback: t }) {
	function n(e) {
		Fe.captureException(e, { tags: { team: Ie.Knowledge } });
	}
	return /* @__PURE__ */ I(Fe.ErrorBoundary, {
		fallback: t,
		onError: n,
		children: e
	});
}
var li = { message: "_message_8a2au_1" };
//#endregion
//#region ../utils/src/components/knowledgeErrorPlaceholder.tsx
function ui({ message: e }) {
	return /* @__PURE__ */ I(j.Paragraph, {
		className: li.message,
		variant: "4",
		subdued: !0,
		children: e || "Something went wrong, please reload and try again. If this issue persists, please contact support."
	});
}
//#endregion
//#region ../utils/src/components/loading.tsx
function di(e) {
	let { width: t = "100%", height: n = "100%", size: r = 56, ...i } = e;
	return /* @__PURE__ */ L(C, {
		style: {
			width: t,
			height: n,
			display: "inline-flex"
		},
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		background: "neutral.000",
		children: [/* @__PURE__ */ I(ce, {
			...i,
			size: r
		}), e.text && /* @__PURE__ */ I(j.Paragraph, {
			padding: "300",
			children: e.text
		})]
	});
}
//#endregion
//#region ../utils/src/contexts/notification.tsx
var fi, pi = R((() => {
	fi = ve((e) => {
		console.log("Notification: ", e);
	}), fi.displayName = "NotificationContext";
}));
//#endregion
//#region ../../../node_modules/use-query-params/adapters/react-router-6/index.js
pi();
var mi = ({ children: e }) => {
	let { navigator: t } = Ce(Ae), n = Me(), r = Ce(ke)?.router, i = je();
	return e({
		replace(e) {
			n(e.search || "?", {
				replace: !0,
				state: e.state
			});
		},
		push(e) {
			n(e.search || "?", {
				replace: !1,
				state: e.state
			});
		},
		get location() {
			return r?.state?.location ?? t?.location ?? i;
		}
	});
}, hi = /* @__PURE__ */ z(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.path = void 0;
	function t(e) {
		let a = n(e), o = (e) => "/" + a.map((t) => t.kind === "param" ? i(e, t.paramName) : t.value).filter((e) => e !== "").join("/");
		if (o.pattern = r(e), o.parts = a, o.path = (n) => t(`${e}/${n}`), !o.pattern.startsWith("/")) throw Error(`Paths must begin with slashes, but ${JSON.stringify(o.pattern)} doesn't.`);
		return o;
	}
	e.path = t;
	function n(e) {
		return e.split("/").map((e) => e.startsWith(":") ? {
			kind: "param",
			paramName: e.replace(/^:/, "")
		} : {
			kind: "constant",
			value: e
		});
	}
	function r(e) {
		return e === "/" ? e : e.replace(/\/+/g, "/").replace(/^(.+)\/$/, (e, t) => t);
	}
	function i(e, t) {
		let n = e[t];
		if (typeof n != "string") throw Error(`When generating a path, the path param ${JSON.stringify(t)} didn't exist on params object ${JSON.stringify(e)}. The types should have prevented this, so either you defeated them (e.g., with \`as\`) or this is a bug!`);
		return n;
	}
})), gi, _i, vi, yi, bi, xi, Si, Ci, wi, Ti, Ei, Di, Oi, ki, Ai, ji, Mi, Ni, Pi, Fi = R((() => {
	gi = hi(), qr(), _i = (0, gi.path)("/knowledge"), vi = _i.path("/collection"), yi = _i.path("/collection/:collectionId"), bi = _i.path("/settings"), xi = bi.path("/ai-suggestions"), Si = xi.path("/versions"), Ci = Si.path("/:versionId"), wi = _i.path("/article-editor/:articleId"), Ti = wi.path("/version-history"), Ei = _i.path("/articles"), Di = _i.path("/article-suggestions"), Oi = (0, gi.path)("/internal-kb"), ki = Oi.path("/collection/:collectionId"), Ai = Oi.path("/collection/:collectionId/article/:articleId"), ji = (0, gi.path)("/settings"), Mi = ji.path("/help-centers"), Ni = Mi.path("/:helpCenterId"), Pi = {
		content: () => vi({}),
		articleSuggestions: () => Di({}),
		articles: (e) => e?.length ? `${Ei({})}?${e}` : Ei({}),
		collectionEdit: ({ collectionId: e, articlesFiltersStore: t }) => {
			let { collectionId: n, ...r } = t, i = Un(r);
			return i.length ? `${yi({ collectionId: e })}?${i}` : yi({ collectionId: e });
		},
		articleVersionHistory: ({ articleId: e, languageId: t }) => {
			let n = Ti({ articleId: e });
			return t ? `${n}?langId=${t}` : n;
		},
		articleEdit: ({ articleId: e, collectionId: t, languageId: n }) => {
			let r = {};
			n && (r.langId = n), t && (r.collectionId = t);
			let i = Object.keys(r).length > 0 ? new URLSearchParams(r).toString() : "";
			return `${wi({ articleId: e })}${i.length ? `?${i}` : ""}`;
		},
		knowledgeSettingsPath: () => bi({}),
		aiSuggestionsSettings: () => xi({}),
		aiSuggestionsVersions: () => Si({}),
		aiSuggestionsVersion: ({ versionId: e }) => Ci({ versionId: e }),
		internalKBDashboard: () => Oi({}),
		internalKBCollection: ({ collectionId: e }) => ki({ collectionId: e }),
		internalKBArticle: ({ collectionId: e, articleId: t, languageId: n }) => ({
			path: Ai({
				collectionId: e,
				articleId: t
			}),
			search: `langId=${n}`
		}),
		helpCentersPath: () => Mi({}),
		helpCenterSettingsPath: ({ helpCenterId: e }) => Ni({ helpCenterId: e })
	};
}));
//#endregion
//#region src/components/helpCenterErrorMessage.tsx
function Ii({ errorMessage: e }) {
	return /* @__PURE__ */ I(ee, {
		title: "Something went wrong",
		description: e,
		icon: "exclamation"
	});
}
var Li = R((() => {})), Ri, zi, Bi, Vi, Hi = R((() => {
	Ri = (e, t, n) => {
		if (e && "reportValidity" in e) {
			let r = ze(n, t);
			e.setCustomValidity(r && r.message || ""), e.reportValidity();
		}
	}, zi = (e, t) => {
		for (let n in t.fields) {
			let r = t.fields[n];
			r && r.ref && "reportValidity" in r.ref ? Ri(r.ref, n, e) : r.refs && r.refs.forEach((t) => Ri(t, n, e));
		}
	}, Bi = (e, t) => {
		t.shouldUseNativeValidation && zi(e, t);
		let n = {};
		for (let r in e) {
			let i = ze(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.ref });
			if (Vi(t.names || Object.keys(e), r)) {
				let e = Object.assign({}, ze(n, r));
				Be(e, "root", a), Be(n, r, e);
			} else Be(n, r, a);
		}
		return n;
	}, Vi = (e, t) => e.some((e) => e.startsWith(t + "."));
})), Ui, Wi, Gi = R((() => {
	Hi(), Ui = function(e, t) {
		for (var n = {}; e.length;) {
			var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
			if (!n[o]) if ("unionErrors" in r) {
				var s = r.unionErrors[0].errors[0];
				n[o] = {
					message: s.message,
					type: s.code
				};
			} else n[o] = {
				message: a,
				type: i
			};
			if ("unionErrors" in r && r.unionErrors.forEach(function(t) {
				return t.errors.forEach(function(t) {
					return e.push(t);
				});
			}), t) {
				var c = n[o].types, l = c && c[r.code];
				n[o] = Re(o, t, n, i, l ? [].concat(l, r.message) : r.message);
			}
			e.shift();
		}
		return n;
	}, Wi = function(e, t, n) {
		return n === void 0 && (n = {}), function(r, i, a) {
			try {
				return Promise.resolve(function(i, o) {
					try {
						var s = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(e) {
							return a.shouldUseNativeValidation && zi({}, a), {
								errors: {},
								values: n.raw ? r : e
							};
						});
					} catch (e) {
						return o(e);
					}
					return s && s.then ? s.then(void 0, o) : s;
				}(0, function(e) {
					if (function(e) {
						return Array.isArray(e?.errors);
					}(e)) return {
						values: {},
						errors: Bi(Ui(e.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
					};
					throw e;
				}));
			} catch (e) {
				return Promise.reject(e);
			}
		};
	};
}));
//#endregion
//#region ../form/src/utils/index.ts
function Ki(e) {
	return { error: e.error?.message || void 0 };
}
var qi = R((() => {}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/_virtual/_rollupPluginBabelHelpers.js
function Ji(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Yi(e) {
	if (Array.isArray(e)) return e;
}
function Xi(e, t, n) {
	return (t = aa(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Zi(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function Qi() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $i(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ea(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? $i(Object(n), !0).forEach(function(t) {
			Xi(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $i(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ta(e, t) {
	if (e == null) return {};
	var n, r, i = na(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function na(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function ra(e, t) {
	return Yi(e) || Zi(e, t) || oa(e, t) || Qi();
}
function ia(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t);
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function aa(e) {
	var t = ia(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function oa(e, t) {
	if (e) {
		if (typeof e == "string") return Ji(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ji(e, t) : void 0;
	}
}
var sa = R((() => {}));
//#endregion
//#region ../../../node_modules/state-local/lib/es/state-local.js
function ca(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function la(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ua(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? la(Object(n), !0).forEach(function(t) {
			ca(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : la(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function da() {
	var e = [...arguments];
	return function(t) {
		return e.reduceRight(function(e, t) {
			return t(e);
		}, t);
	};
}
function fa(e) {
	return function t() {
		var n = this, r = [...arguments];
		return r.length >= e.length ? e.apply(this, r) : function() {
			var e = [...arguments];
			return t.apply(n, [].concat(r, e));
		};
	};
}
function pa(e) {
	return {}.toString.call(e).includes("Object");
}
function ma(e) {
	return !Object.keys(e).length;
}
function ha(e) {
	return typeof e == "function";
}
function ga(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
function _a(e, t) {
	return pa(t) || Ea("changeType"), Object.keys(t).some(function(t) {
		return !ga(e, t);
	}) && Ea("changeField"), t;
}
function va(e) {
	ha(e) || Ea("selectorType");
}
function ya(e) {
	ha(e) || pa(e) || Ea("handlerType"), pa(e) && Object.values(e).some(function(e) {
		return !ha(e);
	}) && Ea("handlersType");
}
function ba(e) {
	e || Ea("initialIsRequired"), pa(e) || Ea("initialType"), ma(e) && Ea("initialContent");
}
function xa(e, t) {
	throw Error(e[t] || e.default);
}
function Sa(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	Da.initial(e), Da.handler(t);
	var n = { current: e }, r = fa(Ta)(n, t), i = fa(wa)(n), a = fa(Da.changes)(e), o = fa(Ca)(n);
	function s() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(e) {
			return e;
		};
		return Da.selector(e), e(n.current);
	}
	function c(e) {
		da(r, i, a, o)(e);
	}
	return [s, c];
}
function Ca(e, t) {
	return ha(t) ? t(e.current) : t;
}
function wa(e, t) {
	return e.current = ua(ua({}, e.current), t), t;
}
function Ta(e, t, n) {
	return ha(t) ? t(e.current) : Object.keys(n).forEach(function(n) {
		return t[n]?.call(t, e.current[n]);
	}), n;
}
var Ea, Da, Oa, ka = R((() => {
	Ea = fa(xa)({
		initialIsRequired: "initial state is required",
		initialType: "initial state should be an object",
		initialContent: "initial state shouldn't be an empty object",
		handlerType: "handler should be an object or a function",
		handlersType: "all handlers should be a functions",
		selectorType: "selector should be a function",
		changeType: "provided value of changes should be an object",
		changeField: "it seams you want to change a field in the state which is not specified in the \"initial\" state",
		default: "an unknown error accured in `state-local` package"
	}), Da = {
		changes: _a,
		selector: va,
		handler: ya,
		initial: ba
	}, Oa = { create: Sa };
})), Aa, ja = R((() => {
	Aa = { paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.1/min/vs" } };
}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/utils/curry.js
function Ma(e) {
	return function t() {
		var n = this, r = [...arguments];
		return r.length >= e.length ? e.apply(this, r) : function() {
			var e = [...arguments];
			return t.apply(n, [].concat(r, e));
		};
	};
}
var Na = R((() => {}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/utils/isObject.js
function Pa(e) {
	return {}.toString.call(e).includes("Object");
}
var Fa = R((() => {}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/validators/index.js
function Ia(e) {
	return e || Ba("configIsRequired"), Pa(e) || Ba("configType"), e.urls ? (La(), { paths: { vs: e.urls.monacoBase } }) : e;
}
function La() {
	console.warn(za.deprecation);
}
function Ra(e, t) {
	throw Error(e[t] || e.default);
}
var za, Ba, Va, Ha = R((() => {
	Na(), Fa(), za = {
		configIsRequired: "the configuration object is required",
		configType: "the configuration object should be an object",
		default: "an unknown error accured in `@monaco-editor/loader` package",
		deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
	}, Ba = Ma(Ra)(za), Va = { config: Ia };
})), Ua, Wa = R((() => {
	Ua = function() {
		var e = [...arguments];
		return function(t) {
			return e.reduceRight(function(e, t) {
				return t(e);
			}, t);
		};
	};
}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/utils/deepMerge.js
function Ga(e, t) {
	return Object.keys(t).forEach(function(n) {
		t[n] instanceof Object && e[n] && Object.assign(t[n], Ga(e[n], t[n]));
	}), ea(ea({}, e), t);
}
var Ka = R((() => {
	sa();
}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/utils/makeCancelable.js
function qa(e) {
	var t = !1, n = new Promise(function(n, r) {
		e.then(function(e) {
			return t ? r(Ja) : n(e);
		}), e.catch(r);
	});
	return n.cancel = function() {
		return t = !0;
	}, n;
}
var Ja, Ya = R((() => {
	Ja = {
		type: "cancelation",
		msg: "operation is manually canceled"
	};
}));
//#endregion
//#region ../../../node_modules/@monaco-editor/loader/lib/es/loader/index.js
function Xa(e) {
	var t = Va.config(e), n = t.monaco, r = ta(t, io);
	so(function(e) {
		return {
			config: Ga(e.config, r),
			monaco: n
		};
	});
}
function Za() {
	var e = oo(function(e) {
		return {
			monaco: e.monaco,
			isInitialized: e.isInitialized,
			resolve: e.resolve
		};
	});
	if (!e.isInitialized) {
		if (so({ isInitialized: !0 }), e.monaco) return e.resolve(e.monaco), qa(co);
		if (window.monaco && window.monaco.editor) return no(window.monaco), e.resolve(window.monaco), qa(co);
		Ua(Qa, eo)(to);
	}
	return qa(co);
}
function Qa(e) {
	return document.body.appendChild(e);
}
function $a(e) {
	var t = document.createElement("script");
	return e && (t.src = e), t;
}
function eo(e) {
	var t = oo(function(e) {
		return {
			config: e.config,
			reject: e.reject
		};
	}), n = $a(`${t.config.paths.vs}/loader.js`);
	return n.onload = function() {
		return e();
	}, n.onerror = t.reject, n;
}
function to() {
	var e = oo(function(e) {
		return {
			config: e.config,
			resolve: e.resolve,
			reject: e.reject
		};
	}), t = window.require;
	t.config(e.config), t(["vs/editor/editor.main"], function(t) {
		var n = t.m || t;
		no(n), e.resolve(n);
	}, function(t) {
		e.reject(t);
	});
}
function no(e) {
	oo().monaco || so({ monaco: e });
}
function ro() {
	return oo(function(e) {
		return e.monaco;
	});
}
var io, ao, oo, so, co, lo, uo = R((() => {
	sa(), ka(), ja(), Ha(), Wa(), Ka(), Ya(), io = ["monaco"], ao = ra(Oa.create({
		config: Aa,
		isInitialized: !1,
		resolve: null,
		reject: null,
		monaco: null
	}), 2), oo = ao[0], so = ao[1], co = new Promise(function(e, t) {
		return so({
			resolve: e,
			reject: t
		});
	}), lo = {
		config: Xa,
		init: Za,
		__getMonacoInstance: ro
	};
})), fo = R((() => {
	uo();
})), po = /* @__PURE__ */ Ye({
	DiffEditor: () => No,
	Editor: () => Lo,
	default: () => Ro,
	loader: () => lo,
	useMonaco: () => Po
});
function mo({ children: e }) {
	return he.createElement("div", { style: Oo.container }, e);
}
function ho({ width: e, height: t, isEditorReady: n, loading: r, _ref: i, className: a, wrapperProps: o }) {
	return he.createElement("section", {
		style: {
			...Do.wrapper,
			width: e,
			height: t
		},
		...o
	}, !n && he.createElement(ko, null, r), he.createElement("div", {
		ref: i,
		style: {
			...Do.fullWidth,
			...!n && Do.hide
		},
		className: a
	}));
}
function go(e) {
	N(e, []);
}
function _o(e, t, n = !0) {
	let r = P(!0);
	N(r.current || !n ? () => {
		r.current = !1;
	} : e, t);
}
function vo() {}
function yo(e, t, n, r) {
	return bo(e, r) || xo(e, t, n, r);
}
function bo(e, t) {
	return e.editor.getModel(So(e, t));
}
function xo(e, t, n, r) {
	return e.editor.createModel(t, n, r ? So(e, r) : void 0);
}
function So(e, t) {
	return e.Uri.parse(t);
}
function Co({ original: e, modified: t, language: n, originalLanguage: r, modifiedLanguage: i, originalModelPath: a, modifiedModelPath: o, keepCurrentOriginalModel: s = !1, keepCurrentModifiedModel: c = !1, theme: l = "light", loading: u = "Loading...", options: d = {}, height: f = "100%", width: p = "100%", className: m, wrapperProps: h = {}, beforeMount: g = vo, onMount: _ = vo }) {
	let [v, ee] = De(!1), [y, b] = De(!0), x = P(null), S = P(null), C = P(null), w = P(_), T = P(g), E = P(!1);
	jo(() => {
		let e = lo.init();
		return e.then((e) => (S.current = e) && b(!1)).catch((e) => e?.type !== "cancelation" && console.error("Monaco initialization: error:", e)), () => x.current ? D() : e.cancel();
	}), Mo(() => {
		if (x.current && S.current) {
			let t = x.current.getOriginalEditor(), i = yo(S.current, e || "", r || n || "text", a || "");
			i !== t.getModel() && t.setModel(i);
		}
	}, [a], v), Mo(() => {
		if (x.current && S.current) {
			let e = x.current.getModifiedEditor(), r = yo(S.current, t || "", i || n || "text", o || "");
			r !== e.getModel() && e.setModel(r);
		}
	}, [o], v), Mo(() => {
		let e = x.current.getModifiedEditor();
		e.getOption(S.current.editor.EditorOption.readOnly) ? e.setValue(t || "") : t !== e.getValue() && (e.executeEdits("", [{
			range: e.getModel().getFullModelRange(),
			text: t || "",
			forceMoveMarkers: !0
		}]), e.pushUndoStop());
	}, [t], v), Mo(() => {
		x.current?.getModel()?.original.setValue(e || "");
	}, [e], v), Mo(() => {
		let { original: e, modified: t } = x.current.getModel();
		S.current.editor.setModelLanguage(e, r || n || "text"), S.current.editor.setModelLanguage(t, i || n || "text");
	}, [
		n,
		r,
		i
	], v), Mo(() => {
		S.current?.editor.setTheme(l);
	}, [l], v), Mo(() => {
		x.current?.updateOptions(d);
	}, [d], v);
	let te = M(() => {
		if (!S.current) return;
		T.current(S.current);
		let s = yo(S.current, e || "", r || n || "text", a || ""), c = yo(S.current, t || "", i || n || "text", o || "");
		x.current?.setModel({
			original: s,
			modified: c
		});
	}, [
		n,
		t,
		i,
		e,
		r,
		a,
		o
	]), ne = M(() => {
		!E.current && C.current && (x.current = S.current.editor.createDiffEditor(C.current, {
			automaticLayout: !0,
			...d
		}), te(), S.current?.editor.setTheme(l), ee(!0), E.current = !0);
	}, [
		d,
		l,
		te
	]);
	N(() => {
		v && w.current(x.current, S.current);
	}, [v]), N(() => {
		!y && !v && ne();
	}, [
		y,
		v,
		ne
	]);
	function D() {
		let e = x.current?.getModel();
		s || e?.original?.dispose(), c || e?.modified?.dispose(), x.current?.dispose();
	}
	return he.createElement(Ao, {
		width: p,
		height: f,
		isEditorReady: v,
		loading: u,
		_ref: C,
		className: m,
		wrapperProps: h
	});
}
function wo() {
	let [e, t] = De(lo.__getMonacoInstance());
	return jo(() => {
		let n;
		return e || (n = lo.init(), n.then((e) => {
			t(e);
		})), () => n?.cancel();
	}), e;
}
function To(e) {
	let t = P();
	return N(() => {
		t.current = e;
	}, [e]), t.current;
}
function Eo({ defaultValue: e, defaultLanguage: t, defaultPath: n, value: r, language: i, path: a, theme: o = "light", line: s, loading: c = "Loading...", options: l = {}, overrideServices: u = {}, saveViewState: d = !0, keepCurrentModel: f = !1, width: p = "100%", height: m = "100%", className: h, wrapperProps: g = {}, beforeMount: _ = vo, onMount: v = vo, onChange: ee, onValidate: y = vo }) {
	let [b, x] = De(!1), [S, C] = De(!0), w = P(null), T = P(null), E = P(null), te = P(v), ne = P(_), D = P(), re = P(r), ie = Fo(a), ae = P(!1), O = P(!1);
	jo(() => {
		let e = lo.init();
		return e.then((e) => (w.current = e) && C(!1)).catch((e) => e?.type !== "cancelation" && console.error("Monaco initialization: error:", e)), () => T.current ? se() : e.cancel();
	}), Mo(() => {
		let o = yo(w.current, e || r || "", t || i || "", a || n || "");
		o !== T.current?.getModel() && (d && Io.set(ie, T.current?.saveViewState()), T.current?.setModel(o), d && T.current?.restoreViewState(Io.get(a)));
	}, [a], b), Mo(() => {
		T.current?.updateOptions(l);
	}, [l], b), Mo(() => {
		!T.current || r === void 0 || (T.current.getOption(w.current.editor.EditorOption.readOnly) ? T.current.setValue(r) : r !== T.current.getValue() && (O.current = !0, T.current.executeEdits("", [{
			range: T.current.getModel().getFullModelRange(),
			text: r,
			forceMoveMarkers: !0
		}]), T.current.pushUndoStop(), O.current = !1));
	}, [r], b), Mo(() => {
		let e = T.current?.getModel();
		e && i && w.current?.editor.setModelLanguage(e, i);
	}, [i], b), Mo(() => {
		s !== void 0 && T.current?.revealLine(s);
	}, [s], b), Mo(() => {
		w.current?.editor.setTheme(o);
	}, [o], b);
	let oe = M(() => {
		if (!(!E.current || !w.current) && !ae.current) {
			ne.current(w.current);
			let c = a || n, f = yo(w.current, r || e || "", t || i || "", c || "");
			T.current = w.current?.editor.create(E.current, {
				model: f,
				automaticLayout: !0,
				...l
			}, u), d && T.current.restoreViewState(Io.get(c)), w.current.editor.setTheme(o), s !== void 0 && T.current.revealLine(s), x(!0), ae.current = !0;
		}
	}, [
		e,
		t,
		n,
		r,
		i,
		a,
		l,
		u,
		d,
		o,
		s
	]);
	N(() => {
		b && te.current(T.current, w.current);
	}, [b]), N(() => {
		!S && !b && oe();
	}, [
		S,
		b,
		oe
	]), re.current = r, N(() => {
		b && ee && (D.current?.dispose(), D.current = T.current?.onDidChangeModelContent((e) => {
			O.current || ee(T.current.getValue(), e);
		}));
	}, [b, ee]), N(() => {
		if (b) {
			let e = w.current.editor.onDidChangeMarkers((e) => {
				let t = T.current.getModel()?.uri;
				if (t && e.find((e) => e.path === t.path)) {
					let e = w.current.editor.getModelMarkers({ resource: t });
					y?.(e);
				}
			});
			return () => {
				e?.dispose();
			};
		}
		return () => {};
	}, [b, y]);
	function se() {
		D.current?.dispose(), f ? d && Io.set(a, T.current.saveViewState()) : T.current.getModel()?.dispose(), T.current.dispose();
	}
	return he.createElement(Ao, {
		width: p,
		height: m,
		isEditorReady: b,
		loading: c,
		_ref: E,
		className: h,
		wrapperProps: g
	});
}
var Do, Oo, ko, Ao, jo, Mo, No, Po, Fo, Io, Lo, Ro, zo = R((() => {
	fo(), Do = {
		wrapper: {
			display: "flex",
			position: "relative",
			textAlign: "initial"
		},
		fullWidth: { width: "100%" },
		hide: { display: "none" }
	}, Oo = { container: {
		display: "flex",
		height: "100%",
		width: "100%",
		justifyContent: "center",
		alignItems: "center"
	} }, ko = mo, Ao = Se(ho), jo = go, Mo = _o, No = Se(Co), Po = wo, Fo = To, Io = /* @__PURE__ */ new Map(), Lo = Se(Eo), Ro = Lo;
}));
//#endregion
//#region ../form/src/components/ui/lazyCodeEditor.tsx
function Bo(e) {
	let t = e.height || 240;
	return /* @__PURE__ */ I(_e, {
		fallback: /* @__PURE__ */ I(Vo, { height: t }),
		children: /* @__PURE__ */ I(Ho, { ...e })
	});
}
var Vo, Ho, Uo = R((() => {
	Vo = ({ height: e }) => /* @__PURE__ */ I(C, {
		alignItems: "center",
		justifyContent: "center",
		style: { height: `${e}px` },
		children: /* @__PURE__ */ I(ce, { bgColor: "#1e1e1e" })
	}), Ho = xe(() => Promise.resolve().then(() => (zo(), po)).then((e) => ({ default: e.Editor })));
})), Wo, Go, Ko = R((() => {
	Wo = "_editor_friuv_1", Go = { editor: Wo };
}));
//#endregion
//#region ../form/src/components/hookForm/fieldCodeEditor.tsx
function qo({ control: e, name: t, height: n = 240, label: r, language: i, description: a, required: o, setError: s, clearErrors: c }) {
	return /* @__PURE__ */ I(Le, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: l }) => /* @__PURE__ */ I(S, {
			label: r,
			required: o,
			meta: Ki(l),
			description: a,
			children: /* @__PURE__ */ I(Bo, {
				className: Go.editor,
				height: n,
				theme: "vs-dark",
				defaultLanguage: i,
				options: {
					minimap: { enabled: !1 },
					folding: !1,
					lineHeight: 20,
					formatOnPaste: !0,
					formatOnType: !0,
					padding: { top: 16 }
				},
				onMount: (e) => e.getAction("editor.action.formatDocument")?.run(),
				value: e.value,
				onChange: e.onChange,
				onValidate: (e) => {
					if (e.length) {
						let { message: n, startLineNumber: r, startColumn: i } = e[0];
						s(t, { message: `${n} at line ${r}, column ${i}` });
					} else c(t);
				}
			})
		})
	});
}
var Jo = R((() => {
	qi(), Uo(), Ko();
}));
//#endregion
//#region ../form/src/components/ui/fieldColorInput.tsx
function Yo(e) {
	return /* @__PURE__ */ L(b, {
		...e,
		colorPickerProps: { ...e.colorPickerProps },
		children: [/* @__PURE__ */ I(_.Sliders, {}), /* @__PURE__ */ I(_.Input, { onBlur: e.onBlur })]
	});
}
var Xo = R((() => {}));
//#endregion
//#region ../form/src/components/hookForm/fieldColorInput.tsx
function Zo({ label: e, control: t, name: n, disabled: r }) {
	return /* @__PURE__ */ I(Le, {
		control: t,
		name: n,
		render: ({ field: t, fieldState: n }) => {
			let { ref: i, ...a } = t, o = n.error?.message;
			return /* @__PURE__ */ I(Yo, {
				input: {
					...a,
					onChange(e) {
						e && a.onChange(e);
					},
					value: a.value
				},
				onBlur: () => a.onBlur(),
				label: e,
				meta: { error: o },
				disabled: r
			});
		}
	});
}
var Qo = R((() => {
	Xo();
}));
//#endregion
//#region ../form/src/components/hookForm/fieldInputText.tsx
function $o({ control: e, name: t, label: n, placeholder: r, required: i, description: a, disabled: o, prefix: s }) {
	return /* @__PURE__ */ I(Le, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => {
			let { ref: c, value: l = "", ...u } = e;
			return /* @__PURE__ */ I(S, {
				label: n,
				required: i,
				meta: Ki(t),
				description: a,
				noLabel: !n,
				children: /* @__PURE__ */ I(D, {
					...u,
					value: l,
					placeholder: r,
					disabled: o,
					prefix: s
				})
			});
		}
	});
}
var es = R((() => {
	qi();
})), ts = R((() => {}));
//#endregion
//#region ../form/src/components/hookForm/fieldInputTextInline.tsx
function ns({ control: e, fieldName: t, label: n, spans: r = { left: 2 } }) {
	return /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(w, {
		span: r.left,
		children: /* @__PURE__ */ I(C, {
			alignItems: "start",
			margin: "11px 0 0",
			children: /* @__PURE__ */ I(j.Paragraph, {
				variant: "3",
				subdued: !0,
				children: n
			})
		})
	}), /* @__PURE__ */ I(w, {
		span: 6 - r.left,
		children: /* @__PURE__ */ I($o, {
			control: e,
			name: t
		})
	})] });
}
var rs = R((() => {
	es();
}));
//#endregion
//#region ../form/src/components/hookForm/fieldSelectionList.tsx
function is({ control: e, name: t, label: n, required: r, description: i, itemsLoading: a, equalityFn: o, placeholders: s, listItems: c, multiple: l = !0, disabled: u }) {
	return /* @__PURE__ */ I(Le, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => /* @__PURE__ */ I(S, {
			label: n,
			required: r,
			meta: Ki(t),
			description: i,
			children: /* @__PURE__ */ I(ne, {
				multiple: l,
				value: e.value,
				onChange: (t) => e.onChange(t.selectedValues),
				disabled: a || u,
				placeholder: a ? s.loading : s.empty,
				equalityFn: o,
				getItemTitleByValue: as,
				selectionListProps: { style: {
					maxHeight: 300,
					overflow: "auto"
				} },
				children: (c || []).map((e) => /* @__PURE__ */ I(se.Item, {
					value: e,
					children: /* @__PURE__ */ I(j.Paragraph, { children: e.name })
				}, e.id))
			})
		})
	});
}
function as(e) {
	return /* @__PURE__ */ I(F, { children: e?.name });
}
var os = R((() => {
	qi();
})), ss, cs, ls, us, ds = R((() => {
	ss = "_wrapper_11awi_1", cs = "_wrapperDark_11awi_5", ls = "_marginBottom_11awi_11", us = {
		wrapper: ss,
		wrapperDark: cs,
		marginBottom: ls
	};
}));
//#endregion
//#region ../form/src/components/ui/toggleBox.tsx
function fs({ name: e, onChange: t, value: n, heading: r, subHeading: i, className: a, dark: o = !1, padding: s, disabled: c }) {
	return /* @__PURE__ */ L(C, {
		justifyContent: "flex-start",
		alignItems: "center",
		className: pe(us.wrapper, a, { [us.wrapperDark]: o }),
		gap: "300",
		children: [/* @__PURE__ */ I(le, {
			name: e,
			id: e,
			title: r,
			onChange: (e) => t(e.currentTarget.value !== "true"),
			value: n.toString(),
			checked: n,
			disabled: c
		}), /* @__PURE__ */ L(C, {
			flexDirection: "column",
			style: { padding: s || "300 0" },
			children: [/* @__PURE__ */ I(j.Paragraph, {
				variant: "1",
				className: pe({ [us.marginBottom]: !!i }),
				children: r
			}), !!i && /* @__PURE__ */ I(j.Paragraph, {
				variant: "4",
				subdued: !0,
				children: i
			})]
		})]
	});
}
var ps = R((() => {
	ds();
}));
//#endregion
//#region ../form/src/components/hookForm/fieldTogglePanel.tsx
function ms({ control: e, name: t, heading: n, subHeading: r, dark: i = !1, noAlert: a, padding: o, disabled: s = !1 }) {
	return /* @__PURE__ */ I(Le, {
		name: t,
		control: e,
		render: ({ field: e, fieldState: t }) => {
			let c = Ki(t), { ref: l, ...u } = e;
			return /* @__PURE__ */ I(S, {
				noLabel: !0,
				meta: c,
				noAlert: a,
				children: /* @__PURE__ */ I(p, {
					background: i ? "neutral.100" : void 0,
					borderRadius: "100",
					children: /* @__PURE__ */ I(fs, {
						...u,
						onChange: e.onChange,
						heading: n,
						subHeading: r,
						dark: i,
						padding: o,
						disabled: s
					})
				})
			});
		}
	});
}
var hs = R((() => {
	qi(), ps();
})), gs = R((() => {
	Jo(), Qo(), es(), ts(), rs(), os(), hs(), Uo(), ps();
}));
//#endregion
//#region ../management-common/src/hooks/usePaginatedCollections.ts
function _s({ fetchAll: e = !1, ...t } = {}) {
	let n = Nt({
		...t,
		variables: vs
	}), { fetchMore: r } = n, i = n.data?.collections.results.length ?? 0, [a, o] = De(), s = i >= 50 && i !== a, c = M(() => r({ variables: {
		offset: i,
		limit: 50
	} }).then(({ data: e }) => {
		let t = e.collections.results.length;
		t < 50 && o(i + t);
	}), [r, i]), l = P();
	return N(() => {
		!e || !s || l.current === i || (l.current = i, c().finally(() => {
			l.current === i && (l.current = void 0);
		}));
	}, [
		e,
		s,
		i,
		c
	]), {
		...n,
		hasMore: s,
		fetchNextPage: c
	};
}
var vs, ys = R((() => {
	V(), vs = {
		offset: 0,
		limit: 50
	};
}));
//#endregion
//#region ../management-common/src/components/collectionSelect.tsx
function bs({ collectionId: e, required: t, label: n = "Collection", setCollectionId: r }) {
	let { data: i, loading: a } = _s({ fetchAll: !0 }), o = Mt({
		skip: !e,
		variables: { id: e || "" }
	}), s = i?.collections.results.map(({ id: e, title: t }) => ({
		id: e,
		name: t
	})) || [];
	function c(e) {
		e && r(e?.toString());
	}
	return /* @__PURE__ */ I(x, {
		disabled: !1,
		searchable: !0,
		label: n,
		required: t,
		input: {
			name: o.data?.collection?.title || "",
			value: e || "",
			onChange: c
		},
		items: s,
		loading: a
	});
}
var xs = R((() => {
	V(), ys();
}));
//#endregion
//#region ../delivery-common/src/hooks/useDebounce.ts
function Ss(e, t) {
	let [n, r] = De(e);
	return N(() => {
		let n = setTimeout(() => r(e), t);
		return () => {
			clearTimeout(n);
		};
	}, [e, t]), n;
}
var Cs = R((() => {}));
//#endregion
//#region ../management-common/src/hooks/useCheckSubdomainAvailability.ts
function ws({ subdomain: e, initialSubdomain: t, subdomainErrorMessage: n }) {
	let { loading: r, data: i, error: a } = Zt({
		variables: { subdomain: Ss(e, 500) },
		skip: !e || e === t,
		fetchPolicy: "network-only"
	}), o = n ? [n] : [];
	return a?.graphQLErrors.length && (o = o.concat(a.graphQLErrors.map((e) => e.message))), i?.subdomainAvailability?.isAvailable === !1 && (i.subdomainAvailability.reason === Qt.Taken && o.push("Subdomain is not available"), i.subdomainAvailability.reason === Qt.NotAllowed && o.push("Subdomain is not allowed")), {
		data: i,
		errors: o,
		loading: r
	};
}
var Ts = R((() => {
	Cs(), V();
}));
//#endregion
//#region ../utils/src/hooks/useNotification.ts
function Es() {
	let e = Ce(fi);
	return {
		errorNotify: M(({ title: t = "Something went wrong", text: n, ...r }) => {
			e({
				icon: "exclamation-circle-filled",
				time: 2e3,
				status: "danger",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: t,
				text: n
			});
		}, [e]),
		successNotify: M(({ title: t, text: n, ...r }) => {
			e({
				icon: "check-circle-filled",
				time: 3e3,
				status: "success",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: t,
				text: n
			});
		}, [e]),
		notify: e
	};
}
var Ds = R((() => {})), H, Os, U, ks, As = R((() => {
	(function(e) {
		e.assertEqual = (e) => {};
		function t(e) {}
		e.assertIs = t;
		function n(e) {
			throw Error();
		}
		e.assertNever = n, e.arrayToEnum = (e) => {
			let t = {};
			for (let n of e) t[n] = n;
			return t;
		}, e.getValidEnumValues = (t) => {
			let n = e.objectKeys(t).filter((e) => typeof t[t[e]] != "number"), r = {};
			for (let e of n) r[e] = t[e];
			return e.objectValues(r);
		}, e.objectValues = (t) => e.objectKeys(t).map(function(e) {
			return t[e];
		}), e.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
			let t = [];
			for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
			return t;
		}, e.find = (e, t) => {
			for (let n of e) if (t(n)) return n;
		}, e.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e;
		function r(e, t = " | ") {
			return e.map((e) => typeof e == "string" ? `'${e}'` : e).join(t);
		}
		e.joinValues = r, e.jsonStringifyReplacer = (e, t) => typeof t == "bigint" ? t.toString() : t;
	})(H ||= {}), (function(e) {
		e.mergeShapes = (e, t) => ({
			...e,
			...t
		});
	})(Os ||= {}), U = H.arrayToEnum([
		"string",
		"nan",
		"number",
		"integer",
		"float",
		"boolean",
		"date",
		"bigint",
		"symbol",
		"function",
		"undefined",
		"null",
		"array",
		"object",
		"unknown",
		"promise",
		"void",
		"never",
		"map",
		"set"
	]), ks = (e) => {
		switch (typeof e) {
			case "undefined": return U.undefined;
			case "string": return U.string;
			case "number": return Number.isNaN(e) ? U.nan : U.number;
			case "boolean": return U.boolean;
			case "function": return U.function;
			case "bigint": return U.bigint;
			case "symbol": return U.symbol;
			case "object": return Array.isArray(e) ? U.array : e === null ? U.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? U.promise : typeof Map < "u" && e instanceof Map ? U.map : typeof Set < "u" && e instanceof Set ? U.set : typeof Date < "u" && e instanceof Date ? U.date : U.object;
			default: return U.unknown;
		}
	};
})), W, js, Ms = R((() => {
	As(), W = H.arrayToEnum([
		"invalid_type",
		"invalid_literal",
		"custom",
		"invalid_union",
		"invalid_union_discriminator",
		"invalid_enum_value",
		"unrecognized_keys",
		"invalid_arguments",
		"invalid_return_type",
		"invalid_date",
		"invalid_string",
		"too_small",
		"too_big",
		"invalid_intersection_types",
		"not_multiple_of",
		"not_finite"
	]), js = class e extends Error {
		get errors() {
			return this.issues;
		}
		constructor(e) {
			super(), this.issues = [], this.addIssue = (e) => {
				this.issues = [...this.issues, e];
			}, this.addIssues = (e = []) => {
				this.issues = [...this.issues, ...e];
			};
			let t = new.target.prototype;
			Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
		}
		format(e) {
			let t = e || function(e) {
				return e.message;
			}, n = { _errors: [] }, r = (e) => {
				for (let i of e.issues) if (i.code === "invalid_union") i.unionErrors.map(r);
				else if (i.code === "invalid_return_type") r(i.returnTypeError);
				else if (i.code === "invalid_arguments") r(i.argumentsError);
				else if (i.path.length === 0) n._errors.push(t(i));
				else {
					let e = n, r = 0;
					for (; r < i.path.length;) {
						let n = i.path[r];
						r === i.path.length - 1 ? (e[n] = e[n] || { _errors: [] }, e[n]._errors.push(t(i))) : e[n] = e[n] || { _errors: [] }, e = e[n], r++;
					}
				}
			};
			return r(this), n;
		}
		static assert(t) {
			if (!(t instanceof e)) throw Error(`Not a ZodError: ${t}`);
		}
		toString() {
			return this.message;
		}
		get message() {
			return JSON.stringify(this.issues, H.jsonStringifyReplacer, 2);
		}
		get isEmpty() {
			return this.issues.length === 0;
		}
		flatten(e = (e) => e.message) {
			let t = {}, n = [];
			for (let r of this.issues) if (r.path.length > 0) {
				let n = r.path[0];
				t[n] = t[n] || [], t[n].push(e(r));
			} else n.push(e(r));
			return {
				formErrors: n,
				fieldErrors: t
			};
		}
		get formErrors() {
			return this.flatten();
		}
	}, js.create = (e) => new js(e);
})), Ns, Ps = R((() => {
	Ms(), As(), Ns = (e, t) => {
		let n;
		switch (e.code) {
			case W.invalid_type:
				n = e.received === U.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
				break;
			case W.invalid_literal:
				n = `Invalid literal value, expected ${JSON.stringify(e.expected, H.jsonStringifyReplacer)}`;
				break;
			case W.unrecognized_keys:
				n = `Unrecognized key(s) in object: ${H.joinValues(e.keys, ", ")}`;
				break;
			case W.invalid_union:
				n = "Invalid input";
				break;
			case W.invalid_union_discriminator:
				n = `Invalid discriminator value. Expected ${H.joinValues(e.options)}`;
				break;
			case W.invalid_enum_value:
				n = `Invalid enum value. Expected ${H.joinValues(e.options)}, received '${e.received}'`;
				break;
			case W.invalid_arguments:
				n = "Invalid function arguments";
				break;
			case W.invalid_return_type:
				n = "Invalid function return type";
				break;
			case W.invalid_date:
				n = "Invalid date";
				break;
			case W.invalid_string:
				typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : H.assertNever(e.validation) : n = e.validation === "regex" ? "Invalid" : `Invalid ${e.validation}`;
				break;
			case W.too_small:
				n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
				break;
			case W.too_big:
				n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
				break;
			case W.custom:
				n = "Invalid input";
				break;
			case W.invalid_intersection_types:
				n = "Intersection results could not be merged";
				break;
			case W.not_multiple_of:
				n = `Number must be a multiple of ${e.multipleOf}`;
				break;
			case W.not_finite:
				n = "Number must be finite";
				break;
			default: n = t.defaultError, H.assertNever(e);
		}
		return { message: n };
	};
}));
//#endregion
//#region ../../../node_modules/zod/v3/errors.js
function Fs() {
	return Is;
}
var Is, Ls = R((() => {
	Ps(), Is = Ns;
}));
//#endregion
//#region ../../../node_modules/zod/v3/helpers/parseUtil.js
function G(e, t) {
	let n = Fs(), r = Rs({
		issueData: t,
		data: e.data,
		path: e.path,
		errorMaps: [
			e.common.contextualErrorMap,
			e.schemaErrorMap,
			n,
			n === Ns ? void 0 : Ns
		].filter((e) => !!e)
	});
	e.common.issues.push(r);
}
var Rs, zs, K, Bs, Vs, Hs, Us, Ws, Gs, Ks = R((() => {
	Ls(), Ps(), Rs = (e) => {
		let { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
			...i,
			path: a
		};
		if (i.message !== void 0) return {
			...i,
			path: a,
			message: i.message
		};
		let s = "", c = r.filter((e) => !!e).slice().reverse();
		for (let e of c) s = e(o, {
			data: t,
			defaultError: s
		}).message;
		return {
			...i,
			path: a,
			message: s
		};
	}, zs = class e {
		constructor() {
			this.value = "valid";
		}
		dirty() {
			this.value === "valid" && (this.value = "dirty");
		}
		abort() {
			this.value !== "aborted" && (this.value = "aborted");
		}
		static mergeArray(e, t) {
			let n = [];
			for (let r of t) {
				if (r.status === "aborted") return K;
				r.status === "dirty" && e.dirty(), n.push(r.value);
			}
			return {
				status: e.value,
				value: n
			};
		}
		static async mergeObjectAsync(t, n) {
			let r = [];
			for (let e of n) {
				let t = await e.key, n = await e.value;
				r.push({
					key: t,
					value: n
				});
			}
			return e.mergeObjectSync(t, r);
		}
		static mergeObjectSync(e, t) {
			let n = {};
			for (let r of t) {
				let { key: t, value: i } = r;
				if (t.status === "aborted" || i.status === "aborted") return K;
				t.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), t.value !== "__proto__" && (i.value !== void 0 || r.alwaysSet) && (n[t.value] = i.value);
			}
			return {
				status: e.value,
				value: n
			};
		}
	}, K = Object.freeze({ status: "aborted" }), Bs = (e) => ({
		status: "dirty",
		value: e
	}), Vs = (e) => ({
		status: "valid",
		value: e
	}), Hs = (e) => e.status === "aborted", Us = (e) => e.status === "dirty", Ws = (e) => e.status === "valid", Gs = (e) => typeof Promise < "u" && e instanceof Promise;
})), qs = R((() => {})), q, Js = R((() => {
	(function(e) {
		e.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, e.toString = (e) => typeof e == "string" ? e : e?.message;
	})(q ||= {});
}));
//#endregion
//#region ../../../node_modules/zod/v3/types.js
function J(e) {
	if (!e) return {};
	let { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
	if (t && (n || r)) throw Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
	return t ? {
		errorMap: t,
		description: i
	} : {
		errorMap: (t, i) => {
			let { message: a } = e;
			return t.code === "invalid_enum_value" ? { message: a ?? i.defaultError } : i.data === void 0 ? { message: a ?? r ?? i.defaultError } : t.code === "invalid_type" ? { message: a ?? n ?? i.defaultError } : { message: i.defaultError };
		},
		description: i
	};
}
function Ys(e) {
	let t = "[0-5]\\d";
	e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision ?? (t = `${t}(\\.\\d+)?`);
	let n = e.precision ? "+" : "?";
	return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Xs(e) {
	return RegExp(`^${Ys(e)}$`);
}
function Zs(e) {
	let t = `${Cc}T${Ys(e)}`, n = [];
	return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, RegExp(`^${t}$`);
}
function Qs(e, t) {
	return !!((t === "v4" || !t) && _c.test(e) || (t === "v6" || !t) && yc.test(e));
}
function $s(e, t) {
	if (!fc.test(e)) return !1;
	try {
		let [n] = e.split(".");
		if (!n) return !1;
		let r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
		return !(typeof i != "object" || !i || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
	} catch {
		return !1;
	}
}
function ec(e, t) {
	return !!((t === "v4" || !t) && vc.test(e) || (t === "v6" || !t) && bc.test(e));
}
function tc(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r;
	return Number.parseInt(e.toFixed(i).replace(".", "")) % Number.parseInt(t.toFixed(i).replace(".", "")) / 10 ** i;
}
function nc(e) {
	if (e instanceof Rc) {
		let t = {};
		for (let n in e.shape) {
			let r = e.shape[n];
			t[n] = el.create(nc(r));
		}
		return new Rc({
			...e._def,
			shape: () => t
		});
	} else if (e instanceof Lc) return new Lc({
		...e._def,
		type: nc(e.element)
	});
	else if (e instanceof el) return el.create(nc(e.unwrap()));
	else if (e instanceof tl) return tl.create(nc(e.unwrap()));
	else if (e instanceof Uc) return Uc.create(e.items.map((e) => nc(e)));
	else return e;
}
function rc(e, t) {
	let n = ks(e), r = ks(t);
	if (e === t) return {
		valid: !0,
		data: e
	};
	if (n === U.object && r === U.object) {
		let n = H.objectKeys(t), r = H.objectKeys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = rc(e[n], t[n]);
			if (!r.valid) return { valid: !1 };
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	} else if (n === U.array && r === U.array) {
		if (e.length !== t.length) return { valid: !1 };
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = rc(i, a);
			if (!o.valid) return { valid: !1 };
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	} else if (n === U.date && r === U.date && +e == +t) return {
		valid: !0,
		data: e
	};
	else return { valid: !1 };
}
function ic(e, t) {
	return new Xc({
		values: e,
		typeName: X.ZodEnum,
		...J(t)
	});
}
var ac, oc, Y, sc, cc, lc, uc, dc, fc, pc, mc, hc, gc, _c, vc, yc, bc, xc, Sc, Cc, wc, Tc, Ec, Dc, Oc, kc, Ac, jc, Mc, Nc, Pc, Fc, Ic, Lc, Rc, zc, Bc, Vc, Hc, Uc, Wc, Gc, Kc, qc, Jc, Yc, Xc, Zc, Qc, $c, el, tl, nl, rl, il, al, ol, sl, X, Z, cl, ll, ul, dl, fl, pl, ml = R((() => {
	Ms(), Ls(), Js(), Ks(), As(), ac = class {
		constructor(e, t, n, r) {
			this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = r;
		}
		get path() {
			return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
		}
	}, oc = (e, t) => {
		if (Ws(t)) return {
			success: !0,
			data: t.value
		};
		if (!e.common.issues.length) throw Error("Validation failed but no issues detected.");
		return {
			success: !1,
			get error() {
				if (this._error) return this._error;
				let t = new js(e.common.issues);
				return this._error = t, this._error;
			}
		};
	}, Y = class {
		get description() {
			return this._def.description;
		}
		_getType(e) {
			return ks(e.data);
		}
		_getOrReturnCtx(e, t) {
			return t || {
				common: e.parent.common,
				data: e.data,
				parsedType: ks(e.data),
				schemaErrorMap: this._def.errorMap,
				path: e.path,
				parent: e.parent
			};
		}
		_processInputParams(e) {
			return {
				status: new zs(),
				ctx: {
					common: e.parent.common,
					data: e.data,
					parsedType: ks(e.data),
					schemaErrorMap: this._def.errorMap,
					path: e.path,
					parent: e.parent
				}
			};
		}
		_parseSync(e) {
			let t = this._parse(e);
			if (Gs(t)) throw Error("Synchronous parse encountered promise.");
			return t;
		}
		_parseAsync(e) {
			let t = this._parse(e);
			return Promise.resolve(t);
		}
		parse(e, t) {
			let n = this.safeParse(e, t);
			if (n.success) return n.data;
			throw n.error;
		}
		safeParse(e, t) {
			let n = {
				common: {
					issues: [],
					async: t?.async ?? !1,
					contextualErrorMap: t?.errorMap
				},
				path: t?.path || [],
				schemaErrorMap: this._def.errorMap,
				parent: null,
				data: e,
				parsedType: ks(e)
			}, r = this._parseSync({
				data: e,
				path: n.path,
				parent: n
			});
			return oc(n, r);
		}
		"~validate"(e) {
			let t = {
				common: {
					issues: [],
					async: !!this["~standard"].async
				},
				path: [],
				schemaErrorMap: this._def.errorMap,
				parent: null,
				data: e,
				parsedType: ks(e)
			};
			if (!this["~standard"].async) try {
				let n = this._parseSync({
					data: e,
					path: [],
					parent: t
				});
				return Ws(n) ? { value: n.value } : { issues: t.common.issues };
			} catch (e) {
				e?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), t.common = {
					issues: [],
					async: !0
				};
			}
			return this._parseAsync({
				data: e,
				path: [],
				parent: t
			}).then((e) => Ws(e) ? { value: e.value } : { issues: t.common.issues });
		}
		async parseAsync(e, t) {
			let n = await this.safeParseAsync(e, t);
			if (n.success) return n.data;
			throw n.error;
		}
		async safeParseAsync(e, t) {
			let n = {
				common: {
					issues: [],
					contextualErrorMap: t?.errorMap,
					async: !0
				},
				path: t?.path || [],
				schemaErrorMap: this._def.errorMap,
				parent: null,
				data: e,
				parsedType: ks(e)
			}, r = this._parse({
				data: e,
				path: n.path,
				parent: n
			}), i = await (Gs(r) ? r : Promise.resolve(r));
			return oc(n, i);
		}
		refine(e, t) {
			let n = (e) => typeof t == "string" || t === void 0 ? { message: t } : typeof t == "function" ? t(e) : t;
			return this._refinement((t, r) => {
				let i = e(t), a = () => r.addIssue({
					code: W.custom,
					...n(t)
				});
				return typeof Promise < "u" && i instanceof Promise ? i.then((e) => e ? !0 : (a(), !1)) : i ? !0 : (a(), !1);
			});
		}
		refinement(e, t) {
			return this._refinement((n, r) => e(n) ? !0 : (r.addIssue(typeof t == "function" ? t(n, r) : t), !1));
		}
		_refinement(e) {
			return new $c({
				schema: this,
				typeName: X.ZodEffects,
				effect: {
					type: "refinement",
					refinement: e
				}
			});
		}
		superRefine(e) {
			return this._refinement(e);
		}
		constructor(e) {
			this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
				version: 1,
				vendor: "zod",
				validate: (e) => this["~validate"](e)
			};
		}
		optional() {
			return el.create(this, this._def);
		}
		nullable() {
			return tl.create(this, this._def);
		}
		nullish() {
			return this.nullable().optional();
		}
		array() {
			return Lc.create(this);
		}
		promise() {
			return Qc.create(this, this._def);
		}
		or(e) {
			return zc.create([this, e], this._def);
		}
		and(e) {
			return Hc.create(this, e, this._def);
		}
		transform(e) {
			return new $c({
				...J(this._def),
				schema: this,
				typeName: X.ZodEffects,
				effect: {
					type: "transform",
					transform: e
				}
			});
		}
		default(e) {
			let t = typeof e == "function" ? e : () => e;
			return new nl({
				...J(this._def),
				innerType: this,
				defaultValue: t,
				typeName: X.ZodDefault
			});
		}
		brand() {
			return new al({
				typeName: X.ZodBranded,
				type: this,
				...J(this._def)
			});
		}
		catch(e) {
			let t = typeof e == "function" ? e : () => e;
			return new rl({
				...J(this._def),
				innerType: this,
				catchValue: t,
				typeName: X.ZodCatch
			});
		}
		describe(e) {
			let t = this.constructor;
			return new t({
				...this._def,
				description: e
			});
		}
		pipe(e) {
			return ol.create(this, e);
		}
		readonly() {
			return sl.create(this);
		}
		isOptional() {
			return this.safeParse(void 0).success;
		}
		isNullable() {
			return this.safeParse(null).success;
		}
	}, sc = /^c[^\s-]{8,}$/i, cc = /^[0-9a-z]+$/, lc = /^[0-9A-HJKMNP-TV-Z]{26}$/i, uc = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, dc = /^[a-z0-9_-]{21}$/i, fc = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, pc = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, mc = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, hc = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", _c = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, yc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, bc = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, xc = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Sc = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Cc = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", wc = RegExp(`^${Cc}$`), Tc = class e extends Y {
		_parse(e) {
			if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== U.string) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.string,
					received: t.parsedType
				}), K;
			}
			let t = new zs(), n;
			for (let r of this._def.checks) if (r.kind === "min") e.data.length < r.value && (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.too_small,
				minimum: r.value,
				type: "string",
				inclusive: !0,
				exact: !1,
				message: r.message
			}), t.dirty());
			else if (r.kind === "max") e.data.length > r.value && (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.too_big,
				maximum: r.value,
				type: "string",
				inclusive: !0,
				exact: !1,
				message: r.message
			}), t.dirty());
			else if (r.kind === "length") {
				let i = e.data.length > r.value, a = e.data.length < r.value;
				(i || a) && (n = this._getOrReturnCtx(e, n), i ? G(n, {
					code: W.too_big,
					maximum: r.value,
					type: "string",
					inclusive: !0,
					exact: !0,
					message: r.message
				}) : a && G(n, {
					code: W.too_small,
					minimum: r.value,
					type: "string",
					inclusive: !0,
					exact: !0,
					message: r.message
				}), t.dirty());
			} else if (r.kind === "email") mc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "email",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "emoji") gc ||= new RegExp(hc, "u"), gc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "emoji",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "uuid") uc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "uuid",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "nanoid") dc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "nanoid",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "cuid") sc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "cuid",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "cuid2") cc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "cuid2",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "ulid") lc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "ulid",
				code: W.invalid_string,
				message: r.message
			}), t.dirty());
			else if (r.kind === "url") try {
				new URL(e.data);
			} catch {
				n = this._getOrReturnCtx(e, n), G(n, {
					validation: "url",
					code: W.invalid_string,
					message: r.message
				}), t.dirty();
			}
			else r.kind === "regex" ? (r.regex.lastIndex = 0, r.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "regex",
				code: W.invalid_string,
				message: r.message
			}), t.dirty())) : r.kind === "trim" ? e.data = e.data.trim() : r.kind === "includes" ? e.data.includes(r.value, r.position) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: {
					includes: r.value,
					position: r.position
				},
				message: r.message
			}), t.dirty()) : r.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : r.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : r.kind === "startsWith" ? e.data.startsWith(r.value) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: { startsWith: r.value },
				message: r.message
			}), t.dirty()) : r.kind === "endsWith" ? e.data.endsWith(r.value) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: { endsWith: r.value },
				message: r.message
			}), t.dirty()) : r.kind === "datetime" ? Zs(r).test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: "datetime",
				message: r.message
			}), t.dirty()) : r.kind === "date" ? wc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: "date",
				message: r.message
			}), t.dirty()) : r.kind === "time" ? Xs(r).test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.invalid_string,
				validation: "time",
				message: r.message
			}), t.dirty()) : r.kind === "duration" ? pc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "duration",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : r.kind === "ip" ? Qs(e.data, r.version) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "ip",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : r.kind === "jwt" ? $s(e.data, r.alg) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "jwt",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : r.kind === "cidr" ? ec(e.data, r.version) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "cidr",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : r.kind === "base64" ? xc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "base64",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : r.kind === "base64url" ? Sc.test(e.data) || (n = this._getOrReturnCtx(e, n), G(n, {
				validation: "base64url",
				code: W.invalid_string,
				message: r.message
			}), t.dirty()) : H.assertNever(r);
			return {
				status: t.value,
				value: e.data
			};
		}
		_regex(e, t, n) {
			return this.refinement((t) => e.test(t), {
				validation: t,
				code: W.invalid_string,
				...q.errToObj(n)
			});
		}
		_addCheck(t) {
			return new e({
				...this._def,
				checks: [...this._def.checks, t]
			});
		}
		email(e) {
			return this._addCheck({
				kind: "email",
				...q.errToObj(e)
			});
		}
		url(e) {
			return this._addCheck({
				kind: "url",
				...q.errToObj(e)
			});
		}
		emoji(e) {
			return this._addCheck({
				kind: "emoji",
				...q.errToObj(e)
			});
		}
		uuid(e) {
			return this._addCheck({
				kind: "uuid",
				...q.errToObj(e)
			});
		}
		nanoid(e) {
			return this._addCheck({
				kind: "nanoid",
				...q.errToObj(e)
			});
		}
		cuid(e) {
			return this._addCheck({
				kind: "cuid",
				...q.errToObj(e)
			});
		}
		cuid2(e) {
			return this._addCheck({
				kind: "cuid2",
				...q.errToObj(e)
			});
		}
		ulid(e) {
			return this._addCheck({
				kind: "ulid",
				...q.errToObj(e)
			});
		}
		base64(e) {
			return this._addCheck({
				kind: "base64",
				...q.errToObj(e)
			});
		}
		base64url(e) {
			return this._addCheck({
				kind: "base64url",
				...q.errToObj(e)
			});
		}
		jwt(e) {
			return this._addCheck({
				kind: "jwt",
				...q.errToObj(e)
			});
		}
		ip(e) {
			return this._addCheck({
				kind: "ip",
				...q.errToObj(e)
			});
		}
		cidr(e) {
			return this._addCheck({
				kind: "cidr",
				...q.errToObj(e)
			});
		}
		datetime(e) {
			return typeof e == "string" ? this._addCheck({
				kind: "datetime",
				precision: null,
				offset: !1,
				local: !1,
				message: e
			}) : this._addCheck({
				kind: "datetime",
				precision: e?.precision === void 0 ? null : e?.precision,
				offset: e?.offset ?? !1,
				local: e?.local ?? !1,
				...q.errToObj(e?.message)
			});
		}
		date(e) {
			return this._addCheck({
				kind: "date",
				message: e
			});
		}
		time(e) {
			return typeof e == "string" ? this._addCheck({
				kind: "time",
				precision: null,
				message: e
			}) : this._addCheck({
				kind: "time",
				precision: e?.precision === void 0 ? null : e?.precision,
				...q.errToObj(e?.message)
			});
		}
		duration(e) {
			return this._addCheck({
				kind: "duration",
				...q.errToObj(e)
			});
		}
		regex(e, t) {
			return this._addCheck({
				kind: "regex",
				regex: e,
				...q.errToObj(t)
			});
		}
		includes(e, t) {
			return this._addCheck({
				kind: "includes",
				value: e,
				position: t?.position,
				...q.errToObj(t?.message)
			});
		}
		startsWith(e, t) {
			return this._addCheck({
				kind: "startsWith",
				value: e,
				...q.errToObj(t)
			});
		}
		endsWith(e, t) {
			return this._addCheck({
				kind: "endsWith",
				value: e,
				...q.errToObj(t)
			});
		}
		min(e, t) {
			return this._addCheck({
				kind: "min",
				value: e,
				...q.errToObj(t)
			});
		}
		max(e, t) {
			return this._addCheck({
				kind: "max",
				value: e,
				...q.errToObj(t)
			});
		}
		length(e, t) {
			return this._addCheck({
				kind: "length",
				value: e,
				...q.errToObj(t)
			});
		}
		nonempty(e) {
			return this.min(1, q.errToObj(e));
		}
		trim() {
			return new e({
				...this._def,
				checks: [...this._def.checks, { kind: "trim" }]
			});
		}
		toLowerCase() {
			return new e({
				...this._def,
				checks: [...this._def.checks, { kind: "toLowerCase" }]
			});
		}
		toUpperCase() {
			return new e({
				...this._def,
				checks: [...this._def.checks, { kind: "toUpperCase" }]
			});
		}
		get isDatetime() {
			return !!this._def.checks.find((e) => e.kind === "datetime");
		}
		get isDate() {
			return !!this._def.checks.find((e) => e.kind === "date");
		}
		get isTime() {
			return !!this._def.checks.find((e) => e.kind === "time");
		}
		get isDuration() {
			return !!this._def.checks.find((e) => e.kind === "duration");
		}
		get isEmail() {
			return !!this._def.checks.find((e) => e.kind === "email");
		}
		get isURL() {
			return !!this._def.checks.find((e) => e.kind === "url");
		}
		get isEmoji() {
			return !!this._def.checks.find((e) => e.kind === "emoji");
		}
		get isUUID() {
			return !!this._def.checks.find((e) => e.kind === "uuid");
		}
		get isNANOID() {
			return !!this._def.checks.find((e) => e.kind === "nanoid");
		}
		get isCUID() {
			return !!this._def.checks.find((e) => e.kind === "cuid");
		}
		get isCUID2() {
			return !!this._def.checks.find((e) => e.kind === "cuid2");
		}
		get isULID() {
			return !!this._def.checks.find((e) => e.kind === "ulid");
		}
		get isIP() {
			return !!this._def.checks.find((e) => e.kind === "ip");
		}
		get isCIDR() {
			return !!this._def.checks.find((e) => e.kind === "cidr");
		}
		get isBase64() {
			return !!this._def.checks.find((e) => e.kind === "base64");
		}
		get isBase64url() {
			return !!this._def.checks.find((e) => e.kind === "base64url");
		}
		get minLength() {
			let e = null;
			for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
			return e;
		}
		get maxLength() {
			let e = null;
			for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
			return e;
		}
	}, Tc.create = (e) => new Tc({
		checks: [],
		typeName: X.ZodString,
		coerce: e?.coerce ?? !1,
		...J(e)
	}), Ec = class e extends Y {
		constructor() {
			super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
		}
		_parse(e) {
			if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== U.number) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.number,
					received: t.parsedType
				}), K;
			}
			let t, n = new zs();
			for (let r of this._def.checks) r.kind === "int" ? H.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.invalid_type,
				expected: "integer",
				received: "float",
				message: r.message
			}), n.dirty()) : r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.too_small,
				minimum: r.value,
				type: "number",
				inclusive: r.inclusive,
				exact: !1,
				message: r.message
			}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.too_big,
				maximum: r.value,
				type: "number",
				inclusive: r.inclusive,
				exact: !1,
				message: r.message
			}), n.dirty()) : r.kind === "multipleOf" ? tc(e.data, r.value) !== 0 && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.not_multiple_of,
				multipleOf: r.value,
				message: r.message
			}), n.dirty()) : r.kind === "finite" ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.not_finite,
				message: r.message
			}), n.dirty()) : H.assertNever(r);
			return {
				status: n.value,
				value: e.data
			};
		}
		gte(e, t) {
			return this.setLimit("min", e, !0, q.toString(t));
		}
		gt(e, t) {
			return this.setLimit("min", e, !1, q.toString(t));
		}
		lte(e, t) {
			return this.setLimit("max", e, !0, q.toString(t));
		}
		lt(e, t) {
			return this.setLimit("max", e, !1, q.toString(t));
		}
		setLimit(t, n, r, i) {
			return new e({
				...this._def,
				checks: [...this._def.checks, {
					kind: t,
					value: n,
					inclusive: r,
					message: q.toString(i)
				}]
			});
		}
		_addCheck(t) {
			return new e({
				...this._def,
				checks: [...this._def.checks, t]
			});
		}
		int(e) {
			return this._addCheck({
				kind: "int",
				message: q.toString(e)
			});
		}
		positive(e) {
			return this._addCheck({
				kind: "min",
				value: 0,
				inclusive: !1,
				message: q.toString(e)
			});
		}
		negative(e) {
			return this._addCheck({
				kind: "max",
				value: 0,
				inclusive: !1,
				message: q.toString(e)
			});
		}
		nonpositive(e) {
			return this._addCheck({
				kind: "max",
				value: 0,
				inclusive: !0,
				message: q.toString(e)
			});
		}
		nonnegative(e) {
			return this._addCheck({
				kind: "min",
				value: 0,
				inclusive: !0,
				message: q.toString(e)
			});
		}
		multipleOf(e, t) {
			return this._addCheck({
				kind: "multipleOf",
				value: e,
				message: q.toString(t)
			});
		}
		finite(e) {
			return this._addCheck({
				kind: "finite",
				message: q.toString(e)
			});
		}
		safe(e) {
			return this._addCheck({
				kind: "min",
				inclusive: !0,
				value: -(2 ** 53 - 1),
				message: q.toString(e)
			})._addCheck({
				kind: "max",
				inclusive: !0,
				value: 2 ** 53 - 1,
				message: q.toString(e)
			});
		}
		get minValue() {
			let e = null;
			for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
			return e;
		}
		get maxValue() {
			let e = null;
			for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
			return e;
		}
		get isInt() {
			return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && H.isInteger(e.value));
		}
		get isFinite() {
			let e = null, t = null;
			for (let n of this._def.checks) if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf") return !0;
			else n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
			return Number.isFinite(t) && Number.isFinite(e);
		}
	}, Ec.create = (e) => new Ec({
		checks: [],
		typeName: X.ZodNumber,
		coerce: e?.coerce || !1,
		...J(e)
	}), Dc = class e extends Y {
		constructor() {
			super(...arguments), this.min = this.gte, this.max = this.lte;
		}
		_parse(e) {
			if (this._def.coerce) try {
				e.data = BigInt(e.data);
			} catch {
				return this._getInvalidInput(e);
			}
			if (this._getType(e) !== U.bigint) return this._getInvalidInput(e);
			let t, n = new zs();
			for (let r of this._def.checks) r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.too_small,
				type: "bigint",
				minimum: r.value,
				inclusive: r.inclusive,
				message: r.message
			}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.too_big,
				type: "bigint",
				maximum: r.value,
				inclusive: r.inclusive,
				message: r.message
			}), n.dirty()) : r.kind === "multipleOf" ? e.data % r.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), G(t, {
				code: W.not_multiple_of,
				multipleOf: r.value,
				message: r.message
			}), n.dirty()) : H.assertNever(r);
			return {
				status: n.value,
				value: e.data
			};
		}
		_getInvalidInput(e) {
			let t = this._getOrReturnCtx(e);
			return G(t, {
				code: W.invalid_type,
				expected: U.bigint,
				received: t.parsedType
			}), K;
		}
		gte(e, t) {
			return this.setLimit("min", e, !0, q.toString(t));
		}
		gt(e, t) {
			return this.setLimit("min", e, !1, q.toString(t));
		}
		lte(e, t) {
			return this.setLimit("max", e, !0, q.toString(t));
		}
		lt(e, t) {
			return this.setLimit("max", e, !1, q.toString(t));
		}
		setLimit(t, n, r, i) {
			return new e({
				...this._def,
				checks: [...this._def.checks, {
					kind: t,
					value: n,
					inclusive: r,
					message: q.toString(i)
				}]
			});
		}
		_addCheck(t) {
			return new e({
				...this._def,
				checks: [...this._def.checks, t]
			});
		}
		positive(e) {
			return this._addCheck({
				kind: "min",
				value: BigInt(0),
				inclusive: !1,
				message: q.toString(e)
			});
		}
		negative(e) {
			return this._addCheck({
				kind: "max",
				value: BigInt(0),
				inclusive: !1,
				message: q.toString(e)
			});
		}
		nonpositive(e) {
			return this._addCheck({
				kind: "max",
				value: BigInt(0),
				inclusive: !0,
				message: q.toString(e)
			});
		}
		nonnegative(e) {
			return this._addCheck({
				kind: "min",
				value: BigInt(0),
				inclusive: !0,
				message: q.toString(e)
			});
		}
		multipleOf(e, t) {
			return this._addCheck({
				kind: "multipleOf",
				value: e,
				message: q.toString(t)
			});
		}
		get minValue() {
			let e = null;
			for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
			return e;
		}
		get maxValue() {
			let e = null;
			for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
			return e;
		}
	}, Dc.create = (e) => new Dc({
		checks: [],
		typeName: X.ZodBigInt,
		coerce: e?.coerce ?? !1,
		...J(e)
	}), Oc = class extends Y {
		_parse(e) {
			if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== U.boolean) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.boolean,
					received: t.parsedType
				}), K;
			}
			return Vs(e.data);
		}
	}, Oc.create = (e) => new Oc({
		typeName: X.ZodBoolean,
		coerce: e?.coerce || !1,
		...J(e)
	}), kc = class e extends Y {
		_parse(e) {
			if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== U.date) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.date,
					received: t.parsedType
				}), K;
			}
			if (Number.isNaN(e.data.getTime())) return G(this._getOrReturnCtx(e), { code: W.invalid_date }), K;
			let t = new zs(), n;
			for (let r of this._def.checks) r.kind === "min" ? e.data.getTime() < r.value && (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.too_small,
				message: r.message,
				inclusive: !0,
				exact: !1,
				minimum: r.value,
				type: "date"
			}), t.dirty()) : r.kind === "max" ? e.data.getTime() > r.value && (n = this._getOrReturnCtx(e, n), G(n, {
				code: W.too_big,
				message: r.message,
				inclusive: !0,
				exact: !1,
				maximum: r.value,
				type: "date"
			}), t.dirty()) : H.assertNever(r);
			return {
				status: t.value,
				value: new Date(e.data.getTime())
			};
		}
		_addCheck(t) {
			return new e({
				...this._def,
				checks: [...this._def.checks, t]
			});
		}
		min(e, t) {
			return this._addCheck({
				kind: "min",
				value: e.getTime(),
				message: q.toString(t)
			});
		}
		max(e, t) {
			return this._addCheck({
				kind: "max",
				value: e.getTime(),
				message: q.toString(t)
			});
		}
		get minDate() {
			let e = null;
			for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
			return e == null ? null : new Date(e);
		}
		get maxDate() {
			let e = null;
			for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
			return e == null ? null : new Date(e);
		}
	}, kc.create = (e) => new kc({
		checks: [],
		coerce: e?.coerce || !1,
		typeName: X.ZodDate,
		...J(e)
	}), Ac = class extends Y {
		_parse(e) {
			if (this._getType(e) !== U.symbol) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.symbol,
					received: t.parsedType
				}), K;
			}
			return Vs(e.data);
		}
	}, Ac.create = (e) => new Ac({
		typeName: X.ZodSymbol,
		...J(e)
	}), jc = class extends Y {
		_parse(e) {
			if (this._getType(e) !== U.undefined) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.undefined,
					received: t.parsedType
				}), K;
			}
			return Vs(e.data);
		}
	}, jc.create = (e) => new jc({
		typeName: X.ZodUndefined,
		...J(e)
	}), Mc = class extends Y {
		_parse(e) {
			if (this._getType(e) !== U.null) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.null,
					received: t.parsedType
				}), K;
			}
			return Vs(e.data);
		}
	}, Mc.create = (e) => new Mc({
		typeName: X.ZodNull,
		...J(e)
	}), Nc = class extends Y {
		constructor() {
			super(...arguments), this._any = !0;
		}
		_parse(e) {
			return Vs(e.data);
		}
	}, Nc.create = (e) => new Nc({
		typeName: X.ZodAny,
		...J(e)
	}), Pc = class extends Y {
		constructor() {
			super(...arguments), this._unknown = !0;
		}
		_parse(e) {
			return Vs(e.data);
		}
	}, Pc.create = (e) => new Pc({
		typeName: X.ZodUnknown,
		...J(e)
	}), Fc = class extends Y {
		_parse(e) {
			let t = this._getOrReturnCtx(e);
			return G(t, {
				code: W.invalid_type,
				expected: U.never,
				received: t.parsedType
			}), K;
		}
	}, Fc.create = (e) => new Fc({
		typeName: X.ZodNever,
		...J(e)
	}), Ic = class extends Y {
		_parse(e) {
			if (this._getType(e) !== U.undefined) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.void,
					received: t.parsedType
				}), K;
			}
			return Vs(e.data);
		}
	}, Ic.create = (e) => new Ic({
		typeName: X.ZodVoid,
		...J(e)
	}), Lc = class e extends Y {
		_parse(e) {
			let { ctx: t, status: n } = this._processInputParams(e), r = this._def;
			if (t.parsedType !== U.array) return G(t, {
				code: W.invalid_type,
				expected: U.array,
				received: t.parsedType
			}), K;
			if (r.exactLength !== null) {
				let e = t.data.length > r.exactLength.value, i = t.data.length < r.exactLength.value;
				(e || i) && (G(t, {
					code: e ? W.too_big : W.too_small,
					minimum: i ? r.exactLength.value : void 0,
					maximum: e ? r.exactLength.value : void 0,
					type: "array",
					inclusive: !0,
					exact: !0,
					message: r.exactLength.message
				}), n.dirty());
			}
			if (r.minLength !== null && t.data.length < r.minLength.value && (G(t, {
				code: W.too_small,
				minimum: r.minLength.value,
				type: "array",
				inclusive: !0,
				exact: !1,
				message: r.minLength.message
			}), n.dirty()), r.maxLength !== null && t.data.length > r.maxLength.value && (G(t, {
				code: W.too_big,
				maximum: r.maxLength.value,
				type: "array",
				inclusive: !0,
				exact: !1,
				message: r.maxLength.message
			}), n.dirty()), t.common.async) return Promise.all([...t.data].map((e, n) => r.type._parseAsync(new ac(t, e, t.path, n)))).then((e) => zs.mergeArray(n, e));
			let i = [...t.data].map((e, n) => r.type._parseSync(new ac(t, e, t.path, n)));
			return zs.mergeArray(n, i);
		}
		get element() {
			return this._def.type;
		}
		min(t, n) {
			return new e({
				...this._def,
				minLength: {
					value: t,
					message: q.toString(n)
				}
			});
		}
		max(t, n) {
			return new e({
				...this._def,
				maxLength: {
					value: t,
					message: q.toString(n)
				}
			});
		}
		length(t, n) {
			return new e({
				...this._def,
				exactLength: {
					value: t,
					message: q.toString(n)
				}
			});
		}
		nonempty(e) {
			return this.min(1, e);
		}
	}, Lc.create = (e, t) => new Lc({
		type: e,
		minLength: null,
		maxLength: null,
		exactLength: null,
		typeName: X.ZodArray,
		...J(t)
	}), Rc = class e extends Y {
		constructor() {
			super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
		}
		_getCached() {
			if (this._cached !== null) return this._cached;
			let e = this._def.shape(), t = H.objectKeys(e);
			return this._cached = {
				shape: e,
				keys: t
			}, this._cached;
		}
		_parse(e) {
			if (this._getType(e) !== U.object) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.object,
					received: t.parsedType
				}), K;
			}
			let { status: t, ctx: n } = this._processInputParams(e), { shape: r, keys: i } = this._getCached(), a = [];
			if (!(this._def.catchall instanceof Fc && this._def.unknownKeys === "strip")) for (let e in n.data) i.includes(e) || a.push(e);
			let o = [];
			for (let e of i) {
				let t = r[e], i = n.data[e];
				o.push({
					key: {
						status: "valid",
						value: e
					},
					value: t._parse(new ac(n, i, n.path, e)),
					alwaysSet: e in n.data
				});
			}
			if (this._def.catchall instanceof Fc) {
				let e = this._def.unknownKeys;
				if (e === "passthrough") for (let e of a) o.push({
					key: {
						status: "valid",
						value: e
					},
					value: {
						status: "valid",
						value: n.data[e]
					}
				});
				else if (e === "strict") a.length > 0 && (G(n, {
					code: W.unrecognized_keys,
					keys: a
				}), t.dirty());
				else if (e !== "strip") throw Error("Internal ZodObject error: invalid unknownKeys value.");
			} else {
				let e = this._def.catchall;
				for (let t of a) {
					let r = n.data[t];
					o.push({
						key: {
							status: "valid",
							value: t
						},
						value: e._parse(new ac(n, r, n.path, t)),
						alwaysSet: t in n.data
					});
				}
			}
			return n.common.async ? Promise.resolve().then(async () => {
				let e = [];
				for (let t of o) {
					let n = await t.key, r = await t.value;
					e.push({
						key: n,
						value: r,
						alwaysSet: t.alwaysSet
					});
				}
				return e;
			}).then((e) => zs.mergeObjectSync(t, e)) : zs.mergeObjectSync(t, o);
		}
		get shape() {
			return this._def.shape();
		}
		strict(t) {
			return q.errToObj, new e({
				...this._def,
				unknownKeys: "strict",
				...t === void 0 ? {} : { errorMap: (e, n) => {
					let r = this._def.errorMap?.(e, n).message ?? n.defaultError;
					return e.code === "unrecognized_keys" ? { message: q.errToObj(t).message ?? r } : { message: r };
				} }
			});
		}
		strip() {
			return new e({
				...this._def,
				unknownKeys: "strip"
			});
		}
		passthrough() {
			return new e({
				...this._def,
				unknownKeys: "passthrough"
			});
		}
		extend(t) {
			return new e({
				...this._def,
				shape: () => ({
					...this._def.shape(),
					...t
				})
			});
		}
		merge(t) {
			return new e({
				unknownKeys: t._def.unknownKeys,
				catchall: t._def.catchall,
				shape: () => ({
					...this._def.shape(),
					...t._def.shape()
				}),
				typeName: X.ZodObject
			});
		}
		setKey(e, t) {
			return this.augment({ [e]: t });
		}
		catchall(t) {
			return new e({
				...this._def,
				catchall: t
			});
		}
		pick(t) {
			let n = {};
			for (let e of H.objectKeys(t)) t[e] && this.shape[e] && (n[e] = this.shape[e]);
			return new e({
				...this._def,
				shape: () => n
			});
		}
		omit(t) {
			let n = {};
			for (let e of H.objectKeys(this.shape)) t[e] || (n[e] = this.shape[e]);
			return new e({
				...this._def,
				shape: () => n
			});
		}
		deepPartial() {
			return nc(this);
		}
		partial(t) {
			let n = {};
			for (let e of H.objectKeys(this.shape)) {
				let r = this.shape[e];
				t && !t[e] ? n[e] = r : n[e] = r.optional();
			}
			return new e({
				...this._def,
				shape: () => n
			});
		}
		required(t) {
			let n = {};
			for (let e of H.objectKeys(this.shape)) if (t && !t[e]) n[e] = this.shape[e];
			else {
				let t = this.shape[e];
				for (; t instanceof el;) t = t._def.innerType;
				n[e] = t;
			}
			return new e({
				...this._def,
				shape: () => n
			});
		}
		keyof() {
			return ic(H.objectKeys(this.shape));
		}
	}, Rc.create = (e, t) => new Rc({
		shape: () => e,
		unknownKeys: "strip",
		catchall: Fc.create(),
		typeName: X.ZodObject,
		...J(t)
	}), Rc.strictCreate = (e, t) => new Rc({
		shape: () => e,
		unknownKeys: "strict",
		catchall: Fc.create(),
		typeName: X.ZodObject,
		...J(t)
	}), Rc.lazycreate = (e, t) => new Rc({
		shape: e,
		unknownKeys: "strip",
		catchall: Fc.create(),
		typeName: X.ZodObject,
		...J(t)
	}), zc = class extends Y {
		_parse(e) {
			let { ctx: t } = this._processInputParams(e), n = this._def.options;
			function r(e) {
				for (let t of e) if (t.result.status === "valid") return t.result;
				for (let n of e) if (n.result.status === "dirty") return t.common.issues.push(...n.ctx.common.issues), n.result;
				let n = e.map((e) => new js(e.ctx.common.issues));
				return G(t, {
					code: W.invalid_union,
					unionErrors: n
				}), K;
			}
			if (t.common.async) return Promise.all(n.map(async (e) => {
				let n = {
					...t,
					common: {
						...t.common,
						issues: []
					},
					parent: null
				};
				return {
					result: await e._parseAsync({
						data: t.data,
						path: t.path,
						parent: n
					}),
					ctx: n
				};
			})).then(r);
			{
				let e, r = [];
				for (let i of n) {
					let n = {
						...t,
						common: {
							...t.common,
							issues: []
						},
						parent: null
					}, a = i._parseSync({
						data: t.data,
						path: t.path,
						parent: n
					});
					if (a.status === "valid") return a;
					a.status === "dirty" && !e && (e = {
						result: a,
						ctx: n
					}), n.common.issues.length && r.push(n.common.issues);
				}
				if (e) return t.common.issues.push(...e.ctx.common.issues), e.result;
				let i = r.map((e) => new js(e));
				return G(t, {
					code: W.invalid_union,
					unionErrors: i
				}), K;
			}
		}
		get options() {
			return this._def.options;
		}
	}, zc.create = (e, t) => new zc({
		options: e,
		typeName: X.ZodUnion,
		...J(t)
	}), Bc = (e) => e instanceof Jc ? Bc(e.schema) : e instanceof $c ? Bc(e.innerType()) : e instanceof Yc ? [e.value] : e instanceof Xc ? e.options : e instanceof Zc ? H.objectValues(e.enum) : e instanceof nl ? Bc(e._def.innerType) : e instanceof jc ? [void 0] : e instanceof Mc ? [null] : e instanceof el ? [void 0, ...Bc(e.unwrap())] : e instanceof tl ? [null, ...Bc(e.unwrap())] : e instanceof al || e instanceof sl ? Bc(e.unwrap()) : e instanceof rl ? Bc(e._def.innerType) : [], Vc = class e extends Y {
		_parse(e) {
			let { ctx: t } = this._processInputParams(e);
			if (t.parsedType !== U.object) return G(t, {
				code: W.invalid_type,
				expected: U.object,
				received: t.parsedType
			}), K;
			let n = this.discriminator, r = t.data[n], i = this.optionsMap.get(r);
			return i ? t.common.async ? i._parseAsync({
				data: t.data,
				path: t.path,
				parent: t
			}) : i._parseSync({
				data: t.data,
				path: t.path,
				parent: t
			}) : (G(t, {
				code: W.invalid_union_discriminator,
				options: Array.from(this.optionsMap.keys()),
				path: [n]
			}), K);
		}
		get discriminator() {
			return this._def.discriminator;
		}
		get options() {
			return this._def.options;
		}
		get optionsMap() {
			return this._def.optionsMap;
		}
		static create(t, n, r) {
			let i = /* @__PURE__ */ new Map();
			for (let e of n) {
				let n = Bc(e.shape[t]);
				if (!n.length) throw Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
				for (let r of n) {
					if (i.has(r)) throw Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
					i.set(r, e);
				}
			}
			return new e({
				typeName: X.ZodDiscriminatedUnion,
				discriminator: t,
				options: n,
				optionsMap: i,
				...J(r)
			});
		}
	}, Hc = class extends Y {
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e), r = (e, r) => {
				if (Hs(e) || Hs(r)) return K;
				let i = rc(e.value, r.value);
				return i.valid ? ((Us(e) || Us(r)) && t.dirty(), {
					status: t.value,
					value: i.data
				}) : (G(n, { code: W.invalid_intersection_types }), K);
			};
			return n.common.async ? Promise.all([this._def.left._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}), this._def.right._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			})]).then(([e, t]) => r(e, t)) : r(this._def.left._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			}), this._def.right._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			}));
		}
	}, Hc.create = (e, t, n) => new Hc({
		left: e,
		right: t,
		typeName: X.ZodIntersection,
		...J(n)
	}), Uc = class e extends Y {
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e);
			if (n.parsedType !== U.array) return G(n, {
				code: W.invalid_type,
				expected: U.array,
				received: n.parsedType
			}), K;
			if (n.data.length < this._def.items.length) return G(n, {
				code: W.too_small,
				minimum: this._def.items.length,
				inclusive: !0,
				exact: !1,
				type: "array"
			}), K;
			!this._def.rest && n.data.length > this._def.items.length && (G(n, {
				code: W.too_big,
				maximum: this._def.items.length,
				inclusive: !0,
				exact: !1,
				type: "array"
			}), t.dirty());
			let r = [...n.data].map((e, t) => {
				let r = this._def.items[t] || this._def.rest;
				return r ? r._parse(new ac(n, e, n.path, t)) : null;
			}).filter((e) => !!e);
			return n.common.async ? Promise.all(r).then((e) => zs.mergeArray(t, e)) : zs.mergeArray(t, r);
		}
		get items() {
			return this._def.items;
		}
		rest(t) {
			return new e({
				...this._def,
				rest: t
			});
		}
	}, Uc.create = (e, t) => {
		if (!Array.isArray(e)) throw Error("You must pass an array of schemas to z.tuple([ ... ])");
		return new Uc({
			items: e,
			typeName: X.ZodTuple,
			rest: null,
			...J(t)
		});
	}, Wc = class e extends Y {
		get keySchema() {
			return this._def.keyType;
		}
		get valueSchema() {
			return this._def.valueType;
		}
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e);
			if (n.parsedType !== U.object) return G(n, {
				code: W.invalid_type,
				expected: U.object,
				received: n.parsedType
			}), K;
			let r = [], i = this._def.keyType, a = this._def.valueType;
			for (let e in n.data) r.push({
				key: i._parse(new ac(n, e, n.path, e)),
				value: a._parse(new ac(n, n.data[e], n.path, e)),
				alwaysSet: e in n.data
			});
			return n.common.async ? zs.mergeObjectAsync(t, r) : zs.mergeObjectSync(t, r);
		}
		get element() {
			return this._def.valueType;
		}
		static create(t, n, r) {
			return n instanceof Y ? new e({
				keyType: t,
				valueType: n,
				typeName: X.ZodRecord,
				...J(r)
			}) : new e({
				keyType: Tc.create(),
				valueType: t,
				typeName: X.ZodRecord,
				...J(n)
			});
		}
	}, Gc = class extends Y {
		get keySchema() {
			return this._def.keyType;
		}
		get valueSchema() {
			return this._def.valueType;
		}
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e);
			if (n.parsedType !== U.map) return G(n, {
				code: W.invalid_type,
				expected: U.map,
				received: n.parsedType
			}), K;
			let r = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([e, t], a) => ({
				key: r._parse(new ac(n, e, n.path, [a, "key"])),
				value: i._parse(new ac(n, t, n.path, [a, "value"]))
			}));
			if (n.common.async) {
				let e = /* @__PURE__ */ new Map();
				return Promise.resolve().then(async () => {
					for (let n of a) {
						let r = await n.key, i = await n.value;
						if (r.status === "aborted" || i.status === "aborted") return K;
						(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
					}
					return {
						status: t.value,
						value: e
					};
				});
			} else {
				let e = /* @__PURE__ */ new Map();
				for (let n of a) {
					let r = n.key, i = n.value;
					if (r.status === "aborted" || i.status === "aborted") return K;
					(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
				}
				return {
					status: t.value,
					value: e
				};
			}
		}
	}, Gc.create = (e, t, n) => new Gc({
		valueType: t,
		keyType: e,
		typeName: X.ZodMap,
		...J(n)
	}), Kc = class e extends Y {
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e);
			if (n.parsedType !== U.set) return G(n, {
				code: W.invalid_type,
				expected: U.set,
				received: n.parsedType
			}), K;
			let r = this._def;
			r.minSize !== null && n.data.size < r.minSize.value && (G(n, {
				code: W.too_small,
				minimum: r.minSize.value,
				type: "set",
				inclusive: !0,
				exact: !1,
				message: r.minSize.message
			}), t.dirty()), r.maxSize !== null && n.data.size > r.maxSize.value && (G(n, {
				code: W.too_big,
				maximum: r.maxSize.value,
				type: "set",
				inclusive: !0,
				exact: !1,
				message: r.maxSize.message
			}), t.dirty());
			let i = this._def.valueType;
			function a(e) {
				let n = /* @__PURE__ */ new Set();
				for (let r of e) {
					if (r.status === "aborted") return K;
					r.status === "dirty" && t.dirty(), n.add(r.value);
				}
				return {
					status: t.value,
					value: n
				};
			}
			let o = [...n.data.values()].map((e, t) => i._parse(new ac(n, e, n.path, t)));
			return n.common.async ? Promise.all(o).then((e) => a(e)) : a(o);
		}
		min(t, n) {
			return new e({
				...this._def,
				minSize: {
					value: t,
					message: q.toString(n)
				}
			});
		}
		max(t, n) {
			return new e({
				...this._def,
				maxSize: {
					value: t,
					message: q.toString(n)
				}
			});
		}
		size(e, t) {
			return this.min(e, t).max(e, t);
		}
		nonempty(e) {
			return this.min(1, e);
		}
	}, Kc.create = (e, t) => new Kc({
		valueType: e,
		minSize: null,
		maxSize: null,
		typeName: X.ZodSet,
		...J(t)
	}), qc = class e extends Y {
		constructor() {
			super(...arguments), this.validate = this.implement;
		}
		_parse(e) {
			let { ctx: t } = this._processInputParams(e);
			if (t.parsedType !== U.function) return G(t, {
				code: W.invalid_type,
				expected: U.function,
				received: t.parsedType
			}), K;
			function n(e, n) {
				return Rs({
					data: e,
					path: t.path,
					errorMaps: [
						t.common.contextualErrorMap,
						t.schemaErrorMap,
						Fs(),
						Ns
					].filter((e) => !!e),
					issueData: {
						code: W.invalid_arguments,
						argumentsError: n
					}
				});
			}
			function r(e, n) {
				return Rs({
					data: e,
					path: t.path,
					errorMaps: [
						t.common.contextualErrorMap,
						t.schemaErrorMap,
						Fs(),
						Ns
					].filter((e) => !!e),
					issueData: {
						code: W.invalid_return_type,
						returnTypeError: n
					}
				});
			}
			let i = { errorMap: t.common.contextualErrorMap }, a = t.data;
			if (this._def.returns instanceof Qc) {
				let e = this;
				return Vs(async function(...t) {
					let o = new js([]), s = await e._def.args.parseAsync(t, i).catch((e) => {
						throw o.addIssue(n(t, e)), o;
					}), c = await Reflect.apply(a, this, s);
					return await e._def.returns._def.type.parseAsync(c, i).catch((e) => {
						throw o.addIssue(r(c, e)), o;
					});
				});
			} else {
				let e = this;
				return Vs(function(...t) {
					let o = e._def.args.safeParse(t, i);
					if (!o.success) throw new js([n(t, o.error)]);
					let s = Reflect.apply(a, this, o.data), c = e._def.returns.safeParse(s, i);
					if (!c.success) throw new js([r(s, c.error)]);
					return c.data;
				});
			}
		}
		parameters() {
			return this._def.args;
		}
		returnType() {
			return this._def.returns;
		}
		args(...t) {
			return new e({
				...this._def,
				args: Uc.create(t).rest(Pc.create())
			});
		}
		returns(t) {
			return new e({
				...this._def,
				returns: t
			});
		}
		implement(e) {
			return this.parse(e);
		}
		strictImplement(e) {
			return this.parse(e);
		}
		static create(t, n, r) {
			return new e({
				args: t || Uc.create([]).rest(Pc.create()),
				returns: n || Pc.create(),
				typeName: X.ZodFunction,
				...J(r)
			});
		}
	}, Jc = class extends Y {
		get schema() {
			return this._def.getter();
		}
		_parse(e) {
			let { ctx: t } = this._processInputParams(e);
			return this._def.getter()._parse({
				data: t.data,
				path: t.path,
				parent: t
			});
		}
	}, Jc.create = (e, t) => new Jc({
		getter: e,
		typeName: X.ZodLazy,
		...J(t)
	}), Yc = class extends Y {
		_parse(e) {
			if (e.data !== this._def.value) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					received: t.data,
					code: W.invalid_literal,
					expected: this._def.value
				}), K;
			}
			return {
				status: "valid",
				value: e.data
			};
		}
		get value() {
			return this._def.value;
		}
	}, Yc.create = (e, t) => new Yc({
		value: e,
		typeName: X.ZodLiteral,
		...J(t)
	}), Xc = class e extends Y {
		_parse(e) {
			if (typeof e.data != "string") {
				let t = this._getOrReturnCtx(e), n = this._def.values;
				return G(t, {
					expected: H.joinValues(n),
					received: t.parsedType,
					code: W.invalid_type
				}), K;
			}
			if (this._cache ||= new Set(this._def.values), !this._cache.has(e.data)) {
				let t = this._getOrReturnCtx(e), n = this._def.values;
				return G(t, {
					received: t.data,
					code: W.invalid_enum_value,
					options: n
				}), K;
			}
			return Vs(e.data);
		}
		get options() {
			return this._def.values;
		}
		get enum() {
			let e = {};
			for (let t of this._def.values) e[t] = t;
			return e;
		}
		get Values() {
			let e = {};
			for (let t of this._def.values) e[t] = t;
			return e;
		}
		get Enum() {
			let e = {};
			for (let t of this._def.values) e[t] = t;
			return e;
		}
		extract(t, n = this._def) {
			return e.create(t, {
				...this._def,
				...n
			});
		}
		exclude(t, n = this._def) {
			return e.create(this.options.filter((e) => !t.includes(e)), {
				...this._def,
				...n
			});
		}
	}, Xc.create = ic, Zc = class extends Y {
		_parse(e) {
			let t = H.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
			if (n.parsedType !== U.string && n.parsedType !== U.number) {
				let e = H.objectValues(t);
				return G(n, {
					expected: H.joinValues(e),
					received: n.parsedType,
					code: W.invalid_type
				}), K;
			}
			if (this._cache ||= new Set(H.getValidEnumValues(this._def.values)), !this._cache.has(e.data)) {
				let e = H.objectValues(t);
				return G(n, {
					received: n.data,
					code: W.invalid_enum_value,
					options: e
				}), K;
			}
			return Vs(e.data);
		}
		get enum() {
			return this._def.values;
		}
	}, Zc.create = (e, t) => new Zc({
		values: e,
		typeName: X.ZodNativeEnum,
		...J(t)
	}), Qc = class extends Y {
		unwrap() {
			return this._def.type;
		}
		_parse(e) {
			let { ctx: t } = this._processInputParams(e);
			return t.parsedType !== U.promise && t.common.async === !1 ? (G(t, {
				code: W.invalid_type,
				expected: U.promise,
				received: t.parsedType
			}), K) : Vs((t.parsedType === U.promise ? t.data : Promise.resolve(t.data)).then((e) => this._def.type.parseAsync(e, {
				path: t.path,
				errorMap: t.common.contextualErrorMap
			})));
		}
	}, Qc.create = (e, t) => new Qc({
		type: e,
		typeName: X.ZodPromise,
		...J(t)
	}), $c = class extends Y {
		innerType() {
			return this._def.schema;
		}
		sourceType() {
			return this._def.schema._def.typeName === X.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
		}
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e), r = this._def.effect || null, i = {
				addIssue: (e) => {
					G(n, e), e.fatal ? t.abort() : t.dirty();
				},
				get path() {
					return n.path;
				}
			};
			if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
				let e = r.transform(n.data, i);
				if (n.common.async) return Promise.resolve(e).then(async (e) => {
					if (t.value === "aborted") return K;
					let r = await this._def.schema._parseAsync({
						data: e,
						path: n.path,
						parent: n
					});
					return r.status === "aborted" ? K : r.status === "dirty" || t.value === "dirty" ? Bs(r.value) : r;
				});
				{
					if (t.value === "aborted") return K;
					let r = this._def.schema._parseSync({
						data: e,
						path: n.path,
						parent: n
					});
					return r.status === "aborted" ? K : r.status === "dirty" || t.value === "dirty" ? Bs(r.value) : r;
				}
			}
			if (r.type === "refinement") {
				let e = (e) => {
					let t = r.refinement(e, i);
					if (n.common.async) return Promise.resolve(t);
					if (t instanceof Promise) throw Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
					return e;
				};
				if (n.common.async === !1) {
					let r = this._def.schema._parseSync({
						data: n.data,
						path: n.path,
						parent: n
					});
					return r.status === "aborted" ? K : (r.status === "dirty" && t.dirty(), e(r.value), {
						status: t.value,
						value: r.value
					});
				} else return this._def.schema._parseAsync({
					data: n.data,
					path: n.path,
					parent: n
				}).then((n) => n.status === "aborted" ? K : (n.status === "dirty" && t.dirty(), e(n.value).then(() => ({
					status: t.value,
					value: n.value
				}))));
			}
			if (r.type === "transform") if (n.common.async === !1) {
				let e = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				if (!Ws(e)) return K;
				let a = r.transform(e.value, i);
				if (a instanceof Promise) throw Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
				return {
					status: t.value,
					value: a
				};
			} else return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((e) => Ws(e) ? Promise.resolve(r.transform(e.value, i)).then((e) => ({
				status: t.value,
				value: e
			})) : K);
			H.assertNever(r);
		}
	}, $c.create = (e, t, n) => new $c({
		schema: e,
		typeName: X.ZodEffects,
		effect: t,
		...J(n)
	}), $c.createWithPreprocess = (e, t, n) => new $c({
		schema: t,
		effect: {
			type: "preprocess",
			transform: e
		},
		typeName: X.ZodEffects,
		...J(n)
	}), el = class extends Y {
		_parse(e) {
			return this._getType(e) === U.undefined ? Vs(void 0) : this._def.innerType._parse(e);
		}
		unwrap() {
			return this._def.innerType;
		}
	}, el.create = (e, t) => new el({
		innerType: e,
		typeName: X.ZodOptional,
		...J(t)
	}), tl = class extends Y {
		_parse(e) {
			return this._getType(e) === U.null ? Vs(null) : this._def.innerType._parse(e);
		}
		unwrap() {
			return this._def.innerType;
		}
	}, tl.create = (e, t) => new tl({
		innerType: e,
		typeName: X.ZodNullable,
		...J(t)
	}), nl = class extends Y {
		_parse(e) {
			let { ctx: t } = this._processInputParams(e), n = t.data;
			return t.parsedType === U.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
				data: n,
				path: t.path,
				parent: t
			});
		}
		removeDefault() {
			return this._def.innerType;
		}
	}, nl.create = (e, t) => new nl({
		innerType: e,
		typeName: X.ZodDefault,
		defaultValue: typeof t.default == "function" ? t.default : () => t.default,
		...J(t)
	}), rl = class extends Y {
		_parse(e) {
			let { ctx: t } = this._processInputParams(e), n = {
				...t,
				common: {
					...t.common,
					issues: []
				}
			}, r = this._def.innerType._parse({
				data: n.data,
				path: n.path,
				parent: { ...n }
			});
			return Gs(r) ? r.then((e) => ({
				status: "valid",
				value: e.status === "valid" ? e.value : this._def.catchValue({
					get error() {
						return new js(n.common.issues);
					},
					input: n.data
				})
			})) : {
				status: "valid",
				value: r.status === "valid" ? r.value : this._def.catchValue({
					get error() {
						return new js(n.common.issues);
					},
					input: n.data
				})
			};
		}
		removeCatch() {
			return this._def.innerType;
		}
	}, rl.create = (e, t) => new rl({
		innerType: e,
		typeName: X.ZodCatch,
		catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
		...J(t)
	}), il = class extends Y {
		_parse(e) {
			if (this._getType(e) !== U.nan) {
				let t = this._getOrReturnCtx(e);
				return G(t, {
					code: W.invalid_type,
					expected: U.nan,
					received: t.parsedType
				}), K;
			}
			return {
				status: "valid",
				value: e.data
			};
		}
	}, il.create = (e) => new il({
		typeName: X.ZodNaN,
		...J(e)
	}), al = class extends Y {
		_parse(e) {
			let { ctx: t } = this._processInputParams(e), n = t.data;
			return this._def.type._parse({
				data: n,
				path: t.path,
				parent: t
			});
		}
		unwrap() {
			return this._def.type;
		}
	}, ol = class e extends Y {
		_parse(e) {
			let { status: t, ctx: n } = this._processInputParams(e);
			if (n.common.async) return (async () => {
				let e = await this._def.in._parseAsync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return e.status === "aborted" ? K : e.status === "dirty" ? (t.dirty(), Bs(e.value)) : this._def.out._parseAsync({
					data: e.value,
					path: n.path,
					parent: n
				});
			})();
			{
				let e = this._def.in._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return e.status === "aborted" ? K : e.status === "dirty" ? (t.dirty(), {
					status: "dirty",
					value: e.value
				}) : this._def.out._parseSync({
					data: e.value,
					path: n.path,
					parent: n
				});
			}
		}
		static create(t, n) {
			return new e({
				in: t,
				out: n,
				typeName: X.ZodPipeline
			});
		}
	}, sl = class extends Y {
		_parse(e) {
			let t = this._def.innerType._parse(e), n = (e) => (Ws(e) && (e.value = Object.freeze(e.value)), e);
			return Gs(t) ? t.then((e) => n(e)) : n(t);
		}
		unwrap() {
			return this._def.innerType;
		}
	}, sl.create = (e, t) => new sl({
		innerType: e,
		typeName: X.ZodReadonly,
		...J(t)
	}), Rc.lazycreate, (function(e) {
		e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
	})(X ||= {}), Z = Tc.create, Ec.create, il.create, Dc.create, cl = Oc.create, kc.create, Ac.create, jc.create, Mc.create, Nc.create, Pc.create, Fc.create, Ic.create, ll = Lc.create, ul = Rc.create, Rc.strictCreate, dl = zc.create, Vc.create, Hc.create, Uc.create, Wc.create, Gc.create, Kc.create, qc.create, Jc.create, fl = Yc.create, Xc.create, pl = Zc.create, Qc.create, $c.create, el.create, tl.create, $c.createWithPreprocess, ol.create;
})), hl = R((() => {
	Ls(), Ks(), qs(), As(), ml(), Ms();
})), gl = R((() => {
	hl(), hl();
})), _l, vl, yl = R((() => {
	gl(), _l = /^[a-z0-9]+(-[a-z0-9]+)*$/i, vl = ul({
		subdomain: Z().min(3, { message: "Subdomains must be at least 3 characters long" }).regex(_l, { message: "Only letters, numbers and hyphens are allowed" }),
		subdomainValidations: ll(Z()).max(0)
	});
}));
//#endregion
//#region src/components/subdomainInput.tsx
function bl({ control: e, subdomainPath: t, subdomainValidationsPath: n, subdomainAvailability: r }) {
	return /* @__PURE__ */ I(Le, {
		control: e,
		name: t,
		render: ({ field: t }) => /* @__PURE__ */ I(Le, {
			control: e,
			name: n,
			render: ({ field: e }) => /* @__PURE__ */ I(xl, {
				subdomainField: t,
				subdomainAvailability: r,
				onChangeField: e.onChange
			})
		})
	});
}
function xl({ subdomainField: e, subdomainAvailability: t, onChangeField: n }) {
	let { errors: r, loading: i, data: a } = t, o = i ? "Validating subdomain..." : void 0, s = !o && a && e.value?.length && !i && r && !r.length ? "Your domain is valid and available" : void 0, c = !o && !i && r.length ? r?.[0] : void 0;
	return N(() => {
		n(r);
	}, [r.toString()]), /* @__PURE__ */ I(S, {
		description: o,
		label: "Subdomain",
		meta: {
			error: c,
			success: s
		},
		required: !0,
		children: /* @__PURE__ */ I(D, {
			ref: e.ref,
			value: e.value,
			onChange: e.onChange,
			prefix: {
				type: "custom",
				value: "https://"
			},
			placeholder: "beautiful-avocado",
			suffix: {
				type: "custom",
				value: ".dixa.help"
			},
			required: !0
		})
	});
}
var Sl = R((() => {}));
//#endregion
//#region src/hooks/useHelpCenterCreateMutation.ts
function Cl({ onCompleted: e, onError: t }) {
	let [n, r] = Rt({
		update: (e, t) => {
			let n = e.readQuery({
				query: Nn,
				variables: { languageId: t.data?.helpCenterCreate?.translation?.languageId }
			}), r = t.data?.helpCenterCreate;
			if (!n || !r) return;
			let i = {
				...n,
				helpCenters: {
					...n.helpCenters,
					results: [{
						__typename: "HelpCenter",
						id: r.id,
						hostname: r.hostname || "",
						isActive: r.isActive ?? !1,
						collection: r.collection,
						customHostname: r.customHostname,
						name: r.name
					}, ...n.helpCenters.results]
				}
			};
			e.writeQuery({
				query: Nn,
				data: i
			});
		},
		onCompleted: e,
		onError: t
	});
	function i({ collectionId: e, defaultLanguage: t, helpCenterName: r, subdomain: i }) {
		n({ variables: {
			subdomain: i,
			name: r,
			translations: [{
				languageId: t[0].id,
				title: r,
				tagline: "Help Center"
			}],
			collectionId: e,
			defaultLanguageId: t[0].id,
			isHelpCenterIndexable: !1
		} });
	}
	return [i, r];
}
var wl = R((() => {
	V();
})), Tl, El, Dl = R((() => {
	Tl = "_noFieldLabel_m67db_1", El = { noFieldLabel: Tl };
}));
//#endregion
//#region src/modals/helpCenterAddModal.tsx
function Ol() {
	let { hideModal: e } = $r(), { errorNotify: t, successNotify: n } = Es(), r = Me(), { enabledLanguages: i } = Ce(Yr), { formState: { errors: a, isValid: o }, watch: s, control: c, handleSubmit: l } = Ve({
		resolver: Wi(kl),
		defaultValues: {
			helpCenterName: "",
			collectionId: "",
			defaultLanguage: [],
			subdomain: "",
			isHelpCenterIndexable: !1
		},
		reValidateMode: "onChange",
		mode: "all"
	}), [u, d] = Cl({
		onCompleted: (t) => {
			let i = t?.helpCenterCreate;
			i && (n({
				title: "Help Center created",
				text: `"${i.name}" has been created.`
			}), He.knowledgeHelpCenterCreated({ helpCenterId: i.id }), e(), r(Pi.helpCenterSettingsPath({ helpCenterId: i.id })));
		},
		onError: (e) => {
			throw t({
				title: "Unable to create Help Center",
				text: "Please try again. If this issue persists, please contact customer support."
			}), e;
		}
	}), f = ws({
		subdomain: s("subdomain"),
		initialSubdomain: "",
		subdomainErrorMessage: a.subdomain?.message
	}), p = d.loading || f.loading, h = i.map((e) => ({
		id: e.languageId,
		name: e.description
	})) || [];
	return /* @__PURE__ */ I(ai, { children: /* @__PURE__ */ L("form", {
		onSubmit: l(u),
		children: [
			/* @__PURE__ */ I(O, {
				title: "New Help Center",
				onClose: e
			}),
			/* @__PURE__ */ L(ie, { children: [
				/* @__PURE__ */ I($o, {
					control: c,
					label: "Name",
					name: "helpCenterName",
					required: !0
				}),
				/* @__PURE__ */ I(S, {
					noAlert: !0,
					noLabel: !0,
					required: !0,
					className: El.noFieldLabel,
					children: /* @__PURE__ */ I(Le, {
						control: c,
						name: "collectionId",
						render: ({ field: e }) => /* @__PURE__ */ I(bs, {
							collectionId: e.value,
							setCollectionId: e.onChange,
							required: !0
						})
					})
				}),
				/* @__PURE__ */ I(bl, {
					subdomainPath: "subdomain",
					subdomainValidationsPath: "subdomainValidations",
					control: c,
					subdomainAvailability: f
				}),
				/* @__PURE__ */ I(S, {
					noLabel: !0,
					required: !0,
					className: El.noFieldLabel,
					children: /* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(is, {
						control: c,
						name: "defaultLanguage",
						label: "Default language",
						itemsLoading: !1,
						placeholders: {
							loading: "Loading available languages...",
							empty: "Select default language"
						},
						equalityFn: (e, t) => e.id === t.id,
						listItems: h,
						multiple: !1,
						required: !0
					}) })
				})
			] }),
			/* @__PURE__ */ I(ae, { children: /* @__PURE__ */ L(C, {
				justifyContent: "flex-end",
				gap: "100",
				children: [/* @__PURE__ */ I(m, {
					disabled: p,
					variant: "tertiary",
					onClick: e,
					children: "Cancel"
				}), /* @__PURE__ */ I(m, {
					disabled: p || !o,
					type: "submit",
					children: "Save"
				})]
			}) })
		]
	}) });
}
var kl, Al = R((() => {
	Gi(), gs(), xs(), Xr(), Ts(), Ds(), Fi(), gl(), yl(), Sl(), wl(), Dl(), kl = ul({
		helpCenterName: Z().min(1, { message: "A name must be provided" }),
		collectionId: Z().min(1, { message: "A collection must be provided" }),
		defaultLanguage: ll(ul({
			id: Z(),
			name: Z()
		})).min(1, { message: "A default language must be provided" }),
		isHelpCenterIndexable: cl()
	}).merge(vl);
}));
//#endregion
//#region src/hooks/useHelpCenterDelete.ts
function jl({ helpCenterId: e, helpCenterTitle: t, onComplete: n }) {
	let [r, { loading: i }] = Ht({
		variables: {
			id: e,
			deregisterCustomHostname: !0
		},
		onCompleted: () => {
			a({
				title: "Deleted",
				text: `"${t}" Help Center was deleted`
			}), He.knowledgeHelpCenterDeleted({ helpCenterId: e }), n();
		},
		onError: () => {
			o({
				title: "Unable to delete",
				text: "There was an error while deleting. Please try again."
			});
		},
		update: (t, n) => {
			let r = t.readQuery({
				query: Nn,
				variables: { languageId: $t.En }
			}), i = n.data?.helpCenterDelete;
			if (!r || !i) return;
			let a = {
				...r,
				helpCenters: {
					...r.helpCenters,
					results: [...r.helpCenters.results.filter((t) => t.id !== e)]
				}
			};
			t.writeQuery({
				query: Nn,
				data: a
			});
		}
	}), { successNotify: a, errorNotify: o } = Es();
	return {
		deleteMutation: r,
		deleteLoading: i
	};
}
var Ml = R((() => {
	V(), Ds();
}));
//#endregion
//#region src/modals/helpCenterDeleteModal.tsx
function Nl({ helpCenterId: e, helpCenterTitle: t }) {
	let { hideModal: n } = $r(), { deleteMutation: r, deleteLoading: i } = jl({
		helpCenterId: e,
		helpCenterTitle: t,
		onComplete: n
	});
	return /* @__PURE__ */ L(ai, { children: [
		/* @__PURE__ */ I(O, {
			title: "Delete Help Center",
			onClose: n
		}),
		/* @__PURE__ */ I(ie, { children: /* @__PURE__ */ L(j.Paragraph, { children: [
			"Are you sure you want to permanently delete",
			" ",
			/* @__PURE__ */ L("strong", { children: [
				"“",
				t,
				"”"
			] }),
			"? This can not be undone."
		] }) }),
		/* @__PURE__ */ I(ae, { children: /* @__PURE__ */ L(C, {
			justifyContent: "flex-end",
			gap: "200",
			children: [/* @__PURE__ */ I(m, {
				disabled: i,
				variant: "tertiary",
				onClick: n,
				children: "Cancel"
			}), /* @__PURE__ */ I(m, {
				disabled: i,
				onClick: r,
				variant: "danger",
				children: "Delete"
			})]
		}) })
	] });
}
var Pl = R((() => {
	si(), Ml();
})), Fl, Il, Ll, Rl, zl, Bl, Vl, Hl, Ul, Wl, Gl = R((() => {
	Fl = "_tableWrapper_1vb1f_1", Il = "_table_1vb1f_1", Ll = "_tableRow_1vb1f_10", Rl = "_isSyncedWithElevio_1vb1f_10", zl = "_th_1vb1f_21", Bl = "_td_1vb1f_22", Vl = "_actionColumn_1vb1f_42", Hl = "_externalLink_1vb1f_46", Ul = "_internalLink_1vb1f_52", Wl = {
		tableWrapper: Fl,
		table: Il,
		tableRow: Ll,
		isSyncedWithElevio: Rl,
		th: zl,
		td: Bl,
		actionColumn: Vl,
		externalLink: Hl,
		internalLink: Ul
	};
})), Kl = /* @__PURE__ */ Ye({ default: () => ql });
function ql() {
	let { data: e, loading: t, error: n } = Xt({ fetchPolicy: "network-only" }), { showModal: r } = $r(), i = Me();
	if (n) return /* @__PURE__ */ I(p, {
		padding: "400",
		children: /* @__PURE__ */ I(Ii, { errorMessage: n.message })
	});
	if ((!e || !e.helpCenters.results.length) && !t) return /* @__PURE__ */ I(Jl, {});
	let a = e?.helpCenters.results || [];
	return /* @__PURE__ */ L(At, { children: [/* @__PURE__ */ I(At.Head, { slotLeft: /* @__PURE__ */ I(At.HeadTitle, { title: "Help centers" }) }), /* @__PURE__ */ I(At.Body, {
		padding: "400",
		children: /* @__PURE__ */ I(C, {
			flexDirection: "column",
			width: "100%",
			children: /* @__PURE__ */ I(p, {
				padding: "400",
				children: t ? /* @__PURE__ */ I(Xl, {}) : /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ L(C, {
					justifyContent: "space-between",
					alignItems: "center",
					margin: "0 0 300",
					children: [/* @__PURE__ */ L(j.Paragraph, {
						variant: "1",
						children: [
							"All Help centers",
							" ",
							/* @__PURE__ */ I(d, {
								variant: "secondary",
								size: "small",
								children: a.length
							})
						]
					}), e && /* @__PURE__ */ I(Zl, {})]
				}), /* @__PURE__ */ L(A, {
					className: Wl.table,
					children: [/* @__PURE__ */ I(A.Thead, { children: /* @__PURE__ */ L(A.Tr, { children: [
						/* @__PURE__ */ I(A.Th, { children: "Name" }),
						/* @__PURE__ */ I(A.Th, { children: "Domain" }),
						/* @__PURE__ */ I(A.Th, { children: "Collection" }),
						/* @__PURE__ */ I(A.Th, { children: "Status" }),
						/* @__PURE__ */ I(A.Th, {})
					] }) }), /* @__PURE__ */ I(A.Tbody, { children: a.map(({ id: e, name: t, isActive: n, hostname: a, customHostname: o, collection: s }) => /* @__PURE__ */ L(A.Tr, { children: [
						/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(Oe, {
							to: Pi.helpCenterSettingsPath({ helpCenterId: e }),
							className: Wl.internalLink,
							"data-testid": "help-center-link",
							children: t
						}, e) }),
						/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ L(C, {
							flexDirection: "column",
							children: [/* @__PURE__ */ I(p, { children: /* @__PURE__ */ L(j.ExternalLink, {
								href: `https://${a}`,
								target: "_blank",
								className: Wl.externalLink,
								children: [
									/* @__PURE__ */ I(E, { name: "external-link" }),
									" ",
									a
								]
							}) }), o && /* @__PURE__ */ I(p, { children: o.hostname })]
						}) }),
						/* @__PURE__ */ I(A.Td, { children: s?.title || "Not linked to a collection" }),
						/* @__PURE__ */ I(A.Td, { children: n ? /* @__PURE__ */ I(de, {
							color: "var(--dixa-color-green-500)",
							children: "Active"
						}) : /* @__PURE__ */ I(de, {
							color: "var(--dixa-color-red-500)",
							children: "Inactive"
						}) }),
						/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(C, {
							justifyContent: "flex-end",
							children: /* @__PURE__ */ I(v, {
								icon: "dots-h",
								fixed: !0,
								buttonProps: { variant: "tertiary" },
								dropdown: /* @__PURE__ */ I(F, { children: /* @__PURE__ */ L(h, { children: [/* @__PURE__ */ I(h.Item, {
									icon: "pen",
									onClick: () => i(Pi.helpCenterSettingsPath({ helpCenterId: e })),
									children: "Edit"
								}), /* @__PURE__ */ I(h.Item, {
									icon: "trash",
									onClick: () => r(Nl, {
										helpCenterId: e,
										helpCenterTitle: t || ""
									}),
									children: "Delete"
								})] }) })
							})
						}) })
					] }, e)) })]
				})] })
			})
		})
	})] });
}
function Jl() {
	return /* @__PURE__ */ L(At, { children: [/* @__PURE__ */ I(At.Head, { slotLeft: /* @__PURE__ */ I(At.Head, { slotLeft: /* @__PURE__ */ I(At.HeadTitle, { title: "Help centers" }) }) }), /* @__PURE__ */ I(At.Body, {
		padding: "400",
		children: /* @__PURE__ */ I(C, {
			padding: "400",
			width: "100%",
			justifyContent: "center",
			children: /* @__PURE__ */ I(ee, {
				size: "small",
				iconColor: "var(--dixa-typography-color-tertiary)",
				title: "No Help Centers",
				description: /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(j.Paragraph, {
					subdued: !0,
					withMarginBottom: !0,
					children: "Create your first Help Center to start sharing Knowledge with your customers. Learn more."
				}), /* @__PURE__ */ I(Zl, {})] }),
				icon: "info"
			})
		})
	})] });
}
function Yl() {
	return /* @__PURE__ */ L(A.Tr, { children: [
		/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(k, {
			height: "24px",
			width: "128px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(k, {
			height: "24px",
			width: "128px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(k, {
			height: "24px",
			width: "64px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(k, {
			height: "24px",
			width: "64px",
			animation: "wave"
		}) }),
		/* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(k, {
			height: "24px",
			width: "24px",
			animation: "wave"
		}) })
	] });
}
function Xl() {
	return /* @__PURE__ */ L(C, {
		gap: "200",
		justifyContent: "space-between",
		flexDirection: "column",
		children: [/* @__PURE__ */ I(C, {
			gap: "100",
			alignItems: "center",
			margin: "0 0 16px",
			children: /* @__PURE__ */ L(C, {
				justifyContent: "space-between",
				alignItems: "center",
				margin: "0 0 300",
				width: "100%",
				children: [/* @__PURE__ */ L(C, {
					flexDirection: "row",
					justifyContent: "center",
					alignItems: "center",
					children: [/* @__PURE__ */ I(j.Paragraph, {
						variant: "1",
						children: "All Help centers"
					}), /* @__PURE__ */ I(k, {
						borderRadius: "8px",
						height: "16px",
						width: "22px",
						animation: "wave"
					})]
				}), /* @__PURE__ */ I(k, {
					borderRadius: "4px",
					height: "28px",
					width: "96px",
					animation: "wave"
				})]
			})
		}), /* @__PURE__ */ L(A, {
			className: Wl.table,
			wrapperProps: { style: { height: "100%" } },
			children: [/* @__PURE__ */ I(A.Thead, { children: /* @__PURE__ */ L(A.Tr, { children: [
				/* @__PURE__ */ I(A.Th, { children: "Name" }),
				/* @__PURE__ */ I(A.Th, { children: "Domain" }),
				/* @__PURE__ */ I(A.Th, { children: "Collection" }),
				/* @__PURE__ */ I(A.Th, { children: "Status" }),
				/* @__PURE__ */ I(A.Th, {})
			] }) }), /* @__PURE__ */ L(A.Tbody, { children: [
				/* @__PURE__ */ I(Yl, {}),
				/* @__PURE__ */ I(Yl, {}),
				/* @__PURE__ */ I(Yl, {}),
				/* @__PURE__ */ I(Yl, {}),
				/* @__PURE__ */ I(Yl, {})
			] })]
		})]
	});
}
function Zl() {
	let { showModal: e } = $r();
	return /* @__PURE__ */ I(m, {
		onClick: () => e(Ol, {}),
		children: "New Help Center"
	});
}
var Ql = R((() => {
	V(), si(), jt(), Fi(), Li(), Al(), Pl(), Gl();
}));
//#endregion
//#region src/hooks/useHelpcenterUpdateAdvancedCustomizationMutation.ts
function $l({ onCompletedCallback: e }) {
	let { successNotify: t, errorNotify: n } = Es(), [r, { loading: i }] = Kt({
		onCompleted: (n) => {
			let r = n.helpCenterUpdate;
			r && (t({
				title: "Success",
				text: "Help center has been updated."
			}), He.knowledgeHelpCenterUpdated({ helpCenterId: r.id }), e(n));
		},
		onError: (e) => {
			n({
				title: "Unable to update Help Center",
				text: `Error saving: ${e.message}.`
			});
		},
		notifyOnNetworkStatusChange: !0
	});
	return {
		updateMutation: r,
		updateLoading: i
	};
}
var eu = R((() => {
	V(), Ds();
})), tu, nu, ru, iu, au, ou = R((() => {
	tu = "_wrapper_1j5v5_1", nu = "_header_1j5v5_7", ru = "_body_1j5v5_15", iu = "_bodyOpen_1j5v5_21", au = {
		wrapper: tu,
		header: nu,
		body: ru,
		bodyOpen: iu
	};
}));
//#endregion
//#region src/components/controls/accordion/index.tsx
function su({ children: e, title: t, icon: n, initialOpen: r }) {
	let [i, a] = De(r || !1);
	return /* @__PURE__ */ I(p, {
		className: au.wrapper,
		children: /* @__PURE__ */ I(g, {
			header: /* @__PURE__ */ I(p, {
				onClick: () => a(!i),
				children: /* @__PURE__ */ I(cu, {
					title: t,
					isOpen: i,
					icon: n
				})
			}),
			isOpen: i,
			children: /* @__PURE__ */ I(p, {
				className: pe(au.body, { [au.bodyOpen]: i }),
				children: e
			})
		})
	});
}
function cu({ title: e, icon: t, isOpen: n }) {
	let r = n ? "angle-up" : "angle-down", i = be(e) ? e : /* @__PURE__ */ L(C, {
		alignItems: "center",
		gap: "200",
		children: [t && /* @__PURE__ */ I(E, { name: t }), /* @__PURE__ */ I(j.Paragraph, {
			variant: "2",
			subdued: !0,
			children: e
		})]
	});
	return /* @__PURE__ */ L(C, {
		className: au.header,
		children: [/* @__PURE__ */ I(p, { children: i }), /* @__PURE__ */ I(E, {
			name: r,
			color: "primary"
		})]
	});
}
var lu = R((() => {
	ou();
}));
//#endregion
//#region src/components/formHeaderLoadingPlaceholder.tsx
function uu() {
	return /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(w, {
		span: 5,
		children: /* @__PURE__ */ I(S, {
			noLabel: !0,
			children: /* @__PURE__ */ I(k, {
				animation: "wave",
				width: "80px",
				height: "20px"
			})
		})
	}), /* @__PURE__ */ I(w, {
		span: 1,
		children: /* @__PURE__ */ I(S, {
			noLabel: !0,
			children: /* @__PURE__ */ I(k, {
				animation: "wave",
				width: "100%",
				height: "36px"
			})
		})
	})] });
}
var du = R((() => {})), fu, pu = R((() => {
	fu = ({ isValid: e, loading: t, label: n, disabled: r }) => /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(w, {
		span: 3,
		children: /* @__PURE__ */ I(j.Paragraph, {
			subdued: !0,
			variant: "1",
			children: n
		})
	}), /* @__PURE__ */ I(w, {
		span: 3,
		children: /* @__PURE__ */ I(C, {
			justifyContent: "flex-end",
			children: /* @__PURE__ */ I(m, {
				type: "submit",
				disabled: t || !e || r,
				isLoading: t,
				loadingIndicator: /* @__PURE__ */ I(ce, { size: 16 }),
				children: "Save Changes"
			})
		})
	})] });
})), mu, hu, gu = R((() => {
	mu = "_code_1w4at_18", hu = { code: mu };
})), _u, vu = R((() => {
	gl(), _u = ul({
		enableCustomCss: cl(),
		customCss: Z(),
		enableCustomJs: cl(),
		customJs: Z(),
		enableCustomHeaderHtml: cl(),
		customHeaderHtml: Z(),
		enableCustomFooterHtml: cl(),
		customFooterHtml: Z()
	});
}));
//#endregion
//#region src/components/advancedCustomizationForm/index.tsx
function yu({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Wt({ variables: { id: e } });
	return r ? /* @__PURE__ */ I(Ii, { errorMessage: r.message }) : !t && n && n.helpCenter ? /* @__PURE__ */ I(Su, { helpCenter: n.helpCenter }) : /* @__PURE__ */ I(bu, {});
}
function bu() {
	return /* @__PURE__ */ I("form", { children: /* @__PURE__ */ L(T, { children: [/* @__PURE__ */ I(uu, {}), Array.from([
		,
		,
		,
		,
	]).map((e, t) => /* @__PURE__ */ L(ge, { children: [/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(S, {
		noLabel: !0,
		children: /* @__PURE__ */ I(k, {
			animation: "wave",
			width: "100%",
			height: "72px"
		})
	}) }), /* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
		noLabel: !0,
		children: [/* @__PURE__ */ I(k, {
			height: "16px",
			width: "64px",
			animation: "wave",
			margin: "0 0 8px"
		}), /* @__PURE__ */ I(k, {
			height: "240px",
			width: "100%",
			animation: "wave"
		})]
	}) })] }, t))] }) });
}
function xu({ css: e, js: t, headerHtml: n, footerHtml: r }) {
	return {
		enableCustomCss: e.enabled || !1,
		customCss: e.value || "",
		enableCustomJs: t.enabled || !1,
		customJs: t.value || "",
		enableCustomHeaderHtml: n.enabled || !1,
		customHeaderHtml: n.value || "",
		enableCustomFooterHtml: r.enabled || !1,
		customFooterHtml: r.value || ""
	};
}
function Su({ helpCenter: e }) {
	let { id: t, themeCustomization: n } = e, { control: r, formState: { isValid: i, isDirty: a }, handleSubmit: o, reset: s, setError: c, clearErrors: l } = Ve({
		resolver: Wi(_u),
		defaultValues: xu(n),
		reValidateMode: "onChange",
		mode: "all"
	}), u = {
		setError: c,
		clearErrors: l
	}, { updateLoading: d, updateMutation: f } = $l({ onCompletedCallback: (e) => {
		e.helpCenterUpdate && s(xu(e.helpCenterUpdate.themeCustomization));
	} });
	function p(e) {
		let { enableCustomCss: n, customCss: r, enableCustomJs: i, customJs: a, enableCustomHeaderHtml: o, customHeaderHtml: s, enableCustomFooterHtml: c, customFooterHtml: l } = e;
		f({ variables: {
			helpCenterId: t,
			themeCustomization: {
				css: {
					enabled: n,
					value: r
				},
				js: {
					enabled: i,
					value: a
				},
				headerHtml: {
					enabled: o,
					value: s
				},
				footerHtml: {
					enabled: c,
					value: l
				}
			}
		} });
	}
	return /* @__PURE__ */ I("form", {
		onSubmit: o(p),
		children: /* @__PURE__ */ L(T, { children: [
			/* @__PURE__ */ I(fu, {
				label: "Advanced",
				loading: d,
				isValid: i,
				disabled: !a
			}),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: r,
				name: "enableCustomCss",
				heading: "Enable Custom CSS",
				subHeading: "Customise your Help Center’s look & feel with custom CSS.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(qo, {
				control: r,
				name: "customCss",
				label: "Custom CSS",
				language: "css",
				...u
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: r,
				name: "enableCustomJs",
				heading: "Enable Custom JS",
				subHeading: "Customise your Help Center’s functionality with custom javascript.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(qo, {
				control: r,
				name: "customJs",
				label: "Custom JS",
				language: "javascript",
				...u
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: r,
				name: "enableCustomHeaderHtml",
				heading: "Enable Custom Header HTML",
				subHeading: "Replace your Help Center’s header with custom HTML.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ L(w, { children: [/* @__PURE__ */ I(qo, {
				control: r,
				name: "customHeaderHtml",
				label: "Custom Header HTML",
				language: "html",
				...u
			}), /* @__PURE__ */ I(su, {
				icon: "info",
				title: "Custom Header HTML tips",
				initialOpen: !1,
				children: /* @__PURE__ */ I(Cu, { name: "Header" })
			})] }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: r,
				name: "enableCustomFooterHtml",
				heading: "Enable Custom Footer HTML",
				subHeading: "Replace your Help Center’s footer with custom HTML.",
				noAlert: !0,
				dark: !0
			}) }),
			/* @__PURE__ */ L(w, { children: [/* @__PURE__ */ I(qo, {
				control: r,
				name: "customFooterHtml",
				label: "Custom Footer HTML",
				language: "html",
				...u
			}), /* @__PURE__ */ I(su, {
				icon: "info",
				title: "Custom Footer HTML tips",
				initialOpen: !1,
				children: /* @__PURE__ */ I(Cu, { name: "Footer" })
			})] })
		] })
	});
}
function Cu({ name: e }) {
	let { enabledLanguages: t } = Ce(Yr), n = /* @__PURE__ */ I(F, { children: t.map((e, n) => /* @__PURE__ */ L(ge, { children: [/* @__PURE__ */ I("code", { children: e.languageId }), n === t.length - 1 ? "" : ", "] }, e.languageId)) });
	return /* @__PURE__ */ L(p, {
		className: hu.code,
		children: [
			/* @__PURE__ */ L(j.Paragraph, { children: [
				`In the Custom ${e} HTML input, you can use the following `,
				/* @__PURE__ */ I(j.ExternalLink, {
					href: "https://liquidjs.com/tutorials/intro-to-liquid.html",
					target: "_blank",
					rel: "noopener noreferrer",
					children: "LiquidJS"
				}),
				` "templating" to insert dynamic elements specific to the ${e.toLowerCase()}:`
			] }),
			/* @__PURE__ */ L("ul", { children: [
				/* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "{% site_title %}" }), " - This will be replaced with the title of your site."] }) }),
				/* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "{% site_tagline %}" }), " - This will be replaced with the tagline of your site."] }) }),
				/* @__PURE__ */ L("li", { children: [
					/* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "{% search_input %}" }), " - This will insert a search input field."] }),
					/* @__PURE__ */ I(j.Paragraph, { children: "You can customize this tag further with the following optional \"filters\" that can optionally be multi-line separated separated, here's some examples:" }),
					/* @__PURE__ */ L("ul", { children: [
						/* @__PURE__ */ L("li", { children: [/* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "placeholder: \"Your name here...\"" }), " - Specify the placeholder text for the search input."] }), /* @__PURE__ */ I(f, {
							variant: "announcement",
							description: /* @__PURE__ */ L(j.Paragraph, { children: [
								/* @__PURE__ */ I("strong", { children: "Note:" }),
								" ",
								/* @__PURE__ */ I("code", { children: "placeholder" }),
								" is a fallback and will be overridden by other language specific placeholders if available, see below"
							] })
						})] }),
						/* @__PURE__ */ L("li", { children: [
							/* @__PURE__ */ I(j.Paragraph, { children: "Language specific placeholders are also supported by specifying the language code as a prefix, examples:" }),
							/* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "en: \"Search...\"" }), " - English output"] }),
							/* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "de: \"Suche...\"" }), " - German output"] }),
							/* @__PURE__ */ L(j.Paragraph, { children: ["Your organisation currently has the following language codes enabled:", " "] }),
							/* @__PURE__ */ I(j.Paragraph, { children: n })
						] }),
						/* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(j.Paragraph, { children: [/* @__PURE__ */ I("code", { children: "inputClass: \"searchBar\"" }), " - Add additional CSS classes to the search input element."] }) }),
						/* @__PURE__ */ I("li", { children: /* @__PURE__ */ L(j.Paragraph, { children: [
							/* @__PURE__ */ I("code", { children: "unstyled: true" }),
							" - Output a pure html input with no styling, see example below. Setting to ",
							/* @__PURE__ */ I("code", { children: "false" }),
							" or completely omitting the flag will output a Dixa styled search input instead."
						] }) })
					] })
				] })
			] }),
			/* @__PURE__ */ I(j.Paragraph, { children: "Example 1:" }),
			/* @__PURE__ */ I("pre", {
				style: { overflowX: "auto" },
				children: "<div>\n  {%\n    search_input\n    inputClass: \"custom\"\n    placeholder: \"Search...\"\n    unstyled: true\n  %}\n</div>"
			}),
			/* @__PURE__ */ I(j.Paragraph, { children: "Outputs a plain unstyled html input:" }),
			/* @__PURE__ */ I("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Search...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ I("br", {}),
			/* @__PURE__ */ I(j.Paragraph, { children: "Example 2 (multi language):" }),
			/* @__PURE__ */ I("pre", {
				style: { overflowX: "auto" },
				children: "<div>\n  {%\n    search_input\n    inputClass: \"custom\"\n    en: \"Search...\"\n    de: \"Suche...\"\n    unstyled: false\n  %}\n</div>"
			}),
			/* @__PURE__ */ L(j.Paragraph, { children: [
				"Outputs a plain unstyled html input if your language is ",
				/* @__PURE__ */ I("code", { children: "/de" }),
				":"
			] }),
			/* @__PURE__ */ I("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Suche...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ L(j.Paragraph, { children: [
				"And if your language is ",
				/* @__PURE__ */ I("code", { children: "/en" }),
				":"
			] }),
			/* @__PURE__ */ I("pre", { children: "<div>\n  <input\n    type=\"text\"\n    class=\"search-input custom\"\n    placeholder=\"Search...\"\n    name=\"q\"\n  />\n</div>" }),
			/* @__PURE__ */ L(j.Paragraph, { children: [
				"Please make sure to include the necessary HTML tags to structure your",
				" ",
				e.toLowerCase(),
				" properly. You can use any valid HTML along with the LiquidJS tags listed above."
			] }),
			/* @__PURE__ */ L(j.Paragraph, { children: [
				"For more details on LiquidJS templating syntax, you can refer to the",
				" ",
				/* @__PURE__ */ I(j.ExternalLink, {
					href: "https://liquidjs.com/tutorials/intro-to-liquid.html",
					target: "_blank",
					rel: "noopener noreferrer",
					children: "LiquidJS documentation"
				}),
				"."
			] })
		]
	});
}
var wu = R((() => {
	Gi(), gs(), Xr(), V(), eu(), lu(), du(), Li(), pu(), gu(), vu();
})), Tu, Eu, Du, Ou = R((() => {
	Tu = "_fieldSet_2u3fk_1", Eu = "_fieldSetLegend_2u3fk_11", Du = {
		fieldSet: Tu,
		fieldSetLegend: Eu
	};
}));
//#endregion
//#region ../management-common/src/components/fieldSet/index.tsx
function ku({ children: e, legend: t, classNames: n }) {
	return /* @__PURE__ */ L("fieldset", {
		className: pe(Du.fieldSet, n?.fieldset),
		children: [/* @__PURE__ */ I("legend", {
			className: pe(Du.fieldSetLegend, n?.legend),
			children: /* @__PURE__ */ I(j.Paragraph, {
				variant: "3",
				subdued: !0,
				className: n?.legendText,
				children: t
			})
		}), e]
	});
}
var Au = R((() => {
	Ou();
}));
//#endregion
//#region ../../../node_modules/react-use/esm/useMountedState.js
function ju() {
	var e = P(!1), t = M(function() {
		return e.current;
	}, []);
	return N(function() {
		return e.current = !0, function() {
			e.current = !1;
		};
	}, []), t;
}
var Mu = R((() => {})), Nu, Pu = R((() => {
	Nu = function(e) {
		e === void 0 && (e = {});
		var t = De(e), n = t[0], r = t[1];
		return [n, M(function(e) {
			r(function(t) {
				return Object.assign({}, t, e instanceof Function ? e(t) : e);
			});
		}, [])];
	};
})), Fu = /* @__PURE__ */ z(((e, t) => {
	t.exports = function() {
		var e = document.getSelection();
		if (!e.rangeCount) return function() {};
		for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++) n.push(e.getRangeAt(r));
		switch (t.tagName.toUpperCase()) {
			case "INPUT":
			case "TEXTAREA":
				t.blur();
				break;
			default:
				t = null;
				break;
		}
		return e.removeAllRanges(), function() {
			e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(t) {
				e.addRange(t);
			}), t && t.focus();
		};
	};
})), Iu = /* @__PURE__ */ z(((e, t) => {
	var n = Fu(), r = {
		"text/plain": "Text",
		"text/html": "Url",
		default: "Text"
	}, i = "Copy to clipboard: #{key}, Enter";
	function a(e) {
		var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
		return e.replace(/#{\s*key\s*}/g, t);
	}
	function o(e, t) {
		var o, s, c, l, u, d, f = !1;
		t ||= {}, o = t.debug || !1;
		try {
			if (c = n(), l = document.createRange(), u = document.getSelection(), d = document.createElement("span"), d.textContent = e, d.ariaHidden = "true", d.style.all = "unset", d.style.position = "fixed", d.style.top = 0, d.style.clip = "rect(0, 0, 0, 0)", d.style.whiteSpace = "pre", d.style.webkitUserSelect = "text", d.style.MozUserSelect = "text", d.style.msUserSelect = "text", d.style.userSelect = "text", d.addEventListener("copy", function(n) {
				if (n.stopPropagation(), t.format) if (n.preventDefault(), n.clipboardData === void 0) {
					o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
					var i = r[t.format] || r.default;
					window.clipboardData.setData(i, e);
				} else n.clipboardData.clearData(), n.clipboardData.setData(t.format, e);
				t.onCopy && (n.preventDefault(), t.onCopy(n.clipboardData));
			}), document.body.appendChild(d), l.selectNodeContents(d), u.addRange(l), !document.execCommand("copy")) throw Error("copy command was unsuccessful");
			f = !0;
		} catch (n) {
			o && console.error("unable to copy using execCommand: ", n), o && console.warn("trying IE specific stuff");
			try {
				window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), f = !0;
			} catch (n) {
				o && console.error("unable to copy using clipboardData: ", n), o && console.error("falling back to prompt"), s = a("message" in t ? t.message : i), window.prompt(s, e);
			}
		} finally {
			u && (typeof u.removeRange == "function" ? u.removeRange(l) : u.removeAllRanges()), d && document.body.removeChild(d), c();
		}
		return f;
	}
	t.exports = o;
})), Lu, Ru, zu = R((() => {
	Lu = /* @__PURE__ */ Ze(Iu()), Mu(), Pu(), Ru = function() {
		var e = ju(), t = Nu({
			value: void 0,
			error: void 0,
			noUserInteraction: !0
		}), n = t[0], r = t[1];
		return [n, M(function(t) {
			if (e()) {
				var n, i;
				try {
					if (typeof t != "string" && typeof t != "number") {
						var a = /* @__PURE__ */ Error("Cannot copy typeof " + typeof t + " to clipboard, must be a string");
						process.env.NODE_ENV === "development" && console.error(a), r({
							value: t,
							error: a,
							noUserInteraction: !0
						});
						return;
					} else if (t === "") {
						var a = /* @__PURE__ */ Error("Cannot copy empty string to clipboard.");
						process.env.NODE_ENV === "development" && console.error(a), r({
							value: t,
							error: a,
							noUserInteraction: !0
						});
						return;
					}
					i = t.toString(), n = (0, Lu.default)(i), r({
						value: i,
						error: void 0,
						noUserInteraction: n
					});
				} catch (e) {
					r({
						value: i,
						error: e,
						noUserInteraction: n
					});
				}
			}
		}, [])];
	};
})), Bu = /* @__PURE__ */ z(((e, t) => {
	t.exports = { ...me };
})), Vu = R((() => {
	Mu(), Pu(), zu();
}));
//#endregion
//#region ../utils/src/hooks/useCopyToClipboard.ts
function Hu(e) {
	let [t, n] = Ru(), [r, i] = De(!1);
	return N(() => {
		let n = null;
		return t.value && (i(!0), n = setTimeout(() => {
			i(!1);
		}, e ?? Uu)), () => {
			n && clearTimeout(n);
		};
	}, [t, e]), {
		clipboard: t,
		setClipboard: n,
		timedClipboardIndicator: r
	};
}
var Uu, Wu = R((() => {
	Vu(), Uu = 3e3;
})), Gu, Ku, qu, Ju, Yu, Xu, Zu = R((() => {
	Gu = "_formField_1bcx8_1", Ku = "_fieldSet_1bcx8_5", qu = "_pre_1bcx8_10", Ju = "_copyIcon_1bcx8_18", Yu = "_copied_1bcx8_22", Xu = {
		formField: Gu,
		fieldSet: Ku,
		pre: qu,
		copyIcon: Ju,
		copied: Yu
	};
})), Qu, $u = R((() => {
	gl(), Qu = ul({ customHostname: Z().min(1, "Hostname is required").refine((e) => /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*\.[A-Za-z]{2,}$/.test(e), { message: "Invalid hostname format. Only a domain name (with optional subdomain) is allowed." }) });
}));
//#endregion
//#region src/components/customHostnameForm/customHostnameFormContent.tsx
function ed({ helpCenterId: e, isActive: t }) {
	let { data: n } = zt({
		variables: { id: e },
		skip: !t
	});
	return n?.helpCenter?.customHostname ? /* @__PURE__ */ I(nd, {
		helpCenterId: e,
		customHostname: n.helpCenter.customHostname
	}) : /* @__PURE__ */ I(td, { helpCenterId: e });
}
function td({ helpCenterId: e }) {
	let { errorNotify: t, successNotify: n } = Es(), { formState: { submitCount: r, isValid: i }, handleSubmit: a, control: o } = Ve({
		defaultValues: { customHostname: "" },
		resolver: Wi(Qu),
		mode: "all",
		reValidateMode: "onChange"
	}), [s, { loading: c }] = Gt({
		onCompleted: () => {
			n({
				title: "Success",
				text: "Custom hostname successfully added"
			});
		},
		onError: (e) => {
			throw t({
				title: "Unable to register custom hostname",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), l = (t) => {
		s({ variables: {
			id: e,
			customHostname: t.customHostname
		} });
	}, u = c || !!r && !i;
	return /* @__PURE__ */ I("form", {
		onSubmit: a(l),
		children: /* @__PURE__ */ L(T, { children: [/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I($o, {
			control: o,
			name: "customHostname",
			label: "Custom hostname URL",
			description: "A URL must be a valid format. Do not start with 'https://' or 'http://'",
			placeholder: "yoursite.com",
			prefix: "https://"
		}) }), /* @__PURE__ */ L(w, {
			span: 6,
			children: [/* @__PURE__ */ I(m, {
				onClick: a(l),
				disabled: u,
				isLoading: c,
				loadingIndicator: /* @__PURE__ */ L(C, {
					gap: "200",
					children: [/* @__PURE__ */ I(ce, { size: 16 }), /* @__PURE__ */ I(j.Paragraph, {
						variant: "3",
						as: "span",
						style: { color: "unset" },
						children: "Registering..."
					})]
				}),
				children: "Register"
			}), c && /* @__PURE__ */ I(j.Paragraph, {
				variant: "4",
				subdued: !0,
				margin: "100 0 0",
				children: "(this may take some time)"
			})]
		})] })
	});
}
function nd({ customHostname: e, helpCenterId: t }) {
	let { errorNotify: n, successNotify: r } = Es(), { loading: i, refetch: a } = zt({
		variables: { id: t },
		notifyOnNetworkStatusChange: !0
	}), [o, { loading: s }] = Ut({
		variables: { id: t },
		onCompleted: () => {
			r({
				title: "Success",
				text: "Custom hostname successfully deregistered"
			});
		},
		onError: (e) => {
			throw n({
				title: "Unable to deregister custom hostname",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), c = s || i, l = e?.records?.ssl.records ?? [], u = l.length > 0 ? l : [void 0];
	return /* @__PURE__ */ I("form", { children: /* @__PURE__ */ L(T, {
		className: Xu.formGrid,
		children: [
			/* @__PURE__ */ I(w, {
				className: Xu.formField,
				children: /* @__PURE__ */ I(ku, {
					legend: "CNAME",
					classNames: { fieldset: Xu.fieldSet },
					children: /* @__PURE__ */ L(T, { children: [
						/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
							label: "Hostname",
							value: e?.hostname
						}) }),
						/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
							label: "Alias",
							value: e?.records?.cname.record?.aliasOf
						}) }),
						/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
							label: "Status",
							value: e?.records?.cname.status,
							showCopyButton: !1
						}) })
					] })
				})
			}),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ku, {
				legend: "SSL",
				classNames: { fieldset: Xu.fieldSet },
				children: /* @__PURE__ */ L(T, { children: [u.map((e, t) => /* @__PURE__ */ L(ge, { children: [/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
					label: "Name",
					value: e?.name
				}) }), /* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
					label: "Value",
					value: e?.value
				}) })] }, `${e?.name}-${e?.value}-${t}`)), /* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rd, {
					label: "Status",
					value: e?.records?.ssl.status,
					showCopyButton: !1
				}) })] })
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(C, {
				gap: "250",
				children: [/* @__PURE__ */ I(m, {
					variant: "danger",
					isLoading: s,
					loadingIndicator: s ? /* @__PURE__ */ L(C, {
						gap: "200",
						children: [/* @__PURE__ */ I(ce, { size: 16 }), /* @__PURE__ */ I(j.Paragraph, {
							variant: "3",
							as: "span",
							style: { color: "unset" },
							children: "De-registering..."
						})]
					}) : "Deregister",
					disabled: c,
					onClick: () => o(),
					children: "Deregister"
				}), /* @__PURE__ */ I(m, {
					variant: "secondary",
					disabled: c,
					onClick: () => a(),
					children: "Recheck status"
				})]
			}) })
		]
	}) });
}
function rd({ value: e, label: t, showCopyButton: n = !0 }) {
	let { timedClipboardIndicator: r, setClipboard: i } = Hu(), { successNotify: a } = Es(), o = () => {
		e && (i(e), a({
			title: "Success",
			text: "Copied to clipboard",
			time: 1e3
		}));
	}, s = pe(Xu.copyIcon, { [Xu.copied]: r });
	return /* @__PURE__ */ L(p, { children: [/* @__PURE__ */ I(j.Paragraph, {
		variant: "4",
		children: t
	}), /* @__PURE__ */ L(C, {
		alignItems: "stretch",
		gap: "200",
		children: [/* @__PURE__ */ I("pre", {
			className: Xu.pre,
			children: e
		}), n && /* @__PURE__ */ I(te, {
			variant: "secondary",
			icon: r ? "check-circle-filled" : "copy",
			onClick: o,
			className: s
		})]
	})] });
}
var id = R((() => {
	Gi(), gs(), Au(), V(), Wu(), Ds(), Zu(), $u();
}));
//#endregion
//#region src/components/customHostnameForm/customHostnameFormLoadingPlaceholder.tsx
function ad() {
	return /* @__PURE__ */ I("form", { children: /* @__PURE__ */ L(C, {
		flexDirection: "column",
		gap: "200",
		children: [
			/* @__PURE__ */ I(k, {
				height: "16px",
				width: "140px",
				animation: "wave"
			}),
			/* @__PURE__ */ I(k, {
				height: "38px",
				width: "100%",
				animation: "wave"
			}),
			/* @__PURE__ */ I(k, {
				height: "12px",
				width: "350px",
				animation: "wave"
			}),
			/* @__PURE__ */ I(k, {
				height: "32px",
				width: "70px",
				animation: "wave",
				margin: "200 0 0"
			})
		]
	}) });
}
var od = R((() => {}));
//#endregion
//#region src/components/customHostnameForm/index.tsx
function sd({ helpCenterId: e, isActive: t }) {
	let { loading: n, data: r, error: i } = zt({ variables: { id: e } });
	return !n && r && r.helpCenter ? /* @__PURE__ */ I(ed, {
		helpCenterId: e,
		isActive: t
	}) : i ? /* @__PURE__ */ I(Ii, { errorMessage: i.message }) : /* @__PURE__ */ I(ad, {});
}
var cd = R((() => {
	V(), Li(), id(), od();
}));
//#endregion
//#region ../management-common/src/utils/language.ts
function ld({ languageId: e, languages: t }) {
	let n = t.find((t) => t.languageId === e);
	if (n === void 0) {
		let t = `Unknown lang: "${e}"`;
		return {
			description: t,
			nativeDescription: t
		};
	}
	return {
		description: n.description,
		nativeDescription: n.nativeDescription
	};
}
var ud = R((() => {})), dd, fd, pd, md, hd, gd = R((() => {
	V(), gl(), dd = /^#([A-Fa-f0-9]{6})$/, fd = Z().refine((e) => dd.test(e), "Invalid color format: must be a valid 6 character long Hex value"), pd = ul({
		languageId: pl($t),
		tagline: dl([fl(""), Z().min(3, { message: "If provided, a site tagline must be at least 3 characters long" })])
	}), md = ul({
		languageId: pl($t),
		title: dl([fl(""), Z().min(3, { message: "If provided, a site title must be at least 3 characters long" })])
	}), hd = ul({
		companyUrl: dl([fl(""), Z().trim().url({ message: "A URL must be a valid format and start with 'https://' or 'http://'" })]),
		helpCenterTitles: ll(md),
		helpCenterTaglines: ll(pd),
		colors: ul({
			websiteBackground: fd,
			pageBackground: fd,
			text: fd,
			link: fd,
			accent: fd,
			accentText: fd
		}),
		themeId: Z().uuid()
	});
})), _d, vd, yd, bd, xd, Sd, Cd = R((() => {
	_d = "_alert_smz2d_1", vd = "_uploadDropzoneWrapper_smz2d_5", yd = "_uploadImageWrapper_smz2d_6", bd = "_uploadDropzoneLoadingWrapper_smz2d_7", xd = "_uploadImage_smz2d_6", Sd = {
		alert: _d,
		uploadDropzoneWrapper: vd,
		uploadImageWrapper: yd,
		uploadDropzoneLoadingWrapper: bd,
		uploadImage: xd
	};
})), wd = /* @__PURE__ */ z(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, ee = t ? Symbol.for("react.scope") : 60119;
	function y(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function b(e) {
		return y(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return b(e) || y(e) === l;
	}, e.isConcurrentMode = b, e.isContextConsumer = function(e) {
		return y(e) === c;
	}, e.isContextProvider = function(e) {
		return y(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return y(e) === d;
	}, e.isFragment = function(e) {
		return y(e) === i;
	}, e.isLazy = function(e) {
		return y(e) === h;
	}, e.isMemo = function(e) {
		return y(e) === m;
	}, e.isPortal = function(e) {
		return y(e) === r;
	}, e.isProfiler = function(e) {
		return y(e) === o;
	}, e.isStrictMode = function(e) {
		return y(e) === a;
	}, e.isSuspense = function(e) {
		return y(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === ee || e.$$typeof === g);
	}, e.typeOf = y;
})), Td = /* @__PURE__ */ z(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, ee = t ? Symbol.for("react.scope") : 60119;
		function y(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === ee || e.$$typeof === g);
		}
		function b(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var x = l, S = u, C = c, w = s, T = n, E = d, te = i, ne = h, D = m, re = r, ie = o, ae = a, O = f, oe = !1;
		function se(e) {
			return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(e) || b(e) === l;
		}
		function k(e) {
			return b(e) === u;
		}
		function ce(e) {
			return b(e) === c;
		}
		function le(e) {
			return b(e) === s;
		}
		function A(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function ue(e) {
			return b(e) === d;
		}
		function de(e) {
			return b(e) === i;
		}
		function j(e) {
			return b(e) === h;
		}
		function fe(e) {
			return b(e) === m;
		}
		function pe(e) {
			return b(e) === r;
		}
		function me(e) {
			return b(e) === o;
		}
		function he(e) {
			return b(e) === a;
		}
		function ge(e) {
			return b(e) === f;
		}
		e.AsyncMode = x, e.ConcurrentMode = S, e.ContextConsumer = C, e.ContextProvider = w, e.Element = T, e.ForwardRef = E, e.Fragment = te, e.Lazy = ne, e.Memo = D, e.Portal = re, e.Profiler = ie, e.StrictMode = ae, e.Suspense = O, e.isAsyncMode = se, e.isConcurrentMode = k, e.isContextConsumer = ce, e.isContextProvider = le, e.isElement = A, e.isForwardRef = ue, e.isFragment = de, e.isLazy = j, e.isMemo = fe, e.isPortal = pe, e.isProfiler = me, e.isStrictMode = he, e.isSuspense = ge, e.isValidElementType = y, e.typeOf = b;
	})();
})), Ed = /* @__PURE__ */ z(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = wd() : t.exports = Td();
})), Dd = /* @__PURE__ */ z(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Od = /* @__PURE__ */ z(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), kd = /* @__PURE__ */ z(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Ad = /* @__PURE__ */ z(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Od(), i = {}, a = kd();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), jd = /* @__PURE__ */ z(((e, t) => {
	var n = Ed(), r = Dd(), i = Od(), a = kd(), o = Ad(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: ee,
			element: y(),
			elementType: b(),
			instanceOf: x,
			node: T(),
			objectOf: C,
			oneOf: S,
			oneOfType: w,
			shape: te,
			exact: ne
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (ie(s) !== e) {
					var c = ae(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function ee(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = ie(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function y() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = ie(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = ie(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function x(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = oe(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function S(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return ae(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function C(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = ie(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function w(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + O(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function T() {
			function e(e, t, n, r, i) {
				return D(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function E(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function te(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = ie(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return E(r, a, o, l, ae(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function ne(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = ie(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return E(o, s, c, d, ae(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function D(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(D);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!D(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !D(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function re(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function ie(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : re(t, e) ? "symbol" : t;
		}
		function ae(e) {
			if (e == null) return "" + e;
			var t = ie(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function O(e) {
			var t = ae(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function oe(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), Md = /* @__PURE__ */ z(((e, t) => {
	var n = Od();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), Nd = /* @__PURE__ */ z(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Ed();
		t.exports = jd()(n.isElement, !0);
	} else t.exports = Md()();
}));
//#endregion
//#region ../../../node_modules/react-dropzone/node_modules/tslib/tslib.es6.mjs
function Pd(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
var Fd = R((() => {}));
//#endregion
//#region ../../../node_modules/react-dropzone/node_modules/file-selector/dist/es2015/file.js
function Id(e, t, n) {
	let r = Ld(e), { webkitRelativePath: i } = e, a = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
	return typeof r.path != "string" && Rd(r, "path", a), n !== void 0 && Object.defineProperty(r, "handle", {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	}), Rd(r, "relativePath", a), r;
}
function Ld(e) {
	let { name: t } = e;
	if (t && t.lastIndexOf(".") !== -1 && !e.type) {
		let n = t.split(".").pop().toLowerCase(), r = zd.get(n);
		r && Object.defineProperty(e, "type", {
			value: r,
			writable: !1,
			configurable: !1,
			enumerable: !0
		});
	}
	return e;
}
function Rd(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	});
}
var zd, Bd = R((() => {
	zd = /* @__PURE__ */ new Map([
		["1km", "application/vnd.1000minds.decision-model+xml"],
		["3dml", "text/vnd.in3d.3dml"],
		["3ds", "image/x-3ds"],
		["3g2", "video/3gpp2"],
		["3gp", "video/3gp"],
		["3gpp", "video/3gpp"],
		["3mf", "model/3mf"],
		["7z", "application/x-7z-compressed"],
		["7zip", "application/x-7z-compressed"],
		["123", "application/vnd.lotus-1-2-3"],
		["aab", "application/x-authorware-bin"],
		["aac", "audio/x-acc"],
		["aam", "application/x-authorware-map"],
		["aas", "application/x-authorware-seg"],
		["abw", "application/x-abiword"],
		["ac", "application/vnd.nokia.n-gage.ac+xml"],
		["ac3", "audio/ac3"],
		["acc", "application/vnd.americandynamics.acc"],
		["ace", "application/x-ace-compressed"],
		["acu", "application/vnd.acucobol"],
		["acutc", "application/vnd.acucorp"],
		["adp", "audio/adpcm"],
		["aep", "application/vnd.audiograph"],
		["afm", "application/x-font-type1"],
		["afp", "application/vnd.ibm.modcap"],
		["ahead", "application/vnd.ahead.space"],
		["ai", "application/pdf"],
		["aif", "audio/x-aiff"],
		["aifc", "audio/x-aiff"],
		["aiff", "audio/x-aiff"],
		["air", "application/vnd.adobe.air-application-installer-package+zip"],
		["ait", "application/vnd.dvb.ait"],
		["ami", "application/vnd.amiga.ami"],
		["amr", "audio/amr"],
		["apk", "application/vnd.android.package-archive"],
		["apng", "image/apng"],
		["appcache", "text/cache-manifest"],
		["application", "application/x-ms-application"],
		["apr", "application/vnd.lotus-approach"],
		["arc", "application/x-freearc"],
		["arj", "application/x-arj"],
		["asc", "application/pgp-signature"],
		["asf", "video/x-ms-asf"],
		["asm", "text/x-asm"],
		["aso", "application/vnd.accpac.simply.aso"],
		["asx", "video/x-ms-asf"],
		["atc", "application/vnd.acucorp"],
		["atom", "application/atom+xml"],
		["atomcat", "application/atomcat+xml"],
		["atomdeleted", "application/atomdeleted+xml"],
		["atomsvc", "application/atomsvc+xml"],
		["atx", "application/vnd.antix.game-component"],
		["au", "audio/x-au"],
		["avi", "video/x-msvideo"],
		["avif", "image/avif"],
		["aw", "application/applixware"],
		["azf", "application/vnd.airzip.filesecure.azf"],
		["azs", "application/vnd.airzip.filesecure.azs"],
		["azv", "image/vnd.airzip.accelerator.azv"],
		["azw", "application/vnd.amazon.ebook"],
		["b16", "image/vnd.pco.b16"],
		["bat", "application/x-msdownload"],
		["bcpio", "application/x-bcpio"],
		["bdf", "application/x-font-bdf"],
		["bdm", "application/vnd.syncml.dm+wbxml"],
		["bdoc", "application/x-bdoc"],
		["bed", "application/vnd.realvnc.bed"],
		["bh2", "application/vnd.fujitsu.oasysprs"],
		["bin", "application/octet-stream"],
		["blb", "application/x-blorb"],
		["blorb", "application/x-blorb"],
		["bmi", "application/vnd.bmi"],
		["bmml", "application/vnd.balsamiq.bmml+xml"],
		["bmp", "image/bmp"],
		["book", "application/vnd.framemaker"],
		["box", "application/vnd.previewsystems.box"],
		["boz", "application/x-bzip2"],
		["bpk", "application/octet-stream"],
		["bpmn", "application/octet-stream"],
		["bsp", "model/vnd.valve.source.compiled-map"],
		["btif", "image/prs.btif"],
		["buffer", "application/octet-stream"],
		["bz", "application/x-bzip"],
		["bz2", "application/x-bzip2"],
		["c", "text/x-c"],
		["c4d", "application/vnd.clonk.c4group"],
		["c4f", "application/vnd.clonk.c4group"],
		["c4g", "application/vnd.clonk.c4group"],
		["c4p", "application/vnd.clonk.c4group"],
		["c4u", "application/vnd.clonk.c4group"],
		["c11amc", "application/vnd.cluetrust.cartomobile-config"],
		["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
		["cab", "application/vnd.ms-cab-compressed"],
		["caf", "audio/x-caf"],
		["cap", "application/vnd.tcpdump.pcap"],
		["car", "application/vnd.curl.car"],
		["cat", "application/vnd.ms-pki.seccat"],
		["cb7", "application/x-cbr"],
		["cba", "application/x-cbr"],
		["cbr", "application/x-cbr"],
		["cbt", "application/x-cbr"],
		["cbz", "application/x-cbr"],
		["cc", "text/x-c"],
		["cco", "application/x-cocoa"],
		["cct", "application/x-director"],
		["ccxml", "application/ccxml+xml"],
		["cdbcmsg", "application/vnd.contact.cmsg"],
		["cda", "application/x-cdf"],
		["cdf", "application/x-netcdf"],
		["cdfx", "application/cdfx+xml"],
		["cdkey", "application/vnd.mediastation.cdkey"],
		["cdmia", "application/cdmi-capability"],
		["cdmic", "application/cdmi-container"],
		["cdmid", "application/cdmi-domain"],
		["cdmio", "application/cdmi-object"],
		["cdmiq", "application/cdmi-queue"],
		["cdr", "application/cdr"],
		["cdx", "chemical/x-cdx"],
		["cdxml", "application/vnd.chemdraw+xml"],
		["cdy", "application/vnd.cinderella"],
		["cer", "application/pkix-cert"],
		["cfs", "application/x-cfs-compressed"],
		["cgm", "image/cgm"],
		["chat", "application/x-chat"],
		["chm", "application/vnd.ms-htmlhelp"],
		["chrt", "application/vnd.kde.kchart"],
		["cif", "chemical/x-cif"],
		["cii", "application/vnd.anser-web-certificate-issue-initiation"],
		["cil", "application/vnd.ms-artgalry"],
		["cjs", "application/node"],
		["cla", "application/vnd.claymore"],
		["class", "application/octet-stream"],
		["clkk", "application/vnd.crick.clicker.keyboard"],
		["clkp", "application/vnd.crick.clicker.palette"],
		["clkt", "application/vnd.crick.clicker.template"],
		["clkw", "application/vnd.crick.clicker.wordbank"],
		["clkx", "application/vnd.crick.clicker"],
		["clp", "application/x-msclip"],
		["cmc", "application/vnd.cosmocaller"],
		["cmdf", "chemical/x-cmdf"],
		["cml", "chemical/x-cml"],
		["cmp", "application/vnd.yellowriver-custom-menu"],
		["cmx", "image/x-cmx"],
		["cod", "application/vnd.rim.cod"],
		["coffee", "text/coffeescript"],
		["com", "application/x-msdownload"],
		["conf", "text/plain"],
		["cpio", "application/x-cpio"],
		["cpp", "text/x-c"],
		["cpt", "application/mac-compactpro"],
		["crd", "application/x-mscardfile"],
		["crl", "application/pkix-crl"],
		["crt", "application/x-x509-ca-cert"],
		["crx", "application/x-chrome-extension"],
		["cryptonote", "application/vnd.rig.cryptonote"],
		["csh", "application/x-csh"],
		["csl", "application/vnd.citationstyles.style+xml"],
		["csml", "chemical/x-csml"],
		["csp", "application/vnd.commonspace"],
		["csr", "application/octet-stream"],
		["css", "text/css"],
		["cst", "application/x-director"],
		["csv", "text/csv"],
		["cu", "application/cu-seeme"],
		["curl", "text/vnd.curl"],
		["cww", "application/prs.cww"],
		["cxt", "application/x-director"],
		["cxx", "text/x-c"],
		["dae", "model/vnd.collada+xml"],
		["daf", "application/vnd.mobius.daf"],
		["dart", "application/vnd.dart"],
		["dataless", "application/vnd.fdsn.seed"],
		["davmount", "application/davmount+xml"],
		["dbf", "application/vnd.dbf"],
		["dbk", "application/docbook+xml"],
		["dcr", "application/x-director"],
		["dcurl", "text/vnd.curl.dcurl"],
		["dd2", "application/vnd.oma.dd2+xml"],
		["ddd", "application/vnd.fujixerox.ddd"],
		["ddf", "application/vnd.syncml.dmddf+xml"],
		["dds", "image/vnd.ms-dds"],
		["deb", "application/x-debian-package"],
		["def", "text/plain"],
		["deploy", "application/octet-stream"],
		["der", "application/x-x509-ca-cert"],
		["dfac", "application/vnd.dreamfactory"],
		["dgc", "application/x-dgc-compressed"],
		["dic", "text/x-c"],
		["dir", "application/x-director"],
		["dis", "application/vnd.mobius.dis"],
		["disposition-notification", "message/disposition-notification"],
		["dist", "application/octet-stream"],
		["distz", "application/octet-stream"],
		["djv", "image/vnd.djvu"],
		["djvu", "image/vnd.djvu"],
		["dll", "application/octet-stream"],
		["dmg", "application/x-apple-diskimage"],
		["dmn", "application/octet-stream"],
		["dmp", "application/vnd.tcpdump.pcap"],
		["dms", "application/octet-stream"],
		["dna", "application/vnd.dna"],
		["doc", "application/msword"],
		["docm", "application/vnd.ms-word.template.macroEnabled.12"],
		["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
		["dot", "application/msword"],
		["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
		["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
		["dp", "application/vnd.osgi.dp"],
		["dpg", "application/vnd.dpgraph"],
		["dra", "audio/vnd.dra"],
		["drle", "image/dicom-rle"],
		["dsc", "text/prs.lines.tag"],
		["dssc", "application/dssc+der"],
		["dtb", "application/x-dtbook+xml"],
		["dtd", "application/xml-dtd"],
		["dts", "audio/vnd.dts"],
		["dtshd", "audio/vnd.dts.hd"],
		["dump", "application/octet-stream"],
		["dvb", "video/vnd.dvb.file"],
		["dvi", "application/x-dvi"],
		["dwd", "application/atsc-dwd+xml"],
		["dwf", "model/vnd.dwf"],
		["dwg", "image/vnd.dwg"],
		["dxf", "image/vnd.dxf"],
		["dxp", "application/vnd.spotfire.dxp"],
		["dxr", "application/x-director"],
		["ear", "application/java-archive"],
		["ecelp4800", "audio/vnd.nuera.ecelp4800"],
		["ecelp7470", "audio/vnd.nuera.ecelp7470"],
		["ecelp9600", "audio/vnd.nuera.ecelp9600"],
		["ecma", "application/ecmascript"],
		["edm", "application/vnd.novadigm.edm"],
		["edx", "application/vnd.novadigm.edx"],
		["efif", "application/vnd.picsel"],
		["ei6", "application/vnd.pg.osasli"],
		["elc", "application/octet-stream"],
		["emf", "image/emf"],
		["eml", "message/rfc822"],
		["emma", "application/emma+xml"],
		["emotionml", "application/emotionml+xml"],
		["emz", "application/x-msmetafile"],
		["eol", "audio/vnd.digital-winds"],
		["eot", "application/vnd.ms-fontobject"],
		["eps", "application/postscript"],
		["epub", "application/epub+zip"],
		["es", "application/ecmascript"],
		["es3", "application/vnd.eszigno3+xml"],
		["esa", "application/vnd.osgi.subsystem"],
		["esf", "application/vnd.epson.esf"],
		["et3", "application/vnd.eszigno3+xml"],
		["etx", "text/x-setext"],
		["eva", "application/x-eva"],
		["evy", "application/x-envoy"],
		["exe", "application/octet-stream"],
		["exi", "application/exi"],
		["exp", "application/express"],
		["exr", "image/aces"],
		["ext", "application/vnd.novadigm.ext"],
		["ez", "application/andrew-inset"],
		["ez2", "application/vnd.ezpix-album"],
		["ez3", "application/vnd.ezpix-package"],
		["f", "text/x-fortran"],
		["f4v", "video/mp4"],
		["f77", "text/x-fortran"],
		["f90", "text/x-fortran"],
		["fbs", "image/vnd.fastbidsheet"],
		["fcdt", "application/vnd.adobe.formscentral.fcdt"],
		["fcs", "application/vnd.isac.fcs"],
		["fdf", "application/vnd.fdf"],
		["fdt", "application/fdt+xml"],
		["fe_launch", "application/vnd.denovo.fcselayout-link"],
		["fg5", "application/vnd.fujitsu.oasysgp"],
		["fgd", "application/x-director"],
		["fh", "image/x-freehand"],
		["fh4", "image/x-freehand"],
		["fh5", "image/x-freehand"],
		["fh7", "image/x-freehand"],
		["fhc", "image/x-freehand"],
		["fig", "application/x-xfig"],
		["fits", "image/fits"],
		["flac", "audio/x-flac"],
		["fli", "video/x-fli"],
		["flo", "application/vnd.micrografx.flo"],
		["flv", "video/x-flv"],
		["flw", "application/vnd.kde.kivio"],
		["flx", "text/vnd.fmi.flexstor"],
		["fly", "text/vnd.fly"],
		["fm", "application/vnd.framemaker"],
		["fnc", "application/vnd.frogans.fnc"],
		["fo", "application/vnd.software602.filler.form+xml"],
		["for", "text/x-fortran"],
		["fpx", "image/vnd.fpx"],
		["frame", "application/vnd.framemaker"],
		["fsc", "application/vnd.fsc.weblaunch"],
		["fst", "image/vnd.fst"],
		["ftc", "application/vnd.fluxtime.clip"],
		["fti", "application/vnd.anser-web-funds-transfer-initiation"],
		["fvt", "video/vnd.fvt"],
		["fxp", "application/vnd.adobe.fxp"],
		["fxpl", "application/vnd.adobe.fxp"],
		["fzs", "application/vnd.fuzzysheet"],
		["g2w", "application/vnd.geoplan"],
		["g3", "image/g3fax"],
		["g3w", "application/vnd.geospace"],
		["gac", "application/vnd.groove-account"],
		["gam", "application/x-tads"],
		["gbr", "application/rpki-ghostbusters"],
		["gca", "application/x-gca-compressed"],
		["gdl", "model/vnd.gdl"],
		["gdoc", "application/vnd.google-apps.document"],
		["geo", "application/vnd.dynageo"],
		["geojson", "application/geo+json"],
		["gex", "application/vnd.geometry-explorer"],
		["ggb", "application/vnd.geogebra.file"],
		["ggt", "application/vnd.geogebra.tool"],
		["ghf", "application/vnd.groove-help"],
		["gif", "image/gif"],
		["gim", "application/vnd.groove-identity-message"],
		["glb", "model/gltf-binary"],
		["gltf", "model/gltf+json"],
		["gml", "application/gml+xml"],
		["gmx", "application/vnd.gmx"],
		["gnumeric", "application/x-gnumeric"],
		["gpg", "application/gpg-keys"],
		["gph", "application/vnd.flographit"],
		["gpx", "application/gpx+xml"],
		["gqf", "application/vnd.grafeq"],
		["gqs", "application/vnd.grafeq"],
		["gram", "application/srgs"],
		["gramps", "application/x-gramps-xml"],
		["gre", "application/vnd.geometry-explorer"],
		["grv", "application/vnd.groove-injector"],
		["grxml", "application/srgs+xml"],
		["gsf", "application/x-font-ghostscript"],
		["gsheet", "application/vnd.google-apps.spreadsheet"],
		["gslides", "application/vnd.google-apps.presentation"],
		["gtar", "application/x-gtar"],
		["gtm", "application/vnd.groove-tool-message"],
		["gtw", "model/vnd.gtw"],
		["gv", "text/vnd.graphviz"],
		["gxf", "application/gxf"],
		["gxt", "application/vnd.geonext"],
		["gz", "application/gzip"],
		["gzip", "application/gzip"],
		["h", "text/x-c"],
		["h261", "video/h261"],
		["h263", "video/h263"],
		["h264", "video/h264"],
		["hal", "application/vnd.hal+xml"],
		["hbci", "application/vnd.hbci"],
		["hbs", "text/x-handlebars-template"],
		["hdd", "application/x-virtualbox-hdd"],
		["hdf", "application/x-hdf"],
		["heic", "image/heic"],
		["heics", "image/heic-sequence"],
		["heif", "image/heif"],
		["heifs", "image/heif-sequence"],
		["hej2", "image/hej2k"],
		["held", "application/atsc-held+xml"],
		["hh", "text/x-c"],
		["hjson", "application/hjson"],
		["hlp", "application/winhlp"],
		["hpgl", "application/vnd.hp-hpgl"],
		["hpid", "application/vnd.hp-hpid"],
		["hps", "application/vnd.hp-hps"],
		["hqx", "application/mac-binhex40"],
		["hsj2", "image/hsj2"],
		["htc", "text/x-component"],
		["htke", "application/vnd.kenameaapp"],
		["htm", "text/html"],
		["html", "text/html"],
		["hvd", "application/vnd.yamaha.hv-dic"],
		["hvp", "application/vnd.yamaha.hv-voice"],
		["hvs", "application/vnd.yamaha.hv-script"],
		["i2g", "application/vnd.intergeo"],
		["icc", "application/vnd.iccprofile"],
		["ice", "x-conference/x-cooltalk"],
		["icm", "application/vnd.iccprofile"],
		["ico", "image/x-icon"],
		["ics", "text/calendar"],
		["ief", "image/ief"],
		["ifb", "text/calendar"],
		["ifm", "application/vnd.shana.informed.formdata"],
		["iges", "model/iges"],
		["igl", "application/vnd.igloader"],
		["igm", "application/vnd.insors.igm"],
		["igs", "model/iges"],
		["igx", "application/vnd.micrografx.igx"],
		["iif", "application/vnd.shana.informed.interchange"],
		["img", "application/octet-stream"],
		["imp", "application/vnd.accpac.simply.imp"],
		["ims", "application/vnd.ms-ims"],
		["in", "text/plain"],
		["ini", "text/plain"],
		["ink", "application/inkml+xml"],
		["inkml", "application/inkml+xml"],
		["install", "application/x-install-instructions"],
		["iota", "application/vnd.astraea-software.iota"],
		["ipfix", "application/ipfix"],
		["ipk", "application/vnd.shana.informed.package"],
		["irm", "application/vnd.ibm.rights-management"],
		["irp", "application/vnd.irepository.package+xml"],
		["iso", "application/x-iso9660-image"],
		["itp", "application/vnd.shana.informed.formtemplate"],
		["its", "application/its+xml"],
		["ivp", "application/vnd.immervision-ivp"],
		["ivu", "application/vnd.immervision-ivu"],
		["jad", "text/vnd.sun.j2me.app-descriptor"],
		["jade", "text/jade"],
		["jam", "application/vnd.jam"],
		["jar", "application/java-archive"],
		["jardiff", "application/x-java-archive-diff"],
		["java", "text/x-java-source"],
		["jhc", "image/jphc"],
		["jisp", "application/vnd.jisp"],
		["jls", "image/jls"],
		["jlt", "application/vnd.hp-jlyt"],
		["jng", "image/x-jng"],
		["jnlp", "application/x-java-jnlp-file"],
		["joda", "application/vnd.joost.joda-archive"],
		["jp2", "image/jp2"],
		["jpe", "image/jpeg"],
		["jpeg", "image/jpeg"],
		["jpf", "image/jpx"],
		["jpg", "image/jpeg"],
		["jpg2", "image/jp2"],
		["jpgm", "video/jpm"],
		["jpgv", "video/jpeg"],
		["jph", "image/jph"],
		["jpm", "video/jpm"],
		["jpx", "image/jpx"],
		["js", "application/javascript"],
		["json", "application/json"],
		["json5", "application/json5"],
		["jsonld", "application/ld+json"],
		["jsonl", "application/jsonl"],
		["jsonml", "application/jsonml+json"],
		["jsx", "text/jsx"],
		["jxr", "image/jxr"],
		["jxra", "image/jxra"],
		["jxrs", "image/jxrs"],
		["jxs", "image/jxs"],
		["jxsc", "image/jxsc"],
		["jxsi", "image/jxsi"],
		["jxss", "image/jxss"],
		["kar", "audio/midi"],
		["karbon", "application/vnd.kde.karbon"],
		["kdb", "application/octet-stream"],
		["kdbx", "application/x-keepass2"],
		["key", "application/x-iwork-keynote-sffkey"],
		["kfo", "application/vnd.kde.kformula"],
		["kia", "application/vnd.kidspiration"],
		["kml", "application/vnd.google-earth.kml+xml"],
		["kmz", "application/vnd.google-earth.kmz"],
		["kne", "application/vnd.kinar"],
		["knp", "application/vnd.kinar"],
		["kon", "application/vnd.kde.kontour"],
		["kpr", "application/vnd.kde.kpresenter"],
		["kpt", "application/vnd.kde.kpresenter"],
		["kpxx", "application/vnd.ds-keypoint"],
		["ksp", "application/vnd.kde.kspread"],
		["ktr", "application/vnd.kahootz"],
		["ktx", "image/ktx"],
		["ktx2", "image/ktx2"],
		["ktz", "application/vnd.kahootz"],
		["kwd", "application/vnd.kde.kword"],
		["kwt", "application/vnd.kde.kword"],
		["lasxml", "application/vnd.las.las+xml"],
		["latex", "application/x-latex"],
		["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
		["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
		["les", "application/vnd.hhe.lesson-player"],
		["less", "text/less"],
		["lgr", "application/lgr+xml"],
		["lha", "application/octet-stream"],
		["link66", "application/vnd.route66.link66+xml"],
		["list", "text/plain"],
		["list3820", "application/vnd.ibm.modcap"],
		["listafp", "application/vnd.ibm.modcap"],
		["litcoffee", "text/coffeescript"],
		["lnk", "application/x-ms-shortcut"],
		["log", "text/plain"],
		["lostxml", "application/lost+xml"],
		["lrf", "application/octet-stream"],
		["lrm", "application/vnd.ms-lrm"],
		["ltf", "application/vnd.frogans.ltf"],
		["lua", "text/x-lua"],
		["luac", "application/x-lua-bytecode"],
		["lvp", "audio/vnd.lucent.voice"],
		["lwp", "application/vnd.lotus-wordpro"],
		["lzh", "application/octet-stream"],
		["m1v", "video/mpeg"],
		["m2a", "audio/mpeg"],
		["m2v", "video/mpeg"],
		["m3a", "audio/mpeg"],
		["m3u", "text/plain"],
		["m3u8", "application/vnd.apple.mpegurl"],
		["m4a", "audio/x-m4a"],
		["m4p", "application/mp4"],
		["m4s", "video/iso.segment"],
		["m4u", "application/vnd.mpegurl"],
		["m4v", "video/x-m4v"],
		["m13", "application/x-msmediaview"],
		["m14", "application/x-msmediaview"],
		["m21", "application/mp21"],
		["ma", "application/mathematica"],
		["mads", "application/mads+xml"],
		["maei", "application/mmt-aei+xml"],
		["mag", "application/vnd.ecowin.chart"],
		["maker", "application/vnd.framemaker"],
		["man", "text/troff"],
		["manifest", "text/cache-manifest"],
		["map", "application/json"],
		["mar", "application/octet-stream"],
		["markdown", "text/markdown"],
		["mathml", "application/mathml+xml"],
		["mb", "application/mathematica"],
		["mbk", "application/vnd.mobius.mbk"],
		["mbox", "application/mbox"],
		["mc1", "application/vnd.medcalcdata"],
		["mcd", "application/vnd.mcd"],
		["mcurl", "text/vnd.curl.mcurl"],
		["md", "text/markdown"],
		["mdb", "application/x-msaccess"],
		["mdi", "image/vnd.ms-modi"],
		["mdx", "text/mdx"],
		["me", "text/troff"],
		["mesh", "model/mesh"],
		["meta4", "application/metalink4+xml"],
		["metalink", "application/metalink+xml"],
		["mets", "application/mets+xml"],
		["mfm", "application/vnd.mfmp"],
		["mft", "application/rpki-manifest"],
		["mgp", "application/vnd.osgeo.mapguide.package"],
		["mgz", "application/vnd.proteus.magazine"],
		["mid", "audio/midi"],
		["midi", "audio/midi"],
		["mie", "application/x-mie"],
		["mif", "application/vnd.mif"],
		["mime", "message/rfc822"],
		["mj2", "video/mj2"],
		["mjp2", "video/mj2"],
		["mjs", "application/javascript"],
		["mk3d", "video/x-matroska"],
		["mka", "audio/x-matroska"],
		["mkd", "text/x-markdown"],
		["mks", "video/x-matroska"],
		["mkv", "video/x-matroska"],
		["mlp", "application/vnd.dolby.mlp"],
		["mmd", "application/vnd.chipnuts.karaoke-mmd"],
		["mmf", "application/vnd.smaf"],
		["mml", "text/mathml"],
		["mmr", "image/vnd.fujixerox.edmics-mmr"],
		["mng", "video/x-mng"],
		["mny", "application/x-msmoney"],
		["mobi", "application/x-mobipocket-ebook"],
		["mods", "application/mods+xml"],
		["mov", "video/quicktime"],
		["movie", "video/x-sgi-movie"],
		["mp2", "audio/mpeg"],
		["mp2a", "audio/mpeg"],
		["mp3", "audio/mpeg"],
		["mp4", "video/mp4"],
		["mp4a", "audio/mp4"],
		["mp4s", "application/mp4"],
		["mp4v", "video/mp4"],
		["mp21", "application/mp21"],
		["mpc", "application/vnd.mophun.certificate"],
		["mpd", "application/dash+xml"],
		["mpe", "video/mpeg"],
		["mpeg", "video/mpeg"],
		["mpg", "video/mpeg"],
		["mpg4", "video/mp4"],
		["mpga", "audio/mpeg"],
		["mpkg", "application/vnd.apple.installer+xml"],
		["mpm", "application/vnd.blueice.multipass"],
		["mpn", "application/vnd.mophun.application"],
		["mpp", "application/vnd.ms-project"],
		["mpt", "application/vnd.ms-project"],
		["mpy", "application/vnd.ibm.minipay"],
		["mqy", "application/vnd.mobius.mqy"],
		["mrc", "application/marc"],
		["mrcx", "application/marcxml+xml"],
		["ms", "text/troff"],
		["mscml", "application/mediaservercontrol+xml"],
		["mseed", "application/vnd.fdsn.mseed"],
		["mseq", "application/vnd.mseq"],
		["msf", "application/vnd.epson.msf"],
		["msg", "application/vnd.ms-outlook"],
		["msh", "model/mesh"],
		["msi", "application/x-msdownload"],
		["msl", "application/vnd.mobius.msl"],
		["msm", "application/octet-stream"],
		["msp", "application/octet-stream"],
		["msty", "application/vnd.muvee.style"],
		["mtl", "model/mtl"],
		["mts", "model/vnd.mts"],
		["mus", "application/vnd.musician"],
		["musd", "application/mmt-usd+xml"],
		["musicxml", "application/vnd.recordare.musicxml+xml"],
		["mvb", "application/x-msmediaview"],
		["mvt", "application/vnd.mapbox-vector-tile"],
		["mwf", "application/vnd.mfer"],
		["mxf", "application/mxf"],
		["mxl", "application/vnd.recordare.musicxml"],
		["mxmf", "audio/mobile-xmf"],
		["mxml", "application/xv+xml"],
		["mxs", "application/vnd.triscape.mxs"],
		["mxu", "video/vnd.mpegurl"],
		["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
		["n3", "text/n3"],
		["nb", "application/mathematica"],
		["nbp", "application/vnd.wolfram.player"],
		["nc", "application/x-netcdf"],
		["ncx", "application/x-dtbncx+xml"],
		["nfo", "text/x-nfo"],
		["ngdat", "application/vnd.nokia.n-gage.data"],
		["nitf", "application/vnd.nitf"],
		["nlu", "application/vnd.neurolanguage.nlu"],
		["nml", "application/vnd.enliven"],
		["nnd", "application/vnd.noblenet-directory"],
		["nns", "application/vnd.noblenet-sealer"],
		["nnw", "application/vnd.noblenet-web"],
		["npx", "image/vnd.net-fpx"],
		["nq", "application/n-quads"],
		["nsc", "application/x-conference"],
		["nsf", "application/vnd.lotus-notes"],
		["nt", "application/n-triples"],
		["ntf", "application/vnd.nitf"],
		["numbers", "application/x-iwork-numbers-sffnumbers"],
		["nzb", "application/x-nzb"],
		["oa2", "application/vnd.fujitsu.oasys2"],
		["oa3", "application/vnd.fujitsu.oasys3"],
		["oas", "application/vnd.fujitsu.oasys"],
		["obd", "application/x-msbinder"],
		["obgx", "application/vnd.openblox.game+xml"],
		["obj", "model/obj"],
		["oda", "application/oda"],
		["odb", "application/vnd.oasis.opendocument.database"],
		["odc", "application/vnd.oasis.opendocument.chart"],
		["odf", "application/vnd.oasis.opendocument.formula"],
		["odft", "application/vnd.oasis.opendocument.formula-template"],
		["odg", "application/vnd.oasis.opendocument.graphics"],
		["odi", "application/vnd.oasis.opendocument.image"],
		["odm", "application/vnd.oasis.opendocument.text-master"],
		["odp", "application/vnd.oasis.opendocument.presentation"],
		["ods", "application/vnd.oasis.opendocument.spreadsheet"],
		["odt", "application/vnd.oasis.opendocument.text"],
		["oga", "audio/ogg"],
		["ogex", "model/vnd.opengex"],
		["ogg", "audio/ogg"],
		["ogv", "video/ogg"],
		["ogx", "application/ogg"],
		["omdoc", "application/omdoc+xml"],
		["onepkg", "application/onenote"],
		["onetmp", "application/onenote"],
		["onetoc", "application/onenote"],
		["onetoc2", "application/onenote"],
		["opf", "application/oebps-package+xml"],
		["opml", "text/x-opml"],
		["oprc", "application/vnd.palm"],
		["opus", "audio/ogg"],
		["org", "text/x-org"],
		["osf", "application/vnd.yamaha.openscoreformat"],
		["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
		["osm", "application/vnd.openstreetmap.data+xml"],
		["otc", "application/vnd.oasis.opendocument.chart-template"],
		["otf", "font/otf"],
		["otg", "application/vnd.oasis.opendocument.graphics-template"],
		["oth", "application/vnd.oasis.opendocument.text-web"],
		["oti", "application/vnd.oasis.opendocument.image-template"],
		["otp", "application/vnd.oasis.opendocument.presentation-template"],
		["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
		["ott", "application/vnd.oasis.opendocument.text-template"],
		["ova", "application/x-virtualbox-ova"],
		["ovf", "application/x-virtualbox-ovf"],
		["owl", "application/rdf+xml"],
		["oxps", "application/oxps"],
		["oxt", "application/vnd.openofficeorg.extension"],
		["p", "text/x-pascal"],
		["p7a", "application/x-pkcs7-signature"],
		["p7b", "application/x-pkcs7-certificates"],
		["p7c", "application/pkcs7-mime"],
		["p7m", "application/pkcs7-mime"],
		["p7r", "application/x-pkcs7-certreqresp"],
		["p7s", "application/pkcs7-signature"],
		["p8", "application/pkcs8"],
		["p10", "application/x-pkcs10"],
		["p12", "application/x-pkcs12"],
		["pac", "application/x-ns-proxy-autoconfig"],
		["pages", "application/x-iwork-pages-sffpages"],
		["pas", "text/x-pascal"],
		["paw", "application/vnd.pawaafile"],
		["pbd", "application/vnd.powerbuilder6"],
		["pbm", "image/x-portable-bitmap"],
		["pcap", "application/vnd.tcpdump.pcap"],
		["pcf", "application/x-font-pcf"],
		["pcl", "application/vnd.hp-pcl"],
		["pclxl", "application/vnd.hp-pclxl"],
		["pct", "image/x-pict"],
		["pcurl", "application/vnd.curl.pcurl"],
		["pcx", "image/x-pcx"],
		["pdb", "application/x-pilot"],
		["pde", "text/x-processing"],
		["pdf", "application/pdf"],
		["pem", "application/x-x509-user-cert"],
		["pfa", "application/x-font-type1"],
		["pfb", "application/x-font-type1"],
		["pfm", "application/x-font-type1"],
		["pfr", "application/font-tdpfr"],
		["pfx", "application/x-pkcs12"],
		["pgm", "image/x-portable-graymap"],
		["pgn", "application/x-chess-pgn"],
		["pgp", "application/pgp"],
		["php", "application/x-httpd-php"],
		["php3", "application/x-httpd-php"],
		["php4", "application/x-httpd-php"],
		["phps", "application/x-httpd-php-source"],
		["phtml", "application/x-httpd-php"],
		["pic", "image/x-pict"],
		["pkg", "application/octet-stream"],
		["pki", "application/pkixcmp"],
		["pkipath", "application/pkix-pkipath"],
		["pkpass", "application/vnd.apple.pkpass"],
		["pl", "application/x-perl"],
		["plb", "application/vnd.3gpp.pic-bw-large"],
		["plc", "application/vnd.mobius.plc"],
		["plf", "application/vnd.pocketlearn"],
		["pls", "application/pls+xml"],
		["pm", "application/x-perl"],
		["pml", "application/vnd.ctc-posml"],
		["png", "image/png"],
		["pnm", "image/x-portable-anymap"],
		["portpkg", "application/vnd.macports.portpkg"],
		["pot", "application/vnd.ms-powerpoint"],
		["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
		["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
		["ppa", "application/vnd.ms-powerpoint"],
		["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
		["ppd", "application/vnd.cups-ppd"],
		["ppm", "image/x-portable-pixmap"],
		["pps", "application/vnd.ms-powerpoint"],
		["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
		["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
		["ppt", "application/powerpoint"],
		["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
		["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
		["pqa", "application/vnd.palm"],
		["prc", "application/x-pilot"],
		["pre", "application/vnd.lotus-freelance"],
		["prf", "application/pics-rules"],
		["provx", "application/provenance+xml"],
		["ps", "application/postscript"],
		["psb", "application/vnd.3gpp.pic-bw-small"],
		["psd", "application/x-photoshop"],
		["psf", "application/x-font-linux-psf"],
		["pskcxml", "application/pskc+xml"],
		["pti", "image/prs.pti"],
		["ptid", "application/vnd.pvi.ptid1"],
		["pub", "application/x-mspublisher"],
		["pvb", "application/vnd.3gpp.pic-bw-var"],
		["pwn", "application/vnd.3m.post-it-notes"],
		["pya", "audio/vnd.ms-playready.media.pya"],
		["pyv", "video/vnd.ms-playready.media.pyv"],
		["qam", "application/vnd.epson.quickanime"],
		["qbo", "application/vnd.intu.qbo"],
		["qfx", "application/vnd.intu.qfx"],
		["qps", "application/vnd.publishare-delta-tree"],
		["qt", "video/quicktime"],
		["qwd", "application/vnd.quark.quarkxpress"],
		["qwt", "application/vnd.quark.quarkxpress"],
		["qxb", "application/vnd.quark.quarkxpress"],
		["qxd", "application/vnd.quark.quarkxpress"],
		["qxl", "application/vnd.quark.quarkxpress"],
		["qxt", "application/vnd.quark.quarkxpress"],
		["ra", "audio/x-realaudio"],
		["ram", "audio/x-pn-realaudio"],
		["raml", "application/raml+yaml"],
		["rapd", "application/route-apd+xml"],
		["rar", "application/x-rar"],
		["ras", "image/x-cmu-raster"],
		["rcprofile", "application/vnd.ipunplugged.rcprofile"],
		["rdf", "application/rdf+xml"],
		["rdz", "application/vnd.data-vision.rdz"],
		["relo", "application/p2p-overlay+xml"],
		["rep", "application/vnd.businessobjects"],
		["res", "application/x-dtbresource+xml"],
		["rgb", "image/x-rgb"],
		["rif", "application/reginfo+xml"],
		["rip", "audio/vnd.rip"],
		["ris", "application/x-research-info-systems"],
		["rl", "application/resource-lists+xml"],
		["rlc", "image/vnd.fujixerox.edmics-rlc"],
		["rld", "application/resource-lists-diff+xml"],
		["rm", "audio/x-pn-realaudio"],
		["rmi", "audio/midi"],
		["rmp", "audio/x-pn-realaudio-plugin"],
		["rms", "application/vnd.jcp.javame.midlet-rms"],
		["rmvb", "application/vnd.rn-realmedia-vbr"],
		["rnc", "application/relax-ng-compact-syntax"],
		["rng", "application/xml"],
		["roa", "application/rpki-roa"],
		["roff", "text/troff"],
		["rp9", "application/vnd.cloanto.rp9"],
		["rpm", "audio/x-pn-realaudio-plugin"],
		["rpss", "application/vnd.nokia.radio-presets"],
		["rpst", "application/vnd.nokia.radio-preset"],
		["rq", "application/sparql-query"],
		["rs", "application/rls-services+xml"],
		["rsa", "application/x-pkcs7"],
		["rsat", "application/atsc-rsat+xml"],
		["rsd", "application/rsd+xml"],
		["rsheet", "application/urc-ressheet+xml"],
		["rss", "application/rss+xml"],
		["rtf", "text/rtf"],
		["rtx", "text/richtext"],
		["run", "application/x-makeself"],
		["rusd", "application/route-usd+xml"],
		["rv", "video/vnd.rn-realvideo"],
		["s", "text/x-asm"],
		["s3m", "audio/s3m"],
		["saf", "application/vnd.yamaha.smaf-audio"],
		["sass", "text/x-sass"],
		["sbml", "application/sbml+xml"],
		["sc", "application/vnd.ibm.secure-container"],
		["scd", "application/x-msschedule"],
		["scm", "application/vnd.lotus-screencam"],
		["scq", "application/scvp-cv-request"],
		["scs", "application/scvp-cv-response"],
		["scss", "text/x-scss"],
		["scurl", "text/vnd.curl.scurl"],
		["sda", "application/vnd.stardivision.draw"],
		["sdc", "application/vnd.stardivision.calc"],
		["sdd", "application/vnd.stardivision.impress"],
		["sdkd", "application/vnd.solent.sdkm+xml"],
		["sdkm", "application/vnd.solent.sdkm+xml"],
		["sdp", "application/sdp"],
		["sdw", "application/vnd.stardivision.writer"],
		["sea", "application/octet-stream"],
		["see", "application/vnd.seemail"],
		["seed", "application/vnd.fdsn.seed"],
		["sema", "application/vnd.sema"],
		["semd", "application/vnd.semd"],
		["semf", "application/vnd.semf"],
		["senmlx", "application/senml+xml"],
		["sensmlx", "application/sensml+xml"],
		["ser", "application/java-serialized-object"],
		["setpay", "application/set-payment-initiation"],
		["setreg", "application/set-registration-initiation"],
		["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
		["sfs", "application/vnd.spotfire.sfs"],
		["sfv", "text/x-sfv"],
		["sgi", "image/sgi"],
		["sgl", "application/vnd.stardivision.writer-global"],
		["sgm", "text/sgml"],
		["sgml", "text/sgml"],
		["sh", "application/x-sh"],
		["shar", "application/x-shar"],
		["shex", "text/shex"],
		["shf", "application/shf+xml"],
		["shtml", "text/html"],
		["sid", "image/x-mrsid-image"],
		["sieve", "application/sieve"],
		["sig", "application/pgp-signature"],
		["sil", "audio/silk"],
		["silo", "model/mesh"],
		["sis", "application/vnd.symbian.install"],
		["sisx", "application/vnd.symbian.install"],
		["sit", "application/x-stuffit"],
		["sitx", "application/x-stuffitx"],
		["siv", "application/sieve"],
		["skd", "application/vnd.koan"],
		["skm", "application/vnd.koan"],
		["skp", "application/vnd.koan"],
		["skt", "application/vnd.koan"],
		["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
		["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
		["slim", "text/slim"],
		["slm", "text/slim"],
		["sls", "application/route-s-tsid+xml"],
		["slt", "application/vnd.epson.salt"],
		["sm", "application/vnd.stepmania.stepchart"],
		["smf", "application/vnd.stardivision.math"],
		["smi", "application/smil"],
		["smil", "application/smil"],
		["smv", "video/x-smv"],
		["smzip", "application/vnd.stepmania.package"],
		["snd", "audio/basic"],
		["snf", "application/x-font-snf"],
		["so", "application/octet-stream"],
		["spc", "application/x-pkcs7-certificates"],
		["spdx", "text/spdx"],
		["spf", "application/vnd.yamaha.smaf-phrase"],
		["spl", "application/x-futuresplash"],
		["spot", "text/vnd.in3d.spot"],
		["spp", "application/scvp-vp-response"],
		["spq", "application/scvp-vp-request"],
		["spx", "audio/ogg"],
		["sql", "application/x-sql"],
		["src", "application/x-wais-source"],
		["srt", "application/x-subrip"],
		["sru", "application/sru+xml"],
		["srx", "application/sparql-results+xml"],
		["ssdl", "application/ssdl+xml"],
		["sse", "application/vnd.kodak-descriptor"],
		["ssf", "application/vnd.epson.ssf"],
		["ssml", "application/ssml+xml"],
		["sst", "application/octet-stream"],
		["st", "application/vnd.sailingtracker.track"],
		["stc", "application/vnd.sun.xml.calc.template"],
		["std", "application/vnd.sun.xml.draw.template"],
		["stf", "application/vnd.wt.stf"],
		["sti", "application/vnd.sun.xml.impress.template"],
		["stk", "application/hyperstudio"],
		["stl", "model/stl"],
		["stpx", "model/step+xml"],
		["stpxz", "model/step-xml+zip"],
		["stpz", "model/step+zip"],
		["str", "application/vnd.pg.format"],
		["stw", "application/vnd.sun.xml.writer.template"],
		["styl", "text/stylus"],
		["stylus", "text/stylus"],
		["sub", "text/vnd.dvb.subtitle"],
		["sus", "application/vnd.sus-calendar"],
		["susp", "application/vnd.sus-calendar"],
		["sv4cpio", "application/x-sv4cpio"],
		["sv4crc", "application/x-sv4crc"],
		["svc", "application/vnd.dvb.service"],
		["svd", "application/vnd.svd"],
		["svg", "image/svg+xml"],
		["svgz", "image/svg+xml"],
		["swa", "application/x-director"],
		["swf", "application/x-shockwave-flash"],
		["swi", "application/vnd.aristanetworks.swi"],
		["swidtag", "application/swid+xml"],
		["sxc", "application/vnd.sun.xml.calc"],
		["sxd", "application/vnd.sun.xml.draw"],
		["sxg", "application/vnd.sun.xml.writer.global"],
		["sxi", "application/vnd.sun.xml.impress"],
		["sxm", "application/vnd.sun.xml.math"],
		["sxw", "application/vnd.sun.xml.writer"],
		["t", "text/troff"],
		["t3", "application/x-t3vm-image"],
		["t38", "image/t38"],
		["taglet", "application/vnd.mynfc"],
		["tao", "application/vnd.tao.intent-module-archive"],
		["tap", "image/vnd.tencent.tap"],
		["tar", "application/x-tar"],
		["tcap", "application/vnd.3gpp2.tcap"],
		["tcl", "application/x-tcl"],
		["td", "application/urc-targetdesc+xml"],
		["teacher", "application/vnd.smart.teacher"],
		["tei", "application/tei+xml"],
		["teicorpus", "application/tei+xml"],
		["tex", "application/x-tex"],
		["texi", "application/x-texinfo"],
		["texinfo", "application/x-texinfo"],
		["text", "text/plain"],
		["tfi", "application/thraud+xml"],
		["tfm", "application/x-tex-tfm"],
		["tfx", "image/tiff-fx"],
		["tga", "image/x-tga"],
		["tgz", "application/x-tar"],
		["thmx", "application/vnd.ms-officetheme"],
		["tif", "image/tiff"],
		["tiff", "image/tiff"],
		["tk", "application/x-tcl"],
		["tmo", "application/vnd.tmobile-livetv"],
		["toml", "application/toml"],
		["torrent", "application/x-bittorrent"],
		["tpl", "application/vnd.groove-tool-template"],
		["tpt", "application/vnd.trid.tpt"],
		["tr", "text/troff"],
		["tra", "application/vnd.trueapp"],
		["trig", "application/trig"],
		["trm", "application/x-msterminal"],
		["ts", "video/mp2t"],
		["tsd", "application/timestamped-data"],
		["tsv", "text/tab-separated-values"],
		["ttc", "font/collection"],
		["ttf", "font/ttf"],
		["ttl", "text/turtle"],
		["ttml", "application/ttml+xml"],
		["twd", "application/vnd.simtech-mindmapper"],
		["twds", "application/vnd.simtech-mindmapper"],
		["txd", "application/vnd.genomatix.tuxedo"],
		["txf", "application/vnd.mobius.txf"],
		["txt", "text/plain"],
		["u8dsn", "message/global-delivery-status"],
		["u8hdr", "message/global-headers"],
		["u8mdn", "message/global-disposition-notification"],
		["u8msg", "message/global"],
		["u32", "application/x-authorware-bin"],
		["ubj", "application/ubjson"],
		["udeb", "application/x-debian-package"],
		["ufd", "application/vnd.ufdl"],
		["ufdl", "application/vnd.ufdl"],
		["ulx", "application/x-glulx"],
		["umj", "application/vnd.umajin"],
		["unityweb", "application/vnd.unity"],
		["uoml", "application/vnd.uoml+xml"],
		["uri", "text/uri-list"],
		["uris", "text/uri-list"],
		["urls", "text/uri-list"],
		["usdz", "model/vnd.usdz+zip"],
		["ustar", "application/x-ustar"],
		["utz", "application/vnd.uiq.theme"],
		["uu", "text/x-uuencode"],
		["uva", "audio/vnd.dece.audio"],
		["uvd", "application/vnd.dece.data"],
		["uvf", "application/vnd.dece.data"],
		["uvg", "image/vnd.dece.graphic"],
		["uvh", "video/vnd.dece.hd"],
		["uvi", "image/vnd.dece.graphic"],
		["uvm", "video/vnd.dece.mobile"],
		["uvp", "video/vnd.dece.pd"],
		["uvs", "video/vnd.dece.sd"],
		["uvt", "application/vnd.dece.ttml+xml"],
		["uvu", "video/vnd.uvvu.mp4"],
		["uvv", "video/vnd.dece.video"],
		["uvva", "audio/vnd.dece.audio"],
		["uvvd", "application/vnd.dece.data"],
		["uvvf", "application/vnd.dece.data"],
		["uvvg", "image/vnd.dece.graphic"],
		["uvvh", "video/vnd.dece.hd"],
		["uvvi", "image/vnd.dece.graphic"],
		["uvvm", "video/vnd.dece.mobile"],
		["uvvp", "video/vnd.dece.pd"],
		["uvvs", "video/vnd.dece.sd"],
		["uvvt", "application/vnd.dece.ttml+xml"],
		["uvvu", "video/vnd.uvvu.mp4"],
		["uvvv", "video/vnd.dece.video"],
		["uvvx", "application/vnd.dece.unspecified"],
		["uvvz", "application/vnd.dece.zip"],
		["uvx", "application/vnd.dece.unspecified"],
		["uvz", "application/vnd.dece.zip"],
		["vbox", "application/x-virtualbox-vbox"],
		["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
		["vcard", "text/vcard"],
		["vcd", "application/x-cdlink"],
		["vcf", "text/x-vcard"],
		["vcg", "application/vnd.groove-vcard"],
		["vcs", "text/x-vcalendar"],
		["vcx", "application/vnd.vcx"],
		["vdi", "application/x-virtualbox-vdi"],
		["vds", "model/vnd.sap.vds"],
		["vhd", "application/x-virtualbox-vhd"],
		["vis", "application/vnd.visionary"],
		["viv", "video/vnd.vivo"],
		["vlc", "application/videolan"],
		["vmdk", "application/x-virtualbox-vmdk"],
		["vob", "video/x-ms-vob"],
		["vor", "application/vnd.stardivision.writer"],
		["vox", "application/x-authorware-bin"],
		["vrml", "model/vrml"],
		["vsd", "application/vnd.visio"],
		["vsf", "application/vnd.vsf"],
		["vss", "application/vnd.visio"],
		["vst", "application/vnd.visio"],
		["vsw", "application/vnd.visio"],
		["vtf", "image/vnd.valve.source.texture"],
		["vtt", "text/vtt"],
		["vtu", "model/vnd.vtu"],
		["vxml", "application/voicexml+xml"],
		["w3d", "application/x-director"],
		["wad", "application/x-doom"],
		["wadl", "application/vnd.sun.wadl+xml"],
		["war", "application/java-archive"],
		["wasm", "application/wasm"],
		["wav", "audio/x-wav"],
		["wax", "audio/x-ms-wax"],
		["wbmp", "image/vnd.wap.wbmp"],
		["wbs", "application/vnd.criticaltools.wbs+xml"],
		["wbxml", "application/wbxml"],
		["wcm", "application/vnd.ms-works"],
		["wdb", "application/vnd.ms-works"],
		["wdp", "image/vnd.ms-photo"],
		["weba", "audio/webm"],
		["webapp", "application/x-web-app-manifest+json"],
		["webm", "video/webm"],
		["webmanifest", "application/manifest+json"],
		["webp", "image/webp"],
		["wg", "application/vnd.pmi.widget"],
		["wgt", "application/widget"],
		["wks", "application/vnd.ms-works"],
		["wm", "video/x-ms-wm"],
		["wma", "audio/x-ms-wma"],
		["wmd", "application/x-ms-wmd"],
		["wmf", "image/wmf"],
		["wml", "text/vnd.wap.wml"],
		["wmlc", "application/wmlc"],
		["wmls", "text/vnd.wap.wmlscript"],
		["wmlsc", "application/vnd.wap.wmlscriptc"],
		["wmv", "video/x-ms-wmv"],
		["wmx", "video/x-ms-wmx"],
		["wmz", "application/x-msmetafile"],
		["woff", "font/woff"],
		["woff2", "font/woff2"],
		["word", "application/msword"],
		["wpd", "application/vnd.wordperfect"],
		["wpl", "application/vnd.ms-wpl"],
		["wps", "application/vnd.ms-works"],
		["wqd", "application/vnd.wqd"],
		["wri", "application/x-mswrite"],
		["wrl", "model/vrml"],
		["wsc", "message/vnd.wfa.wsc"],
		["wsdl", "application/wsdl+xml"],
		["wspolicy", "application/wspolicy+xml"],
		["wtb", "application/vnd.webturbo"],
		["wvx", "video/x-ms-wvx"],
		["x3d", "model/x3d+xml"],
		["x3db", "model/x3d+fastinfoset"],
		["x3dbz", "model/x3d+binary"],
		["x3dv", "model/x3d-vrml"],
		["x3dvz", "model/x3d+vrml"],
		["x3dz", "model/x3d+xml"],
		["x32", "application/x-authorware-bin"],
		["x_b", "model/vnd.parasolid.transmit.binary"],
		["x_t", "model/vnd.parasolid.transmit.text"],
		["xaml", "application/xaml+xml"],
		["xap", "application/x-silverlight-app"],
		["xar", "application/vnd.xara"],
		["xav", "application/xcap-att+xml"],
		["xbap", "application/x-ms-xbap"],
		["xbd", "application/vnd.fujixerox.docuworks.binder"],
		["xbm", "image/x-xbitmap"],
		["xca", "application/xcap-caps+xml"],
		["xcs", "application/calendar+xml"],
		["xdf", "application/xcap-diff+xml"],
		["xdm", "application/vnd.syncml.dm+xml"],
		["xdp", "application/vnd.adobe.xdp+xml"],
		["xdssc", "application/dssc+xml"],
		["xdw", "application/vnd.fujixerox.docuworks"],
		["xel", "application/xcap-el+xml"],
		["xenc", "application/xenc+xml"],
		["xer", "application/patch-ops-error+xml"],
		["xfdf", "application/vnd.adobe.xfdf"],
		["xfdl", "application/vnd.xfdl"],
		["xht", "application/xhtml+xml"],
		["xhtml", "application/xhtml+xml"],
		["xhvml", "application/xv+xml"],
		["xif", "image/vnd.xiff"],
		["xl", "application/excel"],
		["xla", "application/vnd.ms-excel"],
		["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
		["xlc", "application/vnd.ms-excel"],
		["xlf", "application/xliff+xml"],
		["xlm", "application/vnd.ms-excel"],
		["xls", "application/vnd.ms-excel"],
		["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
		["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
		["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
		["xlt", "application/vnd.ms-excel"],
		["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
		["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
		["xlw", "application/vnd.ms-excel"],
		["xm", "audio/xm"],
		["xml", "application/xml"],
		["xns", "application/xcap-ns+xml"],
		["xo", "application/vnd.olpc-sugar"],
		["xop", "application/xop+xml"],
		["xpi", "application/x-xpinstall"],
		["xpl", "application/xproc+xml"],
		["xpm", "image/x-xpixmap"],
		["xpr", "application/vnd.is-xpr"],
		["xps", "application/vnd.ms-xpsdocument"],
		["xpw", "application/vnd.intercon.formnet"],
		["xpx", "application/vnd.intercon.formnet"],
		["xsd", "application/xml"],
		["xsl", "application/xml"],
		["xslt", "application/xslt+xml"],
		["xsm", "application/vnd.syncml+xml"],
		["xspf", "application/xspf+xml"],
		["xul", "application/vnd.mozilla.xul+xml"],
		["xvm", "application/xv+xml"],
		["xvml", "application/xv+xml"],
		["xwd", "image/x-xwindowdump"],
		["xyz", "chemical/x-xyz"],
		["xz", "application/x-xz"],
		["yaml", "text/yaml"],
		["yang", "application/yang"],
		["yin", "application/yin+xml"],
		["yml", "text/yaml"],
		["ymp", "text/x-suse-ymp"],
		["z", "application/x-compress"],
		["z1", "application/x-zmachine"],
		["z2", "application/x-zmachine"],
		["z3", "application/x-zmachine"],
		["z4", "application/x-zmachine"],
		["z5", "application/x-zmachine"],
		["z6", "application/x-zmachine"],
		["z7", "application/x-zmachine"],
		["z8", "application/x-zmachine"],
		["zaz", "application/vnd.zzazz.deck+xml"],
		["zip", "application/zip"],
		["zir", "application/vnd.zul"],
		["zirz", "application/vnd.zul"],
		["zmm", "application/vnd.handheld-entertainment+xml"],
		["zsh", "text/x-scriptzsh"]
	]);
}));
//#endregion
//#region ../../../node_modules/react-dropzone/node_modules/file-selector/dist/es2015/file-selector.js
function Vd(e) {
	return Pd(this, void 0, void 0, function* () {
		return Wd(e) && Hd(e.dataTransfer) ? qd(e.dataTransfer, e.type) : Ud(e) ? Gd(e) : Array.isArray(e) && e.every((e) => "getFile" in e && typeof e.getFile == "function") ? Kd(e) : [];
	});
}
function Hd(e) {
	return Wd(e);
}
function Ud(e) {
	return Wd(e) && Wd(e.target);
}
function Wd(e) {
	return typeof e == "object" && !!e;
}
function Gd(e) {
	return Yd(e.target.files).map((e) => Id(e));
}
function Kd(e) {
	return Pd(this, void 0, void 0, function* () {
		return (yield Promise.all(e.map((e) => e.getFile()))).map((e) => Id(e));
	});
}
function qd(e, t) {
	return Pd(this, void 0, void 0, function* () {
		if (e.items) {
			let n = Yd(e.items).filter((e) => e.kind === "file");
			return t === "drop" ? Jd(Zd(yield Promise.all(n.map(Xd)))) : n;
		}
		return Jd(Yd(e.files).map((e) => Id(e)));
	});
}
function Jd(e) {
	return e.filter((e) => nf.indexOf(e.name) === -1);
}
function Yd(e) {
	if (e === null) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function Xd(e) {
	if (typeof e.webkitGetAsEntry != "function") return Qd(e);
	let t = e.webkitGetAsEntry();
	return t && t.isDirectory ? ef(t) : Qd(e, t);
}
function Zd(e) {
	return e.reduce((e, t) => [...e, ...Array.isArray(t) ? Zd(t) : [t]], []);
}
function Qd(e, t) {
	return Pd(this, void 0, void 0, function* () {
		if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
			let t = yield e.getAsFileSystemHandle();
			if (t === null) throw Error(`${e} is not a File`);
			if (t !== void 0) {
				let e = yield t.getFile();
				return e.handle = t, Id(e);
			}
		}
		let n = e.getAsFile();
		if (!n) throw Error(`${e} is not a File`);
		return Id(n, t?.fullPath ?? void 0);
	});
}
function $d(e) {
	return Pd(this, void 0, void 0, function* () {
		return e.isDirectory ? ef(e) : tf(e);
	});
}
function ef(e) {
	let t = e.createReader();
	return new Promise((e, n) => {
		let r = [];
		function i() {
			t.readEntries((t) => Pd(this, void 0, void 0, function* () {
				if (t.length) {
					let e = Promise.all(t.map($d));
					r.push(e), i();
				} else try {
					e(yield Promise.all(r));
				} catch (e) {
					n(e);
				}
			}), (e) => {
				n(e);
			});
		}
		i();
	});
}
function tf(e) {
	return Pd(this, void 0, void 0, function* () {
		return new Promise((t, n) => {
			e.file((n) => {
				t(Id(n, e.fullPath));
			}, (e) => {
				n(e);
			});
		});
	});
}
var nf, rf = R((() => {
	Fd(), Bd(), nf = [".DS_Store", "Thumbs.db"];
})), af = R((() => {
	rf();
})), of = /* @__PURE__ */ z(((e) => {
	e.__esModule = !0, e.default = function(e, t) {
		if (e && t) {
			var n = Array.isArray(t) ? t : t.split(",");
			if (n.length === 0) return !0;
			var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
			return n.some(function(e) {
				var t = e.trim().toLowerCase();
				return t.charAt(0) === "." ? r.toLowerCase().endsWith(t) : t.endsWith("/*") ? a === t.replace(/\/.*$/, "") : i === t;
			});
		}
		return !0;
	};
}));
//#endregion
//#region ../../../node_modules/react-dropzone/dist/es/utils/index.js
function sf(e) {
	return uf(e) || lf(e) || gf(e) || cf();
}
function cf() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function lf(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function uf(e) {
	if (Array.isArray(e)) return _f(e);
}
function df(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ff(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? df(Object(n), !0).forEach(function(t) {
			pf(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : df(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function pf(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function mf(e, t) {
	return yf(e) || vf(e, t) || gf(e, t) || hf();
}
function hf() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function gf(e, t) {
	if (e) {
		if (typeof e == "string") return _f(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _f(e, t);
	}
}
function _f(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function vf(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function yf(e) {
	if (Array.isArray(e)) return e;
}
function bf(e) {
	return e.type === "" && typeof e.getAsFile == "function";
}
function xf(e, t) {
	var n = e.type === "application/x-moz-file" || Bf(e, t) || bf(e);
	return [n, n ? null : Gf(t)];
}
function Sf(e, t, n) {
	if (Cf(e.size)) {
		if (Cf(t) && Cf(n)) {
			if (e.size > n) return [!1, Kf(n)];
			if (e.size < t) return [!1, qf(t)];
		} else if (Cf(t) && e.size < t) return [!1, qf(t)];
		else if (Cf(n) && e.size > n) return [!1, Kf(n)];
	}
	return [!0, null];
}
function Cf(e) {
	return e != null;
}
function wf(e) {
	var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
	return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(e) {
		var t = mf(xf(e, n), 1)[0], a = mf(Sf(e, r, i), 1)[0], o = s ? s(e) : null;
		return t && a && !o;
	});
}
function Tf(e) {
	return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : e.cancelBubble !== void 0 && e.cancelBubble;
}
function Ef(e) {
	return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(e) {
		return e === "Files" || e === "application/x-moz-file";
	}) : !!e.target && !!e.target.files;
}
function Df(e) {
	e.preventDefault();
}
function Of(e) {
	return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function kf(e) {
	return e.indexOf("Edge/") !== -1;
}
function Af() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
	return Of(e) || kf(e);
}
function jf() {
	var e = [...arguments];
	return function(t) {
		var n = [...arguments].slice(1);
		return e.some(function(e) {
			return !Tf(t) && e && e.apply(void 0, [t].concat(n)), Tf(t);
		});
	};
}
function Mf() {
	return "showOpenFilePicker" in window;
}
function Nf(e) {
	return Cf(e) ? [{
		description: "Files",
		accept: Object.entries(e).filter(function(e) {
			var t = mf(e, 2), n = t[0], r = t[1], i = !0;
			return Lf(n) || (console.warn(`Skipped "${n}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`), i = !1), (!Array.isArray(r) || !r.every(Rf)) && (console.warn(`Skipped "${n}" because an invalid file extension was provided.`), i = !1), i;
		}).reduce(function(e, t) {
			var n = mf(t, 2), r = n[0], i = n[1];
			return ff(ff({}, e), {}, pf({}, r, i));
		}, {})
	}] : e;
}
function Pf(e) {
	if (Cf(e)) return Object.entries(e).reduce(function(e, t) {
		var n = mf(t, 2), r = n[0], i = n[1];
		return [].concat(sf(e), [r], sf(i));
	}, []).filter(function(e) {
		return Lf(e) || Rf(e);
	}).join(",");
}
function Ff(e) {
	return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function If(e) {
	return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Lf(e) {
	return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Rf(e) {
	return /^.*\.[\w]+$/.test(e);
}
var zf, Bf, Vf, Hf, Uf, Wf, Gf, Kf, qf, Jf, Yf = R((() => {
	zf = /* @__PURE__ */ Ze(of()), Bf = typeof zf.default == "function" ? zf.default : zf.default.default, Vf = "file-invalid-type", Hf = "file-too-large", Uf = "file-too-small", Wf = "too-many-files", Gf = function() {
		var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split(","), t = e.length > 1 ? `one of ${e.join(", ")}` : e[0];
		return {
			code: Vf,
			message: `File type must be ${t}`
		};
	}, Kf = function(e) {
		return {
			code: Hf,
			message: `File is larger than ${e} ${e === 1 ? "byte" : "bytes"}`
		};
	}, qf = function(e) {
		return {
			code: Uf,
			message: `File is smaller than ${e} ${e === 1 ? "byte" : "bytes"}`
		};
	}, Jf = {
		code: Wf,
		message: "Too many files"
	};
}));
//#endregion
//#region ../../../node_modules/react-dropzone/dist/es/index.js
function Xf(e) {
	return $f(e) || Qf(e) || np(e) || Zf();
}
function Zf() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Qf(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function $f(e) {
	if (Array.isArray(e)) return rp(e);
}
function ep(e, t) {
	return ap(e) || ip(e, t) || np(e, t) || tp();
}
function tp() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function np(e, t) {
	if (e) {
		if (typeof e == "string") return rp(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rp(e, t);
	}
}
function rp(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function ip(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function ap(e) {
	if (Array.isArray(e)) return e;
}
function op(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Q(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? op(Object(n), !0).forEach(function(t) {
			sp(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : op(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function sp(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function cp(e, t) {
	if (e == null) return {};
	var n = lp(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
function lp(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
function up() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Q(Q({}, vp), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, p = t.onDropAccepted, m = t.onDropRejected, h = t.onFileDialogCancel, g = t.onFileDialogOpen, _ = t.useFsAccessApi, v = t.autoFocus, ee = t.preventDropOnDocument, y = t.noClick, b = t.noKeyboard, x = t.noDrag, S = t.noDragEventsBubbling, C = t.onError, w = t.validator, T = Te(function() {
		return Pf(n);
	}, [n]), E = Te(function() {
		return Nf(n);
	}, [n]), te = Te(function() {
		return typeof g == "function" ? g : fp;
	}, [g]), ne = Te(function() {
		return typeof h == "function" ? h : fp;
	}, [h]), D = P(null), re = P(null), ie = ep(Ee(dp, yp), 2), ae = ie[0], O = ie[1], oe = ae.isFocused, se = ae.isFileDialogActive, k = P(typeof window < "u" && window.isSecureContext && _ && Mf()), ce = function() {
		!k.current && se && setTimeout(function() {
			re.current && (re.current.files.length || (O({ type: "closeDialog" }), ne()));
		}, 300);
	};
	N(function() {
		return window.addEventListener("focus", ce, !1), function() {
			window.removeEventListener("focus", ce, !1);
		};
	}, [
		re,
		se,
		ne,
		k
	]);
	var le = P([]), A = P([]), ue = function(e) {
		D.current && D.current.contains(e.target) || (e.preventDefault(), le.current = []);
	};
	N(function() {
		return ee && (document.addEventListener("dragover", Df, !1), document.addEventListener("drop", ue, !1)), function() {
			ee && (document.removeEventListener("dragover", Df), document.removeEventListener("drop", ue));
		};
	}, [D, ee]), N(function() {
		var e = function(e) {
			A.current = [].concat(Xf(A.current), [e.target]), Ef(e) && O({
				isDragGlobal: !0,
				type: "setDragGlobal"
			});
		}, t = function(e) {
			A.current = A.current.filter(function(t) {
				return t !== e.target && t !== null;
			}), !(A.current.length > 0) && O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, n = function() {
			A.current = [], O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, r = function() {
			A.current = [], O({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		};
		return document.addEventListener("dragenter", e, !1), document.addEventListener("dragleave", t, !1), document.addEventListener("dragend", n, !1), document.addEventListener("drop", r, !1), function() {
			document.removeEventListener("dragenter", e), document.removeEventListener("dragleave", t), document.removeEventListener("dragend", n), document.removeEventListener("drop", r);
		};
	}, [D]), N(function() {
		return !r && v && D.current && D.current.focus(), function() {};
	}, [
		D,
		v,
		r
	]);
	var de = M(function(e) {
		C ? C(e) : console.error(e);
	}, [C]), j = M(function(e) {
		e.preventDefault(), e.persist(), we(e), le.current = [].concat(Xf(le.current), [e.target]), Ef(e) && Promise.resolve(i(e)).then(function(t) {
			if (!(Tf(e) && !S)) {
				var n = t.length, r = n > 0 && wf({
					files: t,
					accept: T,
					minSize: o,
					maxSize: a,
					multiple: s,
					maxFiles: c,
					validator: w
				});
				O({
					isDragAccept: r,
					isDragReject: n > 0 && !r,
					isDragActive: !0,
					type: "setDraggedFiles"
				}), l && l(e);
			}
		}).catch(function(e) {
			return de(e);
		});
	}, [
		i,
		l,
		de,
		S,
		T,
		o,
		a,
		s,
		c,
		w
	]), fe = M(function(e) {
		e.preventDefault(), e.persist(), we(e);
		var t = Ef(e);
		if (t && e.dataTransfer) try {
			e.dataTransfer.dropEffect = "copy";
		} catch {}
		return t && d && d(e), !1;
	}, [d, S]), pe = M(function(e) {
		e.preventDefault(), e.persist(), we(e);
		var t = le.current.filter(function(e) {
			return D.current && D.current.contains(e);
		}), n = t.indexOf(e.target);
		n !== -1 && t.splice(n, 1), le.current = t, !(t.length > 0) && (O({
			type: "setDraggedFiles",
			isDragActive: !1,
			isDragAccept: !1,
			isDragReject: !1
		}), Ef(e) && u && u(e));
	}, [
		D,
		u,
		S
	]), me = M(function(e, t) {
		var n = [], r = [];
		e.forEach(function(e) {
			var t = ep(xf(e, T), 2), i = t[0], s = t[1], c = ep(Sf(e, o, a), 2), l = c[0], u = c[1], d = w ? w(e) : null;
			if (i && l && !d) n.push(e);
			else {
				var f = [s, u];
				d && (f = f.concat(d)), r.push({
					file: e,
					errors: f.filter(function(e) {
						return e;
					})
				});
			}
		}), (!s && n.length > 1 || s && c >= 1 && n.length > c) && (n.forEach(function(e) {
			r.push({
				file: e,
				errors: [Jf]
			});
		}), n.splice(0)), O({
			acceptedFiles: n,
			fileRejections: r,
			isDragReject: r.length > 0,
			type: "setFiles"
		}), f && f(n, r, t), r.length > 0 && m && m(r, t), n.length > 0 && p && p(n, t);
	}, [
		O,
		s,
		T,
		o,
		a,
		c,
		f,
		p,
		m,
		w
	]), he = M(function(e) {
		e.preventDefault(), e.persist(), we(e), le.current = [], Ef(e) && Promise.resolve(i(e)).then(function(t) {
			Tf(e) && !S || me(t, e);
		}).catch(function(e) {
			return de(e);
		}), O({ type: "reset" });
	}, [
		i,
		me,
		de,
		S
	]), ge = M(function() {
		if (k.current) {
			O({ type: "openDialog" }), te();
			var e = {
				multiple: s,
				types: E
			};
			window.showOpenFilePicker(e).then(function(e) {
				return i(e);
			}).then(function(e) {
				me(e, null), O({ type: "closeDialog" });
			}).catch(function(e) {
				Ff(e) ? (ne(e), O({ type: "closeDialog" })) : If(e) ? (k.current = !1, re.current ? (re.current.value = null, re.current.click()) : de(/* @__PURE__ */ Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : de(e);
			});
			return;
		}
		re.current && (O({ type: "openDialog" }), te(), re.current.value = null, re.current.click());
	}, [
		O,
		te,
		ne,
		_,
		me,
		de,
		E,
		s
	]), _e = M(function(e) {
		!D.current || !D.current.isEqualNode(e.target) || (e.key === " " || e.key === "Enter" || e.keyCode === 32 || e.keyCode === 13) && (e.preventDefault(), ge());
	}, [D, ge]), ve = M(function() {
		O({ type: "focus" });
	}, []), ye = M(function() {
		O({ type: "blur" });
	}, []), be = M(function() {
		y || (Af() ? setTimeout(ge, 0) : ge());
	}, [y, ge]), xe = function(e) {
		return r ? null : e;
	}, Se = function(e) {
		return b ? null : xe(e);
	}, Ce = function(e) {
		return x ? null : xe(e);
	}, we = function(e) {
		S && e.stopPropagation();
	}, De = Te(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, i = e.role, a = e.onKeyDown, o = e.onFocus, s = e.onBlur, c = e.onClick, l = e.onDragEnter, u = e.onDragOver, d = e.onDragLeave, f = e.onDrop, p = cp(e, hp);
			return Q(Q(sp({
				onKeyDown: Se(jf(a, _e)),
				onFocus: Se(jf(o, ve)),
				onBlur: Se(jf(s, ye)),
				onClick: xe(jf(c, be)),
				onDragEnter: Ce(jf(l, j)),
				onDragOver: Ce(jf(u, fe)),
				onDragLeave: Ce(jf(d, pe)),
				onDrop: Ce(jf(f, he)),
				role: typeof i == "string" && i !== "" ? i : "presentation"
			}, n, D), !r && !b ? { tabIndex: 0 } : {}), p);
		};
	}, [
		D,
		_e,
		ve,
		ye,
		be,
		j,
		fe,
		pe,
		he,
		b,
		x,
		r
	]), Oe = M(function(e) {
		e.stopPropagation();
	}, []), ke = Te(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, r = e.onChange, i = e.onClick, a = cp(e, gp);
			return Q(Q({}, sp({
				accept: T,
				multiple: s,
				type: "file",
				style: {
					border: 0,
					clip: "rect(0, 0, 0, 0)",
					clipPath: "inset(50%)",
					height: "1px",
					margin: "0 -1px -1px 0",
					overflow: "hidden",
					padding: 0,
					position: "absolute",
					width: "1px",
					whiteSpace: "nowrap"
				},
				onChange: xe(jf(r, he)),
				onClick: xe(jf(i, Oe)),
				tabIndex: -1
			}, n, re)), a);
		};
	}, [
		re,
		n,
		s,
		he,
		r
	]);
	return Q(Q({}, ae), {}, {
		isFocused: oe && !r,
		getRootProps: De,
		getInputProps: ke,
		rootRef: D,
		inputRef: re,
		open: xe(ge)
	});
}
function dp(e, t) {
	/* istanbul ignore next */
	switch (t.type) {
		case "focus": return Q(Q({}, e), {}, { isFocused: !0 });
		case "blur": return Q(Q({}, e), {}, { isFocused: !1 });
		case "openDialog": return Q(Q({}, yp), {}, { isFileDialogActive: !0 });
		case "closeDialog": return Q(Q({}, e), {}, { isFileDialogActive: !1 });
		case "setDraggedFiles": return Q(Q({}, e), {}, {
			isDragActive: t.isDragActive,
			isDragAccept: t.isDragAccept,
			isDragReject: t.isDragReject
		});
		case "setFiles": return Q(Q({}, e), {}, {
			acceptedFiles: t.acceptedFiles,
			fileRejections: t.fileRejections,
			isDragReject: t.isDragReject
		});
		case "setDragGlobal": return Q(Q({}, e), {}, { isDragGlobal: t.isDragGlobal });
		case "reset": return Q({}, yp);
		default: return e;
	}
}
function fp() {}
var $, pp, mp, hp, gp, _p, vp, yp, bp = R((() => {
	$ = /* @__PURE__ */ Ze(Nd()), af(), Yf(), pp = ["children"], mp = ["open"], hp = [
		"refKey",
		"role",
		"onKeyDown",
		"onFocus",
		"onBlur",
		"onClick",
		"onDragEnter",
		"onDragOver",
		"onDragLeave",
		"onDrop"
	], gp = [
		"refKey",
		"onChange",
		"onClick"
	], _p = /*#__PURE__*/ ye(function(e, t) {
		var n = e.children, r = up(cp(e, pp)), i = r.open, a = cp(r, mp);
		return we(t, function() {
			return { open: i };
		}, [i]), /*#__PURE__*/ he.createElement(ge, null, n(Q(Q({}, a), {}, { open: i })));
	}), _p.displayName = "Dropzone", vp = {
		disabled: !1,
		getFilesFromEvent: Vd,
		maxSize: Infinity,
		minSize: 0,
		multiple: !0,
		maxFiles: 0,
		preventDropOnDocument: !0,
		noClick: !1,
		noKeyboard: !1,
		noDrag: !1,
		noDragEventsBubbling: !1,
		validator: null,
		useFsAccessApi: !1,
		autoFocus: !1
	}, _p.defaultProps = vp, _p.propTypes = {
		children: $.default.func,
		accept: $.default.objectOf($.default.arrayOf($.default.string)),
		multiple: $.default.bool,
		preventDropOnDocument: $.default.bool,
		noClick: $.default.bool,
		noKeyboard: $.default.bool,
		noDrag: $.default.bool,
		noDragEventsBubbling: $.default.bool,
		minSize: $.default.number,
		maxSize: $.default.number,
		maxFiles: $.default.number,
		disabled: $.default.bool,
		getFilesFromEvent: $.default.func,
		onFileDialogCancel: $.default.func,
		onFileDialogOpen: $.default.func,
		useFsAccessApi: $.default.bool,
		autoFocus: $.default.bool,
		onDragEnter: $.default.func,
		onDragLeave: $.default.func,
		onDragOver: $.default.func,
		onDrop: $.default.func,
		onDropAccepted: $.default.func,
		onDropRejected: $.default.func,
		onError: $.default.func,
		validator: $.default.func
	}, yp = {
		isFocused: !1,
		isFileDialogActive: !1,
		isDragActive: !1,
		isDragAccept: !1,
		isDragReject: !1,
		isDragGlobal: !1,
		acceptedFiles: [],
		fileRejections: []
	};
})), xp, Sp, Cp, wp, Tp, Ep, Dp, Op = R((() => {
	xp = "_dropzone_1wf8u_1", Sp = "_isFocused_1wf8u_7", Cp = "_isDragAccept_1wf8u_11", wp = "_isDragReject_1wf8u_15", Tp = "_heading_1wf8u_20", Ep = "_uploadErrorText_1wf8u_24", Dp = {
		dropzone: xp,
		isFocused: Sp,
		isDragAccept: Cp,
		isDragReject: wp,
		heading: Tp,
		uploadErrorText: Ep
	};
})), kp, Ap, jp, Mp, Np, Pp = R((() => {
	bp(), Op(), kp = ({ file: e, onDrop: t, uploadError: n, padding: r, title: i, description: a, height: o = "160px", width: s = "100%" }) => {
		let { getRootProps: c, getInputProps: l, open: u, isFocused: d, isDragAccept: f, isDragReject: m } = up({
			noClick: !0,
			maxFiles: 1,
			onDrop: t,
			accept: { "image/*": [
				".png",
				".jpg",
				".jpeg"
			] }
		});
		return /* @__PURE__ */ L(p, {
			padding: r,
			children: [/* @__PURE__ */ L(C, {
				...c({
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					className: pe(Dp.dropzone, {
						[Dp.isFocused]: d,
						[Dp.isDragAccept]: f,
						[Dp.isDragReject]: m
					}),
					onClick: u,
					color: "#46597C",
					gap: "200",
					minWidth: "305px",
					style: {
						height: o,
						width: s
					}
				}),
				children: [e && !n ? /* @__PURE__ */ I(Np, { filename: e.name }) : /* @__PURE__ */ L(F, { children: [
					f && /* @__PURE__ */ I(jp, {}),
					m && /* @__PURE__ */ I(Mp, {}),
					!f && !m && /* @__PURE__ */ I(Ap, {
						title: i,
						description: a
					})
				] }), /* @__PURE__ */ I("input", { ...l() })]
			}), n && e && /* @__PURE__ */ I(j.Input, {
				className: Dp.uploadErrorText,
				variant: "error",
				clamp: 5,
				wrap: "pre-wrap",
				children: `File could not be uploaded. ${n.message}`
			})]
		});
	}, Ap = ({ title: e, description: t }) => /* @__PURE__ */ L(F, { children: [
		/* @__PURE__ */ I(E, {
			name: "cloud-upload",
			size: 20
		}),
		e && /* @__PURE__ */ I(j.Paragraph, {
			variant: "1",
			className: Dp.heading,
			children: e
		}),
		t && /* @__PURE__ */ I(j.Paragraph, {
			color: "secondary",
			variant: "4",
			children: t
		})
	] }), jp = () => /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(E, {
		name: "check-circle-filled",
		size: 20,
		className: Dp.dropzoneIcon
	}), /* @__PURE__ */ I(j.Heading, { children: "Drop to upload image" })] }), Mp = () => /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(E, {
		name: "exclamation-circle-filled",
		size: 20,
		className: Dp.dropzoneIcon
	}), /* @__PURE__ */ I(j.Heading, { children: "Image will not upload" })] }), Np = ({ filename: e }) => /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(ce, {
		className: Dp.dropzoneIcon,
		size: 20
	}), /* @__PURE__ */ L(j.Heading, { children: ["Uploading ", e] })] });
}));
//#endregion
//#region ../management-common/src/components/imageUpload/index.tsx
function Fp({ uploading: e, removing: t, uploadError: n, image: r, onDrop: i, onRemoveImage: a }) {
	let o = P(null), s = (e) => {
		e.target.files && i && i(Array.from(e.target.files), [], e);
	}, c = () => {
		a();
	}, l = r?.url;
	return /* @__PURE__ */ L(p, { children: [/* @__PURE__ */ L(C, {
		gap: "300",
		alignItems: "center",
		children: [
			!r && !e && /* @__PURE__ */ I(p, {
				className: Sd.uploadDropzoneWrapper,
				children: /* @__PURE__ */ I(kp, {
					file: null,
					onDrop: i,
					uploadError: n,
					description: "Choose an image...",
					width: "160px",
					height: "80px"
				})
			}),
			e && /* @__PURE__ */ I(Ip, { label: "Uploading..." }),
			t && /* @__PURE__ */ I(Ip, { label: "Removing..." }),
			!!r && !e && !t && /* @__PURE__ */ I(Lp, { image: r }),
			/* @__PURE__ */ I("input", {
				id: "change-image",
				type: "file",
				ref: o,
				style: { display: "none" },
				onChange: s
			}),
			!e && n && /* @__PURE__ */ I(m, {
				variant: "secondary",
				onClick: c,
				children: "Try again"
			}),
			!e && !t && l && !n && /* @__PURE__ */ L(C, {
				gap: "200",
				children: [/* @__PURE__ */ I(m, {
					variant: "secondary",
					children: /* @__PURE__ */ I("label", {
						htmlFor: "change-image",
						children: "Change..."
					})
				}), /* @__PURE__ */ I(m, {
					variant: "secondary",
					onClick: a,
					children: "Remove"
				})]
			})
		]
	}), n && /* @__PURE__ */ I(y, {
		variant: "error",
		className: Sd.alert,
		children: n.message || "Image failed to upload. Please try again or try a new image."
	})] });
}
function Ip({ label: e }) {
	return /* @__PURE__ */ L(C, {
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		id: "wrapper",
		width: "160px",
		height: "80px",
		gap: "200",
		className: Sd.uploadDropzoneLoadingWrapper,
		children: [/* @__PURE__ */ I(ce, { size: 16 }), /* @__PURE__ */ I(j.Paragraph, {
			subdued: !0,
			variant: "4",
			children: e
		})]
	});
}
function Lp({ image: e }) {
	return /* @__PURE__ */ I(p, {
		className: Sd.uploadImageWrapper,
		children: /* @__PURE__ */ I("img", {
			className: Sd.uploadImage,
			src: e.url,
			alt: `Image filename: ${e.filename}`
		})
	});
}
var Rp = R((() => {
	Cd(), Pp();
}));
//#endregion
//#region ../utils/src/string.ts
function zp(e) {
	return e.substring(e.lastIndexOf("/") + 1);
}
var Bp = R((() => {}));
//#endregion
//#region ../management-common/src/hooks/useUploadImage.ts
function Vp(e) {
	let t = new DataView(e, 10), n = 0, r = t.getUint8(0), i = 0;
	r & 128 && (i = 3 * 2 ** ((r & 7) + 1)), n = 3 + i;
	let a = t.getUint8(n), o = t.getUint8(n + 1), s = 0;
	return a & 33 && o & 249 && (s = t.getUint16(n + 4)), s > 0;
}
async function Hp(e) {
	if (e.type === "image/gif") {
		let t = await e.arrayBuffer();
		try {
			if (Vp(t) && e.size > Kp) return /* @__PURE__ */ Error("File size exceeds max allowed");
		} catch {}
	}
	return e.size > Gp ? /* @__PURE__ */ Error("File size exceeds max allowed") : null;
}
function Up() {
	let [e, { error: t, reset: n }] = Pt(), [r, i] = De(void 0), [a, o] = De(!1);
	return [
		M(async (t) => {
			n(), i(void 0);
			let r = await Hp(t);
			if (r) {
				i(r);
				return;
			}
			let { data: a } = await e({ variables: { fileName: t.name } }), s = a?.fileUploadRequest;
			if (!s) {
				i(/* @__PURE__ */ Error("Upload URL can't be found"));
				return;
			}
			let c = {
				url: s.availableAt,
				filename: zp(s.availableAt),
				width: void 0,
				height: void 0
			}, l = { "Content-Type": s.contentType };
			s.customHeaders.forEach((e) => {
				let [t, n] = e.split(":");
				l[t] = n;
			});
			try {
				o(!0), await fetch(s.uploadUrl, {
					method: s.method,
					headers: l,
					body: t
				});
			} catch (e) {
				o(!1), i(e instanceof Error ? e : /* @__PURE__ */ Error("Upload failed"));
				return;
			}
			try {
				o(!0);
				let e = await fetch(Wp(s.availableAt), { method: "GET" });
				if (!e.ok) {
					o(!1), i(/* @__PURE__ */ Error(e.status === 413 ? "File size exceeds max allowed" : "Upload failed"));
					return;
				}
				c.width = Number.parseInt(e.headers.get("x-amz-meta-original-width") || "") || void 0, c.height = Number.parseInt(e.headers.get("x-amz-meta-original-height") || "") || void 0;
			} catch (e) {
				i(e instanceof Error ? e : /* @__PURE__ */ Error("Upload failed"));
				return;
			} finally {
				o(!1);
			}
			return c;
		}, [e, n]),
		t || r,
		a
	];
}
function Wp(e, t) {
	return `${e}?width=${Math.min(qp, t || qp)}`;
}
var Gp, Kp, qp, Jp = R((() => {
	V(), Bp(), Gp = 50 * 1024 * 1024, Kp = 6 * 1024 * 1024, qp = 1280;
})), Yp, Xp, Zp, Qp, $p, em, tm, nm, rm, im, am, om, sm, cm, lm, um = R((() => {
	Yp = Symbol(), Xp = Symbol(), Zp = "a", Qp = "w", $p = (e, t) => new Proxy(e, t), em = Object.getPrototypeOf, tm = /* @__PURE__ */ new WeakMap(), nm = (e) => e && (tm.has(e) ? tm.get(e) : em(e) === Object.prototype || em(e) === Array.prototype), rm = (e) => typeof e == "object" && !!e, im = (e) => {
		if (Array.isArray(e)) return Array.from(e);
		let t = Object.getOwnPropertyDescriptors(e);
		return Object.values(t).forEach((e) => {
			e.configurable = !0;
		}), Object.create(em(e), t);
	}, am = (e) => e[Xp] || e, om = (e, t, n, r) => {
		if (!nm(e)) return e;
		let i = r && r.get(e);
		if (!i) {
			let t = am(e);
			i = ((e) => Object.values(Object.getOwnPropertyDescriptors(e)).some((e) => !e.configurable && !e.writable))(t) ? [t, im(t)] : [t], r?.set(e, i);
		}
		let [a, o] = i, s = n && n.get(a);
		return s && s[1].f === !!o || (s = ((e, t) => {
			let n = { f: t }, r = !1, i = (t, i) => {
				if (!r) {
					let r = n[Zp].get(e);
					if (r || (r = {}, n[Zp].set(e, r)), t === Qp) r[Qp] = !0;
					else {
						let e = r[t];
						e || (e = /* @__PURE__ */ new Set(), r[t] = e), e.add(i);
					}
				}
			}, a = {
				get: (t, r) => r === Xp ? e : (i("k", r), om(Reflect.get(t, r), n[Zp], n.c, n.t)),
				has: (t, a) => a === Yp ? (r = !0, n[Zp].delete(e), !0) : (i("h", a), Reflect.has(t, a)),
				getOwnPropertyDescriptor: (e, t) => (i("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
				ownKeys: (e) => (i(Qp), Reflect.ownKeys(e))
			};
			return t && (a.set = a.deleteProperty = () => !1), [a, n];
		})(a, !!o), s[1].p = $p(o || a, s[0]), n && n.set(a, s)), s[1][Zp] = t, s[1].c = n, s[1].t = r, s[1].p;
	}, sm = (e, t, n, r, i = Object.is) => {
		if (i(e, t)) return !1;
		if (!rm(e) || !rm(t)) return !0;
		let a = n.get(am(e));
		if (!a) return !0;
		if (r) {
			let n = r.get(e);
			if (n && n.n === t) return n.g;
			r.set(e, {
				n: t,
				g: !1
			});
		}
		let o = null;
		try {
			for (let n of a.h || []) if (o = Reflect.has(e, n) !== Reflect.has(t, n), o) return o;
			if (!0 === a[Qp]) {
				if (o = ((e, t) => {
					let n = Reflect.ownKeys(e), r = Reflect.ownKeys(t);
					return n.length !== r.length || n.some((e, t) => e !== r[t]);
				})(e, t), o) return o;
			} else for (let n of a.o || []) if (o = !!Reflect.getOwnPropertyDescriptor(e, n) != !!Reflect.getOwnPropertyDescriptor(t, n), o) return o;
			for (let s of a.k || []) if (o = sm(e[s], t[s], n, r, i), o) return o;
			return o === null && (o = !0), o;
		} finally {
			r && r.set(e, {
				n: t,
				g: o
			});
		}
	}, cm = (e) => nm(e) && e[Xp] || null, lm = (e, t = !0) => {
		tm.set(e, t);
	};
}));
//#endregion
//#region ../../../node_modules/valtio/esm/vanilla.mjs
function dm(e = {}) {
	return vm(e);
}
function fm(e, t, n) {
	let r = hm.get(e), i, a = [], o = r[3], s = !1, c = o((e) => {
		if (a.push(e), n) {
			t(a.splice(0));
			return;
		}
		i ||= Promise.resolve().then(() => {
			i = void 0, s && t(a.splice(0));
		});
	});
	return s = !0, () => {
		s = !1, c();
	};
}
function pm(e, t) {
	let [n, r, i] = hm.get(e);
	return i(n, r(), t);
}
var mm, hm, gm, _m, vm, ym = R((() => {
	um(), mm = (e) => typeof e == "object" && !!e, hm = /* @__PURE__ */ new WeakMap(), gm = /* @__PURE__ */ new WeakSet(), _m = (e = Object.is, t = (e, t) => new Proxy(e, t), n = (e) => mm(e) && !gm.has(e) && (Array.isArray(e) || !(Symbol.iterator in e)) && !(e instanceof WeakMap) && !(e instanceof WeakSet) && !(e instanceof Error) && !(e instanceof Number) && !(e instanceof Date) && !(e instanceof String) && !(e instanceof RegExp) && !(e instanceof ArrayBuffer), r = (e) => {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: throw e;
		}
	}, i = /* @__PURE__ */ new WeakMap(), a = (e, t, n = r) => {
		let o = i.get(e);
		if (o?.[0] === t) return o[1];
		let s = Array.isArray(e) ? [] : Object.create(Object.getPrototypeOf(e));
		return lm(s, !0), i.set(e, [t, s]), Reflect.ownKeys(e).forEach((t) => {
			if (Object.getOwnPropertyDescriptor(s, t)) return;
			let r = Reflect.get(e, t), { enumerable: i } = Reflect.getOwnPropertyDescriptor(e, t), o = {
				value: r,
				enumerable: i,
				configurable: !0
			};
			if (gm.has(r)) lm(r, !1);
			else if (r instanceof Promise) delete o.value, o.get = () => n(r);
			else if (hm.has(r)) {
				let [e, t] = hm.get(r);
				o.value = a(e, t(), n);
			}
			Object.defineProperty(s, t, o);
		}), Object.preventExtensions(s);
	}, o = /* @__PURE__ */ new WeakMap(), s = [1, 1], c = (r) => {
		if (!mm(r)) throw Error("object required");
		let i = o.get(r);
		if (i) return i;
		let l = s[0], u = /* @__PURE__ */ new Set(), d = (e, t = ++s[0]) => {
			l !== t && (l = t, u.forEach((n) => n(e, t)));
		}, f = s[1], p = (e = ++s[1]) => (f !== e && !u.size && (f = e, h.forEach(([t]) => {
			let n = t[1](e);
			n > l && (l = n);
		})), l), m = (e) => (t, n) => {
			let r = [...t];
			r[1] = [e, ...r[1]], d(r, n);
		}, h = /* @__PURE__ */ new Map(), g = (e, t) => {
			if (u.size) {
				let n = t[3](m(e));
				h.set(e, [t, n]);
			} else h.set(e, [t]);
		}, _ = (e) => {
			var t;
			let n = h.get(e);
			n && (h.delete(e), (t = n[1]) == null || t.call(n));
		}, v = (e) => (u.add(e), u.size === 1 && h.forEach(([e, t], n) => {
			let r = e[3](m(n));
			h.set(n, [e, r]);
		}), () => {
			u.delete(e), u.size === 0 && h.forEach(([e, t], n) => {
				t && (t(), h.set(n, [e]));
			});
		}), ee = Array.isArray(r) ? [] : Object.create(Object.getPrototypeOf(r)), y = t(ee, {
			deleteProperty(e, t) {
				let n = Reflect.get(e, t);
				_(t);
				let r = Reflect.deleteProperty(e, t);
				return r && d([
					"delete",
					[t],
					n
				]), r;
			},
			set(t, r, i, a) {
				let s = Reflect.has(t, r), l = Reflect.get(t, r, a);
				if (s && (e(l, i) || o.has(i) && e(l, o.get(i)))) return !0;
				_(r), mm(i) && (i = cm(i) || i);
				let u = i;
				if (i instanceof Promise) i.then((e) => {
					i.status = "fulfilled", i.value = e, d([
						"resolve",
						[r],
						e
					]);
				}).catch((e) => {
					i.status = "rejected", i.reason = e, d([
						"reject",
						[r],
						e
					]);
				});
				else {
					!hm.has(i) && n(i) && (u = c(i));
					let e = !gm.has(u) && hm.get(u);
					e && g(r, e);
				}
				return Reflect.set(t, r, u, a), d([
					"set",
					[r],
					i,
					l
				]), !0;
			}
		});
		o.set(r, y);
		let b = [
			ee,
			p,
			a,
			v
		];
		return hm.set(y, b), Reflect.ownKeys(r).forEach((e) => {
			let t = Object.getOwnPropertyDescriptor(r, e);
			"value" in t && (y[e] = r[e], delete t.value, delete t.writable), Object.defineProperty(ee, e, t);
		}), y;
	}) => [
		c,
		hm,
		gm,
		e,
		t,
		n,
		r,
		i,
		a,
		o,
		s
	], [vm] = _m();
})), bm = /* @__PURE__ */ z(((e) => {
	var t = Bu();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
})), xm = /* @__PURE__ */ z(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(/* @__PURE__ */ Error());
		var t = Bu(), n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		function r(e) {
			i("error", e, [...arguments].slice(1));
		}
		function i(e, t, r) {
			var i = n.ReactDebugCurrentFrame.getStackAddendum();
			i !== "" && (t += "%s", r = r.concat([i]));
			var a = r.map(function(e) {
				return String(e);
			});
			a.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, a);
		}
		function a(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		var o = typeof Object.is == "function" ? Object.is : a, s = t.useState, c = t.useEffect, l = t.useLayoutEffect, u = t.useDebugValue, d = !1, f = !1;
		function p(e, n, i) {
			d || t.startTransition !== void 0 && (d = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var a = n();
			f || o(a, n()) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
			var p = s({ inst: {
				value: a,
				getSnapshot: n
			} }), h = p[0].inst, g = p[1];
			return l(function() {
				h.value = a, h.getSnapshot = n, m(h) && g({ inst: h });
			}, [
				e,
				a,
				n
			]), c(function() {
				return m(h) && g({ inst: h }), e(function() {
					m(h) && g({ inst: h });
				});
			}, [e]), u(a), a;
		}
		function m(e) {
			var t = e.getSnapshot, n = e.value;
			try {
				return !o(n, t());
			} catch {
				return !0;
			}
		}
		function h(e, t, n) {
			return t();
		}
		var g = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0 ? p : h;
		e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? g : t.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(/* @__PURE__ */ Error());
	})();
})), Sm = /* @__PURE__ */ z(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = bm() : t.exports = xm();
}));
//#endregion
//#region ../../../node_modules/valtio/esm/react.mjs
function Cm(e, t) {
	let n = t?.sync, r = P(), i = P(), a = !0, o = Em(M((t) => {
		let r = fm(e, t, n);
		return t(), r;
	}, [e, n]), () => {
		let t = pm(e, Tm);
		try {
			if (!a && r.current && i.current && !sm(r.current, t, i.current, /* @__PURE__ */ new WeakMap())) return r.current;
		} catch {}
		return t;
	}, () => pm(e, Tm));
	a = !1;
	let s = /* @__PURE__ */ new WeakMap();
	return N(() => {
		r.current = o, i.current = s;
	}), om(o, s, Te(() => /* @__PURE__ */ new WeakMap(), []), Dm);
}
var wm, Tm, Em, Dm, Om = R((() => {
	um(), wm = /* @__PURE__ */ Ze(Sm(), 1), ym(), {use: Tm} = he, {useSyncExternalStore: Em} = wm.default, Dm = /* @__PURE__ */ new WeakMap();
})), km = R((() => {
	ym(), Om();
})), Am, jm, Mm, Nm, Pm = R((() => {
	km(), Am = dm({
		companyLogo: null,
		favicon: null
	}), jm = () => {
		Am.companyLogo = null, Am.favicon = null;
	}, Mm = (e) => {
		Am.companyLogo = e;
	}, Nm = (e) => {
		Am.favicon = e;
	};
}));
//#endregion
//#region src/components/customizationForm/image/fieldCompanyLogoUploader.tsx
function Fm({ helpCenterId: e }) {
	let [t, { loading: n }] = Vt(), [r, i, a] = Up(), [o, { loading: s }] = It(), { successNotify: c, errorNotify: l } = Es(), u = Cm(Am);
	function d() {
		t({
			variables: { helpCenterId: e },
			onCompleted: () => {
				Mm(null), c({
					title: "Image deleted",
					text: "Image was successfully deleted"
				});
			},
			onError: (e) => {
				l({
					text: `Please try again. Cause: ${e.message}`,
					title: "Unable to update Help Center"
				});
			}
		});
	}
	let f = M(({ onChange: t, attachMutation: n, uploadMutation: r }) => async function(i) {
		if (i?.length !== 1) return;
		let a = i[0].type;
		if (a !== "image/jpg" && a !== "image/jpeg" && a !== "image/png") {
			l({
				title: "Not allowed",
				text: "Images must be .jpg, .jpeg or .png format only"
			});
			return;
		}
		let o = await r(i[0]);
		!o || !e || n({
			variables: {
				id: e,
				logo: o.url
			},
			onCompleted: () => {
				c({
					title: "Image uploaded",
					text: "Image was uploaded successfully"
				}), t(o);
			},
			onError: (e) => {
				l({
					title: "Image could not be saved",
					text: e.message
				});
			}
		});
	}, [
		l,
		e,
		c
	]);
	return /* @__PURE__ */ I(S, {
		label: "Company logo",
		noAlert: !0,
		children: /* @__PURE__ */ I(Fp, {
			uploading: a || s,
			removing: n,
			onDrop: f({
				onChange: Mm,
				attachMutation: o,
				uploadMutation: r
			}),
			uploadError: i,
			image: u.companyLogo,
			onRemoveImage: d
		})
	});
}
var Im = R((() => {
	Rp(), V(), Jp(), Ds(), km(), Pm();
}));
//#endregion
//#region src/components/customizationForm/image/fieldFaviconUploader.tsx
function Lm({ helpCenterId: e }) {
	let [t, n, r] = Up(), [i, { loading: a }] = Bt(), [o, { loading: s }] = Lt(), { successNotify: c, errorNotify: l } = Es(), u = Cm(Am);
	function d() {
		i({
			variables: { helpCenterId: e },
			onCompleted: () => {
				Nm(null), c({
					title: "Favicon deleted",
					text: "Favicon was successfully deleted"
				});
			},
			onError: (e) => {
				l({
					text: `Please try again. Cause: ${e.message}`,
					title: "Unable to update Help Center"
				});
			}
		});
	}
	let f = M(({ onChange: t, attachMutation: n, uploadMutation: r }) => async function(i) {
		if (i?.length !== 1) return;
		let a = i[0].type;
		if (a !== "image/jpg" && a !== "image/jpeg" && a !== "image/png") {
			l({
				title: "Not allowed",
				text: "Images must be .jpg, .jpeg or .png format only"
			});
			return;
		}
		let o = await r(i[0]);
		!o || !e || n({
			variables: {
				id: e,
				favicon: o.url
			},
			onCompleted: () => {
				c({
					title: "Favicon uploaded",
					text: "Favicon was uploaded successfully"
				}), t(o);
			},
			onError: (e) => {
				l({
					title: "Image could not be saved",
					text: e.message
				});
			}
		});
	}, [
		l,
		e,
		c
	]);
	return /* @__PURE__ */ I(S, {
		label: "Favicon",
		noAlert: !0,
		children: /* @__PURE__ */ I(Fp, {
			uploading: r || s,
			removing: a,
			onDrop: f({
				onChange: Nm,
				attachMutation: o,
				uploadMutation: t
			}),
			uploadError: n,
			image: u.favicon,
			onRemoveImage: d
		})
	});
}
var Rm = R((() => {
	Rp(), V(), Jp(), Ds(), km(), Pm();
}));
//#endregion
//#region ../utils/src/colors.ts
function zm(e) {
	return e.length === 9 ? e.slice(0, 7) : e;
}
var Bm = R((() => {}));
//#endregion
//#region src/utils/colors.ts
function Vm(e) {
	let t = {};
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
		let r = e[n];
		t[n] = zm(r);
	}
	return t;
}
var Hm = R((() => {
	Bm();
}));
//#endregion
//#region src/components/customizationForm/useCustomizationFormSchemaInitialValues.ts
function Um({ helpCenter: e }) {
	let { enabledLanguages: t } = Ce(Yr), { companyUrl: n, theme: { colors: r, id: i }, translations: a } = e;
	return Te(() => ({
		companyUrl: n || "",
		helpCenterTaglines: t.map((e) => {
			let t = a.find((t) => t.languageId === e.languageId);
			return {
				languageId: e.languageId,
				tagline: t?.tagline || ""
			};
		}),
		helpCenterTitles: t.map((e) => {
			let t = a.find((t) => t.languageId === e.languageId);
			return {
				languageId: e.languageId,
				title: t?.title || ""
			};
		}),
		themeId: i,
		colors: Vm(r)
	}), [
		t,
		a,
		r,
		n,
		i
	]);
}
var Wm = R((() => {
	Xr(), Hm();
}));
//#endregion
//#region src/components/customizationForm/useUpdateCustomizationSettingsForm.ts
function Gm({ onCompleted: e, onError: t }) {
	let { enabledLanguages: n } = Ce(Yr), [r, { loading: i }] = qt({ onError: t }), [a, { loading: o }] = Jt({ onError: t });
	return [async ({ helpCenterId: i, touchedFields: o, formValues: s }) => {
		let c = r({
			onError: t,
			variables: {
				helpCenterId: i,
				colors: s.colors,
				companyUrl: s.companyUrl,
				themeId: s.themeId
			}
		}), l = n.map((e, t) => {
			let n = s.helpCenterTitles, r = s.helpCenterTaglines, c = n.find((t) => t.languageId === e.languageId), l = r.find((t) => t.languageId === e.languageId), u = o.helpCenterTitles?.[t]?.title || !1, d = o.helpCenterTaglines?.[t]?.tagline || !1;
			return !u && !d ? null : a({ variables: {
				helpCenterId: i,
				translation: {
					languageId: e.languageId,
					tagline: l?.tagline || "",
					title: c?.title || ""
				}
			} });
		});
		await Promise.all([c, ...l]), e(s);
	}, { loading: i || o }];
}
var Km = R((() => {
	Xr(), V();
}));
//#endregion
//#region src/components/customizationForm/customizationFormContent.tsx
function qm({ helpCenter: e }) {
	let { id: t, logo: n, favicon: r } = e;
	N(() => {
		jm();
	}, [t]), Jm({
		initialLogo: n,
		initialFavicon: r
	});
	let { enabledLanguages: i } = Ce(Yr), { control: a, handleSubmit: o, formState: { isValid: s, isDirty: c, touchedFields: l }, reset: u, getValues: d } = Ve({
		defaultValues: Um({ helpCenter: e }),
		resolver: Wi(hd),
		reValidateMode: "onChange",
		mode: "all"
	}), { errorNotify: f, successNotify: p } = Es(), [m, { loading: h }] = Gm({
		onCompleted: (e) => {
			p({
				title: "Success",
				text: "Help center has been updated."
			}), u(e), He.knowledgeHelpCenterUpdated({ helpCenterId: t });
		},
		onError: (e) => {
			throw f({
				title: "Unable to update Help Center",
				text: "Please try again. If this issue persists contact customer support."
			}), e;
		}
	});
	function g(e) {
		m({
			formValues: e,
			helpCenterId: t,
			touchedFields: l
		});
	}
	let _ = h || !c, v = d("helpCenterTitles");
	return /* @__PURE__ */ I(F, { children: /* @__PURE__ */ I("form", {
		onSubmit: o(g),
		children: /* @__PURE__ */ L(T, { children: [
			/* @__PURE__ */ I(fu, {
				label: "Customization",
				loading: h,
				isValid: s,
				disabled: _
			}),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(Fm, { helpCenterId: t }) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(Lm, { helpCenterId: t }) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I($o, {
				control: a,
				name: "companyUrl",
				label: "Company URL",
				description: "A URL must be a valid format and start with 'https://' or 'http://'",
				placeholder: "https://yoursite.com"
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ku, {
				legend: "Help center title",
				children: /* @__PURE__ */ I(T, { children: v.map(({ languageId: e }, t) => /* @__PURE__ */ I(ns, {
					control: a,
					fieldName: `helpCenterTitles.${t}.title`,
					label: ld({
						languageId: e,
						languages: i
					}).description
				}, e)) })
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ku, {
				legend: "Help center tagline",
				children: /* @__PURE__ */ I(T, { children: v.map(({ languageId: e }, t) => /* @__PURE__ */ I(ns, {
					control: a,
					fieldName: `helpCenterTaglines.${t}.tagline`,
					label: ld({
						languageId: e,
						languages: i
					}).description
				}, e)) })
			}) }),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Website background color",
					name: "colors.websiteBackground"
				})
			}),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Page background color",
					name: "colors.pageBackground"
				})
			}),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Text color",
					name: "colors.text"
				})
			}),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Link color",
					name: "colors.link"
				})
			}),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Accent color",
					name: "colors.accent"
				})
			}),
			/* @__PURE__ */ I(w, {
				span: 3,
				children: /* @__PURE__ */ I(Zo, {
					control: a,
					label: "Accent text color",
					name: "colors.accentText"
				})
			})
		] })
	}) });
}
function Jm({ initialLogo: e, initialFavicon: t }) {
	N(() => {
		e && (Am.companyLogo = {
			filename: e.filename,
			url: e.availableAt,
			width: e.size,
			height: 0
		}), t && (Am.favicon = {
			filename: t.filename,
			url: t.availableAt,
			width: t.size,
			height: 0
		});
	}, []);
}
var Ym = R((() => {
	Gi(), gs(), Au(), Xr(), ud(), Ds(), pu(), gd(), Im(), Rm(), Pm(), Wm(), Km();
}));
//#endregion
//#region src/components/customizationForm/customizationFormLoadingPlaceholder.tsx
function Xm() {
	let e = () => /* @__PURE__ */ I(w, {
		span: 3,
		children: /* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
			noLabel: !0,
			children: [/* @__PURE__ */ I(k, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ I(k, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) })
	});
	return /* @__PURE__ */ I("form", { children: /* @__PURE__ */ L(T, { children: [
		/* @__PURE__ */ I(uu, {}),
		/* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
			noLabel: !0,
			children: [/* @__PURE__ */ I(k, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ I(k, {
				height: "80px",
				width: "160px",
				animation: "wave"
			})]
		}) }),
		/* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
			noLabel: !0,
			children: [/* @__PURE__ */ I(k, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ I(k, {
				height: "80px",
				width: "160px",
				animation: "wave"
			})]
		}) }),
		Array.from([
			,
			,
			,
		]).map((e, t) => /* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
			noLabel: !0,
			children: [/* @__PURE__ */ I(k, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ I(k, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) }, t)),
		Array.from([
			,
			,
			,
			,
			,
			,
		]).map((t, n) => /* @__PURE__ */ I(e, {}, n))
	] }) });
}
var Zm = R((() => {
	du();
}));
//#endregion
//#region src/components/customizationForm/index.tsx
function Qm({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Wt({ variables: { id: e } });
	return !t && n && n.helpCenter ? /* @__PURE__ */ I(qm, { helpCenter: n.helpCenter }) : r ? /* @__PURE__ */ I(Ii, { errorMessage: r.message }) : /* @__PURE__ */ I(Xm, {});
}
var $m = R((() => {
	V(), Li(), Ym(), Zm();
}));
//#endregion
//#region src/hooks/useHelpCenterUpdateSettingsMutation.ts
function eh({ helpCenterId: e, subdomainChanged: t, onCompleted: n, onError: r }) {
	let [i, a] = Yt({
		onCompleted: n,
		onError: r
	});
	function o(n) {
		let { enabledLanguages: r, disabledLanguages: a } = th({ settingsFormLanguages: n.languages });
		i({ variables: {
			id: e,
			active: n.active,
			collectionId: n.collectionId,
			subdomain: t ? n.subdomain : void 0,
			name: n.name,
			enableLanguages: r,
			disableLanguages: a,
			isHelpCenterIndexable: n.isHelpCenterIndexable,
			defaultLanguage: n.defaultLanguage.at(0)?.id
		} });
	}
	return [o, a];
}
function th({ settingsFormLanguages: e }) {
	let { enabled: t, disabled: n } = e.reduce((e, t) => (t.enabled ? e.enabled.push(t.languageId) : e.disabled.push(t.languageId), e), {
		enabled: [],
		disabled: []
	});
	return {
		enabledLanguages: t.length ? t : void 0,
		disabledLanguages: n.length ? n : void 0
	};
}
var nh = R((() => {
	V();
}));
//#endregion
//#region src/components/settingsForm/defaultLanguageSelect.tsx
function rh({ control: e, watch: t, availableLanguages: n }) {
	let r = t("languages");
	return /* @__PURE__ */ I(is, {
		control: e,
		name: "defaultLanguage",
		label: "Default language",
		itemsLoading: !1,
		placeholders: {
			loading: "Loading available languages...",
			empty: "Select default language"
		},
		equalityFn: (e, t) => e.id === t.id,
		listItems: Te(() => r.filter((e) => e.enabled).map((e) => {
			let t = n.find((t) => t.languageId === e.languageId)?.description || "";
			return {
				id: e.languageId,
				name: t
			};
		}), [n, r]),
		multiple: !1,
		required: !0
	});
}
var ih = R((() => {
	gs();
})), ah, oh, sh = R((() => {
	ah = "_table_tz287_1", oh = { table: ah };
}));
//#endregion
//#region src/components/settingsForm/languagesPanel.tsx
function ch(e) {
	return /* @__PURE__ */ I(S, {
		label: "Languages",
		required: !0,
		children: /* @__PURE__ */ L(A, {
			className: oh.table,
			children: [/* @__PURE__ */ I(A.Thead, { children: /* @__PURE__ */ L(A.Tr, { children: [/* @__PURE__ */ I(A.Th, { children: "Language" }), /* @__PURE__ */ I(A.Th, {})] }) }), /* @__PURE__ */ I(A.Tbody, { children: /* @__PURE__ */ I(lh, { ...e }) })]
		})
	});
}
function lh({ watch: e, setValue: t, availableLanguages: n }) {
	let r = e("languages"), i = r.map((e) => ({
		languageId: e.languageId,
		enabled: e.enabled,
		description: n.find((t) => t.languageId === e.languageId)?.description || "",
		nativeDescription: n.find((t) => t.languageId === e.languageId)?.nativeDescription || ""
	})), a = e("defaultLanguage"), o = ({ index: e }) => {
		t(`languages.${e}.enabled`, !r[e].enabled, {
			shouldDirty: !0,
			shouldTouch: !0
		});
	};
	return /* @__PURE__ */ I(F, { children: i.map(({ languageId: e, enabled: t }, n) => {
		let r = e === a[0]?.id, s = ld({
			languageId: e,
			languages: i
		}).description;
		return /* @__PURE__ */ L(A.Tr, { children: [/* @__PURE__ */ I(A.Td, { children: r ? `${s} (Default)` : s }), /* @__PURE__ */ I(A.Td, { children: /* @__PURE__ */ I(le, {
			name: e,
			value: t?.toString(),
			checked: t,
			disabled: r,
			onChange: () => o({ index: n })
		}) })] }, e);
	}) });
}
var uh = R((() => {
	ud(), sh();
}));
//#endregion
//#region src/components/settingsForm/settingsFormSchema.ts
function dh({ helpCenterEnabledLanguages: e, enabledLanguages: t }) {
	return t.map((t) => ({
		languageId: t.languageId,
		enabled: e.some((e) => e.languageId === t.languageId)
	}));
}
var fh, ph, mh, hh, gh = R((() => {
	V(), gl(), yl(), fh = ul({
		languageId: pl($t),
		enabled: cl()
	}), ph = ul({
		active: cl(),
		name: Z().min(1, { message: "A name must be provided." }),
		collectionId: Z().uuid({ message: "A collection must be chosen" }),
		isHelpCenterIndexable: cl(),
		defaultLanguage: ll(ul({
			id: pl($t),
			name: Z()
		})),
		languages: ll(fh)
	}), mh = ph.merge(vl), hh = ({ helpCenter: e, enabledLanguages: t }) => ({
		active: e.isActive,
		name: e.name,
		collectionId: e.collection?.id || "",
		subdomain: e.subdomain,
		isHelpCenterIndexable: e.isHelpCenterIndexable,
		subdomainValidations: [],
		languages: dh({
			helpCenterEnabledLanguages: e.enabledLanguages || [],
			enabledLanguages: t
		}),
		defaultLanguage: [{
			id: e.defaultLanguage.languageId,
			name: e.defaultLanguage.description
		}]
	});
}));
//#endregion
//#region src/components/settingsForm/index.tsx
function _h({ helpCenterId: e }) {
	let { loading: t, data: n, error: r } = Wt({ variables: { id: e } });
	return !t && n && n.helpCenter ? /* @__PURE__ */ I(yh, { helpCenter: n.helpCenter }) : r ? /* @__PURE__ */ I(Ii, { errorMessage: r.message }) : /* @__PURE__ */ I(vh, {});
}
function vh() {
	return /* @__PURE__ */ I("form", { children: /* @__PURE__ */ L(T, { children: [
		/* @__PURE__ */ I(uu, {}),
		/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(S, {
			noLabel: !0,
			children: /* @__PURE__ */ I(k, {
				animation: "wave",
				width: "100%",
				height: "72px"
			})
		}) }),
		Array.from([
			,
			,
			,
		]).map((e, t) => /* @__PURE__ */ I(w, { children: /* @__PURE__ */ L(S, {
			noLabel: !0,
			children: [/* @__PURE__ */ I(k, {
				height: "16px",
				width: "64px",
				animation: "wave",
				margin: "0 0 8px"
			}), /* @__PURE__ */ I(k, {
				height: "40px",
				width: "100%",
				animation: "wave"
			})]
		}) }, t))
	] }) });
}
function yh({ helpCenter: e }) {
	let { successNotify: t, errorNotify: n } = Es(), { enabledLanguages: r, availableLanguages: i } = Ce(Yr), a = hh({
		helpCenter: e,
		enabledLanguages: r
	}), { reset: o, control: s, watch: c, formState: { defaultValues: l, errors: u, dirtyFields: d, isDirty: f, isValid: m }, setValue: h, handleSubmit: g } = Ve({
		resolver: Wi(mh),
		defaultValues: a,
		reValidateMode: "onChange",
		mode: "all"
	}), _ = d.subdomain, [v, ee] = eh({
		helpCenterId: e.id,
		subdomainChanged: _,
		onCompleted: (e) => {
			let n = e.helpCenterUpdate;
			if (!n) return;
			t({
				title: "Help Center Updated",
				text: `${n.name} has been updated.`
			}), He.knowledgeHelpCenterUpdated({ helpCenterId: n.id });
			let i = hh({
				helpCenter: n,
				enabledLanguages: r
			});
			o(i);
		},
		onError: (e) => {
			throw n({
				title: "Unable to update Help Center",
				text: e.message || "Please try again. If this issue persists contact customer support."
			}), e;
		}
	}), y = c("subdomain"), b = ws({
		initialSubdomain: l?.subdomain || "",
		subdomain: y,
		subdomainErrorMessage: u.subdomain?.message
	}), x = ee.loading;
	return /* @__PURE__ */ I("form", {
		onSubmit: g(v),
		children: /* @__PURE__ */ L(T, { children: [
			/* @__PURE__ */ I(fu, {
				label: "Settings",
				loading: x,
				isValid: m,
				disabled: !f
			}),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: s,
				name: "active",
				heading: "Enable Help Center",
				subHeading: "Make your Help Center publicly available",
				dark: !0
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I($o, {
				control: s,
				name: "name",
				label: "Name",
				required: !0
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(p, { children: /* @__PURE__ */ I(Le, {
				name: "collectionId",
				control: s,
				render: ({ field: e, fieldState: t }) => /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(bs, {
					collectionId: e.value,
					setCollectionId: e.onChange,
					required: !0
				}), t.error && /* @__PURE__ */ I(j.Paragraph, {
					color: "var(--dixa-typography-color-error)	",
					children: t.error.message
				})] })
			}) }) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(bl, {
				control: s,
				subdomainAvailability: b,
				subdomainPath: "subdomain",
				subdomainValidationsPath: "subdomainValidations"
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ms, {
				control: s,
				name: "isHelpCenterIndexable",
				heading: "Allow search engines to index Help Center",
				subHeading: "Manage whether your public Help Center content appears in search engine results."
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(rh, {
				control: s,
				watch: c,
				availableLanguages: i
			}) }),
			/* @__PURE__ */ I(w, { children: /* @__PURE__ */ I(ch, {
				setValue: h,
				watch: c,
				availableLanguages: i
			}) })
		] })
	});
}
var bh = R((() => {
	Gi(), gs(), xs(), Xr(), V(), Ts(), Ds(), nh(), du(), Li(), pu(), Sl(), ih(), uh(), gh();
})), xh, Sh, Ch, wh, Th, Eh, Dh, Oh, kh, Ah = R((() => {
	xh = "_tabContentWrapper_1315b_1", Sh = "_tabContentContainer_1315b_5", Ch = "_tabContent_1315b_1", wh = "_inactive_1315b_14", Th = "_preview_1315b_19", Eh = "_customHostname_1315b_27", Dh = "_tab_1315b_1", Oh = "_tabsWrapper_1315b_49", kh = {
		tabContentWrapper: xh,
		tabContentContainer: Sh,
		tabContent: Ch,
		inactive: wh,
		preview: Th,
		customHostname: Eh,
		tab: Dh,
		tabsWrapper: Oh
	};
})), jh = /* @__PURE__ */ Ye({
	BackButton: () => Fh,
	default: () => Nh
});
function Mh({ tabId: e, helpCenterId: t, isActive: n }) {
	let r = pe(kh.tabContent, {
		[kh.inactive]: !n,
		[kh.customHostname]: e === Lh.CustomHostname
	});
	if (!t) return null;
	let i;
	switch (e) {
		case Lh.Settings:
			i = /* @__PURE__ */ I(_h, { helpCenterId: t });
			break;
		case Lh.Customization:
			i = /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(Qm, { helpCenterId: t }), /* @__PURE__ */ I("div", { className: kh.preview })] });
			break;
		case Lh.Advanced:
			i = /* @__PURE__ */ L(F, { children: [/* @__PURE__ */ I(yu, { helpCenterId: t }), /* @__PURE__ */ I("div", { className: kh.preview })] });
			break;
		case Lh.CustomHostname:
			i = /* @__PURE__ */ I(sd, {
				helpCenterId: t,
				isActive: n
			});
			break;
		default: i = null;
	}
	return /* @__PURE__ */ I(p, {
		className: r,
		children: i
	});
}
function Nh() {
	let { helpCenterId: e } = Ne(), [t, n] = De(Lh.Settings);
	return /* @__PURE__ */ I(At, { children: /* @__PURE__ */ I(At.Body, { children: /* @__PURE__ */ L(C, {
		flexDirection: "column",
		width: "100%",
		className: kh.tabContentWrapper,
		children: [
			/* @__PURE__ */ I(At.Head, {
				slotLeft: /* @__PURE__ */ I(At.HeadBackLink, {
					backText: "Back",
					backProps: { to: Pi.helpCentersPath() }
				}),
				slotCenter: /* @__PURE__ */ I(At.HeadTitle, { title: "Dixa Help Center" }),
				slotRight: /* @__PURE__ */ I(Ih, { helpCenterId: e })
			}),
			/* @__PURE__ */ I(ue, {
				tabs: Rh,
				onChange: n,
				activeId: t,
				tabClassName: kh.tab,
				className: kh.tabsWrapper
			}),
			/* @__PURE__ */ I(Ph, { children: Rh.map((n) => /* @__PURE__ */ I(Mh, {
				tabId: n.id,
				helpCenterId: e,
				isActive: t === n.id
			}, n.id)) })
		]
	}) }) });
}
function Ph({ children: e }) {
	return /* @__PURE__ */ I(p, {
		className: kh.tabContentContainer,
		children: e
	});
}
function Fh() {
	return /* @__PURE__ */ I(Oe, {
		to: Pi.helpCentersPath(),
		children: "Back"
	});
}
function Ih({ helpCenterId: e = "" }) {
	if (!e) throw Error("No helpCenterId provided");
	let { loading: t, data: n } = Wt({ variables: { id: e } });
	return n?.helpCenter?.isActive ? /* @__PURE__ */ I("a", {
		href: n?.helpCenter?.hostname ? `https://${n.helpCenter.hostname}/en` : "",
		target: "_blank",
		rel: "noreferrer",
		children: /* @__PURE__ */ I(m, {
			variant: "secondary",
			disabled: t,
			icon: "external-link",
			children: "Open"
		})
	}) : /* @__PURE__ */ I(fe, {
		content: "This help center is not currently active",
		children: /* @__PURE__ */ I(m, {
			variant: "secondary",
			disabled: !0,
			icon: "external-link",
			children: "Open"
		})
	});
}
var Lh, Rh, zh = R((() => {
	V(), jt(), Fi(), wu(), cd(), $m(), bh(), Ah(), Lh = {
		CustomHostname: "customHostname",
		Settings: "settings",
		Customization: "customization",
		Advanced: "advanced"
	}, Rh = [
		{
			id: Lh.Settings,
			label: "Settings"
		},
		{
			id: Lh.Customization,
			label: "Customization"
		},
		{
			id: Lh.Advanced,
			label: "Advanced"
		},
		{
			id: Lh.CustomHostname,
			label: "Custom hostname"
		}
	];
}));
si(), pi(), qr();
var Bh = xe(() => Promise.resolve().then(() => (Ql(), Kl))), Vh = xe(() => Promise.resolve().then(() => (zh(), jh))), Hh = [{
	path: "/",
	element: /* @__PURE__ */ I(Bh, {})
}, {
	path: "/:helpCenterId",
	element: /* @__PURE__ */ I(Vh, {})
}];
function Uh() {
	return Pe(Hh);
}
var Wh = ({ notify: e }) => {
	let t = ct();
	return /* @__PURE__ */ I(ci, {
		fallback: /* @__PURE__ */ I(ui, {}),
		children: /* @__PURE__ */ I(fi.Provider, {
			value: e,
			children: /* @__PURE__ */ I(n, {
				client: t,
				children: /* @__PURE__ */ I(_e, {
					fallback: /* @__PURE__ */ I(di, {}),
					children: /* @__PURE__ */ I(Er, {
						adapter: mi,
						children: /* @__PURE__ */ I(Zr, { children: /* @__PURE__ */ I(Qr, { children: /* @__PURE__ */ I(Uh, {}) }) })
					})
				})
			})
		})
	});
};
//#endregion
export { Wh as default, Hh as helpCenterRoutesData };

//# sourceMappingURL=index.js.map